/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s, o, r, n, a, l, c, h) {
    "use strict";
    function d(t) {
        var e = Object.create(null);
        return (
            t &&
                Object.keys(t).forEach(function (i) {
                    if ("default" !== i) {
                        var s = Object.getOwnPropertyDescriptor(t, i);
                        Object.defineProperty(
                            e,
                            i,
                            s.get
                                ? s
                                : {
                                      enumerable: !0,
                                      get: function () {
                                          return t[i];
                                      },
                                  }
                        );
                    }
                }),
            (e.default = t),
            Object.freeze(e)
        );
    }
    var u = d(o);
    function p(t) {
        const e = t.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        e.forEach((t) => {
            i.querySelector(`[id="${t.id}"]`) || i.appendChild(t);
        });
    }
    function m(t) {
        t.querySelectorAll(".float__wrapper").forEach((t) => {
            const e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e &&
                i.addEventListener("keyup", (t) => {
                    "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
                }),
                i && i.value && i.value.length && e.classList.add("label--float");
        });
    }
    function g(t) {
        t.querySelectorAll(".errors").forEach((t) => {
            t.setAttribute("tabindex", "0"), t.setAttribute("aria-live", "assertive"), t.setAttribute("role", "alert");
        });
    }
    function y(t) {
        document.addEventListener("theme:resize", f.bind(null, t)), f(t);
    }
    function f(t) {
        window.innerWidth > window.theme.sizes.small &&
            setTimeout(() => {
                t.querySelectorAll(".lazypostload-desktop").forEach((t) => {
                    t.style.visibility = "visible";
                });
            }, 2e3);
    }
    function w() {
        const t = {};
        return (
            (t.windowHeight = window.innerHeight),
            (t.announcementHeight = S("#shopify-section-announcement")),
            (t.footerHeight = S('[data-section-type*="footer"]')),
            (t.menuHeight = S("[data-header-height]")),
            (t.headerHeight = t.menuHeight + t.announcementHeight),
            (t.logoHeight = (function () {
                const t = S("[data-footer-logo]");
                return t > 0 ? t + 20 : 0;
            })()),
            (t.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? t.menuHeight : 0),
            (t.backfillHeight = S("[data-header-backfill]")),
            t
        );
    }
    function b() {
        document.addEventListener("theme:resize", v),
            (function () {
                const { windowHeight: t, announcementHeight: e, headerHeight: i, logoHeight: s, menuHeight: o, footerHeight: r, stickyHeader: n, backfillHeight: a } = w();
                document.documentElement.style.setProperty("--scrollbar-width", `${E()}px`),
                    document.documentElement.style.setProperty("--footer-logo", `${s}px`),
                    document.documentElement.style.setProperty("--full-screen", `${t}px`),
                    document.documentElement.style.setProperty("--three-quarters", 0.75 * t + "px"),
                    document.documentElement.style.setProperty("--two-thirds", 0.66 * t + "px"),
                    document.documentElement.style.setProperty("--one-half", 0.5 * t + "px"),
                    document.documentElement.style.setProperty("--one-third", 0.33 * t + "px"),
                    document.documentElement.style.setProperty("--one-fifth", 0.2 * t + "px"),
                    document.documentElement.style.setProperty("--menu-height", `${o}px`),
                    document.documentElement.style.setProperty("--announcement-height", `${e}px`),
                    document.documentElement.style.setProperty("--header-height", `${i}px`),
                    document.documentElement.style.setProperty("--footer-height", `${r}px`),
                    document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"),
                    document.documentElement.style.setProperty("--menu-height-sticky", `${n}px`);
                let l = Math.abs(a - o) > 1 ? `${o}px` : "auto";
                document.documentElement.style.setProperty("--menu-backfill-height", l);
            })();
    }
    function v() {
        const { windowHeight: t, announcementHeight: e, headerHeight: i, logoHeight: s, menuHeight: o, footerHeight: r, stickyHeader: n, backfillHeight: a } = w();
        document.documentElement.style.setProperty("--scrollbar-width", `${E()}px`),
            document.documentElement.style.setProperty("--full-screen", `${t}px`),
            document.documentElement.style.setProperty("--menu-height", `${o}px`),
            document.documentElement.style.setProperty("--announcement-height", `${e}px`),
            document.documentElement.style.setProperty("--header-height", `${i}px`),
            document.documentElement.style.setProperty("--footer-height", `${r}px`),
            document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"),
            document.documentElement.style.setProperty("--menu-height-sticky", `${n}px`);
        let l = Math.abs(a - o) > 1 ? `${o}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", l);
    }
    function S(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function E() {
        const t = document.createElement("div");
        (t.style.visibility = "hidden"), (t.style.overflow = "scroll"), (t.style.msOverflowStyle = "scrollbar"), document.body.appendChild(t);
        const e = document.createElement("div");
        t.appendChild(e);
        const i = t.offsetWidth - e.offsetWidth;
        return t.parentNode.removeChild(t), i;
    }
    function L(t, e) {
        let i = 64,
            s = 0;
        e.forEach((t) => {
            if (t.offsetHeight > s) {
                const e = parseInt(window.getComputedStyle(t).marginTop) + parseInt(window.getComputedStyle(t).marginBottom);
                e > i && (i = e), (s = t.offsetHeight);
            }
        });
        const o = t.querySelectorAll("[data-overflow-background]");
        [t, ...o].forEach((t) => {
            t.style.setProperty("min-height", `calc(${s + i}px + var(--menu-height))`);
        });
    }
    function T(t) {
        let e = document.querySelector("[data-footer-logo]") ? document.querySelector("[data-footer-logo]").clientHeight + 20 : 0;
        const i = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]"),
            s = i ? i.getAttribute("data-section-id") : null;
        if ((((null !== s && t.getAttribute("data-section-id") !== s) || !i) && (e = 0), window.innerWidth < window.theme.sizes.medium)) {
            return void t.querySelectorAll("[data-overflow-frame]").forEach((t) => {
                const e = t.querySelectorAll("[data-overflow-content]");
                L(t, e);
            });
        }
        const o = document.createElement("div");
        t.prepend(o), (o.style.display = "none"), (o.style.width = getComputedStyle(t).getPropertyValue("--outer"));
        const r = 2 * parseInt(getComputedStyle(o).getPropertyValue("width"));
        t.firstChild.remove();
        let n = 0;
        const a = t.querySelectorAll("[data-overflow-frame]");
        t.querySelectorAll("[data-overflow-content]").forEach((t) => {
            t.offsetHeight > n && (n = t.offsetHeight);
        });
        [...a, ...t.querySelectorAll("[data-overflow-background]")].forEach((t) => {
            t.style.setProperty("min-height", `${n + r}px`);
        }),
            t.style.setProperty("min-height", `${n + r + 2 + e}px`);
    }
    function k(e) {
        const i = e.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((t) => {
                const e = t.querySelectorAll(".js-overflow-content");
                L(t, e),
                    document.addEventListener("theme:resize", () => {
                        L(t, e);
                    });
            });
            const s = e.querySelectorAll("[data-slideshow-wrapper]");
            s.length &&
                s.forEach((e) => {
                    const i = t.data(e);
                    void 0 !== i && i.reloadCells();
                });
        }
        const s = e.querySelectorAll("[data-overflow-wrapper]");
        s &&
            s.forEach((t) => {
                T(t),
                    document.addEventListener("theme:resize", () => {
                        T(t);
                    });
            });
    }
    function A(t, e) {
        let i;
        return (...s) => {
            clearTimeout(i), (i = setTimeout(() => t.apply(this, s), e));
        };
    }
    (window.theme = window.theme || {}), (window.theme.sizes = { small: 480, medium: 768, large: 1100, widescreen: 1400 }), (window.theme.keyboardKeys = { TAB: 9, ENTER: 13, ESCAPE: 27, SPACE: 32, LEFTARROW: 37, RIGHTARROW: 39 });
    let q = window.innerWidth,
        C = window.innerHeight;
    let P = window.pageYOffset,
        x = null,
        $ = null,
        H = null,
        _ = null,
        I = 0;
    function M(t) {
        let i = t.target;
        t.detail && t.detail instanceof Element && (i = t.detail), e.disableBodyScroll(i), document.documentElement.setAttribute("data-scroll-locked", "");
    }
    function D() {
        if (
            ((I = setTimeout(() => {
                document.body.removeAttribute("data-drawer-closing");
            }, 20)),
            document.body.hasAttribute("data-drawer-closing"))
        )
            return document.body.removeAttribute("data-drawer-closing"), void (I && clearTimeout(I));
        document.body.setAttribute("data-drawer-closing", ""), document.documentElement.removeAttribute("data-scroll-locked"), e.clearAllBodyScrollLocks();
    }
    window.addEventListener(
        "resize",
        A(function () {
            document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
                q !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (q = window.innerWidth)),
                C !== window.innerHeight && (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })), (C = window.innerHeight));
        }, 50)
    ),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.pageYOffset;
                                t > P ? (($ = !0), (x = !1)) : t < P ? (($ = !1), (x = !0)) : ((x = null), ($ = null)),
                                    (P = t),
                                    document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: x, down: $, position: t }, bubbles: !1 })),
                                    x && !H && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
                                    $ && !_ && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
                                    (_ = $),
                                    (H = x);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", M),
                window.addEventListener("theme:scroll:unlock", D);
        })(),
        window.addEventListener("load", () => {
            b(), m(document), g(document), p(document), k(document), y(document), window.theme.settings.animate_scroll && i.refresh();
        }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            m(e), g(e), p(e), k(e), y(e), window.theme.settings.animate_scroll && i.refresh();
        }),
        document.addEventListener("shopify:section:reorder", () => {
            document.dispatchEvent(new CustomEvent("theme:header:check", { bubbles: !1 }));
        });
    const W = (t, e = !1, i = "block") => {
        t && (e ? t.style.removeProperty("display") : (t.style.display = i));
    };
    function B(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    B.prototype = Error.prototype;
    const F = "data-scrollbar-slider",
        O = "[data-scrollbar-arrow-prev]",
        N = "[data-scrollbar-arrow-next]",
        z = "is-hidden",
        R = 200;
    let j = class {
        init() {
            this.arrowNext && this.arrowPrev && (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(), this.events());
        }
        resize() {
            document.addEventListener("theme:resize", () => {
                window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow();
            });
        }
        events() {
            this.arrowNext.addEventListener("click", (t) => {
                t.preventDefault(), this.goToNext();
            }),
                this.arrowPrev.addEventListener("click", (t) => {
                    t.preventDefault(), this.goToPrev();
                }),
                this.scrollbar.addEventListener("scroll", () => {
                    this.togglePrevArrow(), this.toggleNextArrow();
                });
        }
        goToNext() {
            const t = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(z), this.toggleNextArrow();
        }
        goToPrev() {
            const t = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
            this.move(t), this.arrowNext.classList.remove(z), this.togglePrevArrow();
        }
        toggleNextArrow() {
            setTimeout(() => {
                window.isRTL
                    ? this.arrowNext.classList.toggle(z, 0 === this.scrollbar.scrollLeft)
                    : this.arrowNext.classList.toggle(z, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
            }, R);
        }
        togglePrevArrow() {
            setTimeout(() => {
                window.isRTL
                    ? this.arrowPrev.classList.toggle(z, Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >= this.scrollbar.scrollWidth)
                    : this.arrowPrev.classList.toggle(z, this.scrollbar.scrollLeft <= 0);
            }, R);
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t) => {
                t.addEventListener("click", (e) => {
                    ("a" === e.target.tagName.toLowerCase() || (e.currentTarget && "a" === e.currentTarget.tagName.toLowerCase()) || (e.currentTarget && e.currentTarget.querySelector("a"))) && e.preventDefault(),
                        this.move(t.offsetLeft - t.clientWidth);
                });
            });
        }
        move(t) {
            this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
        }
        constructor(t) {
            (this.scrollbar = t),
                (this.arrowNext = this.scrollbar.parentNode.querySelector(N)),
                (this.arrowPrev = this.scrollbar.parentNode.querySelector(O)),
                this.init(),
                this.resize(),
                this.scrollbar.hasAttribute(F) && this.scrollToVisibleElement();
        }
    };
    const V = "[data-sibling-inner]";
    let U = class {
        init() {
            this.siblings.forEach((t) => {
                new j(t);
            });
        }
        constructor(t) {
            (this.siblings = t.querySelectorAll(V)), this.init();
        }
    };
    const J = {
            onLoad() {
                new U(this.container);
            },
        },
        K = { expires: 7, path: "/", domain: window.location.hostname };
    let Y = class {
        write(t) {
            document.cookie = `${this.options.name}=${t}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        read() {
            let t = [];
            const e = document.cookie.split("; ").find((t) => t.startsWith(this.options.name));
            if (-1 !== document.cookie.indexOf("; ") && e) {
                const e = document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.options.name))
                    .split("=")[1];
                null !== e && (t = e.split(","));
            }
            return t;
        }
        destroy() {
            document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        remove(t) {
            const e = this.read(),
                i = e.indexOf(t);
            -1 !== i && (e.splice(i, 1), this.write(e));
        }
        constructor(t = {}) {
            this.options = { ...K, ...t };
        }
    };
    const G = 4,
        X = 10,
        Q = "[data-recently-viewed-products]",
        Z = "data-limit",
        tt = "[data-recent-link-tab]",
        et = "[data-recent-wrapper]",
        it = "[data-recently-viewed-tab]",
        st = "[data-tabs-holder-scroll]",
        ot = "[data-api-content]",
        rt = "data-minimum",
        nt = "hide",
        at = "section-without-title--skip",
        lt = { expires: 90, name: "shopify_recently_viewed" },
        ct = [],
        ht = [];
    const dt = {
        onLoad() {
            ct[this.id] = new (class {
                renderProducts() {
                    const t = this.cookie.read(),
                        e = [];
                    let i = 0;
                    if (t.length > 0) {
                        for (let s = 0; s < t.length; s++) {
                            const o = t[s];
                            if (ht.includes(o)) continue;
                            const r = `${window.theme.routes.root_url}products/${o}?section_id=api-product-grid-item`;
                            if ((e.push(r), i++, i === this.howManyToShow || i === t.length - 1)) break;
                        }
                        if (e.length > 0 && e.length >= this.minimum) {
                            this.container.classList.remove(nt), this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.remove(nt), this.container.classList.add(at));
                            const t = e.map((t) => fetch(t, { mode: "no-cors" }).then(this.handleErrors)),
                                i = [];
                            Promise.allSettled(t)
                                .then((t) =>
                                    Promise.all(
                                        t.map(async (t) => {
                                            "fulfilled" === t.status && i.push(await t.value.text());
                                        })
                                    )
                                )
                                .then(() => {
                                    i.forEach((t) => {
                                        const e = document.createElement("div"),
                                            i = document.createElement("div");
                                        (e.innerHTML = t),
                                            i.classList.add("product-grid-slide"),
                                            i.setAttribute("data-carousel-slide", null),
                                            i.setAttribute("data-item", null),
                                            (i.innerHTML = e.querySelector(ot).innerHTML),
                                            this.wrapper.appendChild(i);
                                    }),
                                        new U(this.container);
                                })
                                .then(() => {
                                    W(this.wrapper, !0), this.container.dispatchEvent(new CustomEvent("theme:recent-products:added", { bubbles: !0 }));
                                });
                        } else if (this.recentViewedTab) {
                            const t = Array.prototype.filter.call(this.recentViewedTab.parentNode.children, (t) => t !== this.recentViewedTab).length > 1;
                            this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.add(nt), this.container.classList.remove(at)), t || this.container.classList.add(nt);
                        } else this.container.classList.add(nt);
                    }
                }
                handleErrors(t) {
                    return t.ok
                        ? t
                        : t.text().then(function (e) {
                              throw new B({ status: t.statusText, headers: t.headers, text: e });
                          });
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.cookie = new Y(lt)),
                        (this.wrapper = this.container.querySelector(Q)),
                        null !== this.wrapper &&
                            ((this.howManyToShow = parseInt(this.container.querySelector(et).getAttribute(Z)) || G),
                            (this.minimum = parseInt(this.container.querySelector(et).getAttribute(rt))),
                            (this.recentViewedTab = this.container.querySelector(it)),
                            (this.recentViewedLink = this.container.querySelector(tt)),
                            (this.tabsHolderScroll = this.container.querySelector(st)),
                            this.renderProducts());
                }
            })(this);
        },
    };
    function ut(t, e) {
        if (null === e) return t;
        if ((null == t && (t = window.theme.assets.noImage), "master" === e)) return pt(t);
        const i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
        if (i) {
            const s = t.split(i[0]),
                o = i[0];
            return pt(`${s[0]}_${e}${o}`);
        }
        return null;
    }
    function pt(t) {
        return t.replace(/http(s)?:/, "");
    }
    function mt() {
        this.entries = [];
    }
    function gt(t, e) {
        yt(t);
        var i = (function (t, e) {
            yt(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var i = [];
            return (
                e.forEach(function (e) {
                    for (var s = 0; s < t.options.length; s++) {
                        if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                            i[s] = e.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(t, e);
        return (function (t, e) {
            return (
                yt(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e),
                t.variants.filter(function (t) {
                    return e.every(function (e, i) {
                        return t.options[i] === e;
                    });
                })[0] || null
            );
        })(t, i);
    }
    function yt(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    (mt.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (mt.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var ft = '[name="id"]',
        wt = '[name="selling_plan"]',
        bt = '[name^="options"]',
        vt = '[name="quantity"]',
        St = '[name^="properties"]';
    function Et(t) {
        const e = `${window.theme.routes.root_url}products/${t}.js`;
        return window
            .fetch(e)
            .then((t) => t.json())
            .catch((t) => {
                console.error(t);
            });
    }
    const Lt = {};
    function Tt(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return Lt[t.url]
                ? Lt[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        r = document.createElement("script");
                                    (r.src = t),
                                        (r.onload = r.onreadystatechange = function () {
                                            o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? i() : ((o = !0), e());
                                        }),
                                        s.appendChild(r);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (Lt[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return Lt[t.json]
                ? Promise.resolve(Lt[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((Lt[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Lt[e]
                ? Lt[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (Lt[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    const kt = "[data-swapper-wrapper]",
        At = "[data-swapper-target]",
        qt = "data-swapper-hover";
    let Ct = {};
    function Pt(t) {
        Ct[t.id] = [];
        t.querySelectorAll(kt).forEach((e) => {
            Ct[t.id].push(
                new (class {
                    init() {
                        this.hovers.forEach((t) => {
                            t.addEventListener(
                                "mouseenter",
                                function () {
                                    const e = t.getAttribute(qt);
                                    this.target.innerHTML = `${e}`;
                                }.bind(this)
                            );
                        }),
                            this.hovers.forEach((t) => {
                                t.addEventListener(
                                    "mouseleave",
                                    function () {
                                        this.target.innerHTML = this.deafaultContent;
                                    }.bind(this)
                                );
                            }),
                            this.hovers.forEach((t) => {
                                t.addEventListener(
                                    "click",
                                    function () {
                                        const e = t.getAttribute(qt);
                                        this.deafaultContent = `${e}`;
                                    }.bind(this)
                                );
                            });
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.target = this.container.querySelector(At)),
                            (this.hovers = this.container.querySelectorAll(`[${qt}]`)),
                            this.target && this.hovers.length && ((this.deafaultContent = this.target.innerHTML), this.init());
                    }
                })(e)
            );
        });
    }
    const xt = {
            onLoad() {
                Pt(this.container);
            },
        },
        $t = { color: "ash" },
        Ht = "data-swatch",
        _t = "[data-grid-item]",
        It = "[data-grid-image]",
        Mt = "data-grid-image-default",
        Dt = "data-grid-image-target",
        Wt = "data-grid-image-target-default",
        Bt = "data-swatch-image",
        Ft = "data-swatch-image-id",
        Ot = "data-swatch-variant",
        Nt = "[data-grid-link]",
        zt = "[data-grid-swatches]",
        Rt = "[data-swatch-template]",
        jt = "data-swatch-handle",
        Vt = "data-swatch-label",
        Ut = "data-swatch-index",
        Jt = "data-media-id",
        Kt = "data-media-src-placeholder",
        Yt = "data-fetched-image",
        Gt = "data-fetched-image-index",
        Xt = "is-fade";
    let Qt = class extends HTMLElement {
        init() {
            this.setStyles(),
                this.variant &&
                    this.outer &&
                    (this.outer.addEventListener("theme:upsell:media", (t) => {
                        t && t.detail && t.detail.media && (this.media = t.detail.media);
                    }),
                    this.handleHovers());
                   // this.handleClicks()
        }
        setStyles() {
            this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                this.colorMatch.path && (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`), this.element.style.setProperty("background-size", "cover"));
        }
        handleHovers() {
            this.element.addEventListener("mouseenter", () => {
                if (((this.imageReplace = null), this.imageId)) {
                    if (!this.outer.querySelector(`[${Dt}="${this.imageId}"]`) && ((this.imageSlide = this.outer.querySelector(It)), this.image && this.imageSlide)) {
                        const t = window.devicePixelRatio || 1,
                            e = this.imageSlide.offsetWidth * t,
                            i = 180 * Math.ceil(e / 180);
                        if ((this.imageSlide.hasAttribute(Wt) ? this.imageSlide.getAttribute(Wt) : "") === this.imageId && this.imageSlide.hasAttribute(Mt)) return void (this.imageReplace = this.imageSlide.getAttribute(Mt));
                        if (this.element.hasAttribute(Yt)) this.imageReplace = this.element.getAttribute(Yt);
                        else if (this.media) {
                            const t = this.media.querySelector(`[${Jt}="${this.imageId}"]`);
                            if (t && t.hasAttribute(Kt)) {
                                const e = ut(t.getAttribute(Kt).replace("_1x1", ""), `${i}x`);
                                (this.imageReplace = `url("${e}")`), this.element.setAttribute(Yt, this.imageReplace);
                            }
                        } else {
                            const t = ut(this.image, `${i}x`);
                            window
                                .fetch(t)
                                .then((t) => t.blob())
                                .then((t) => {
                                    const e = URL.createObjectURL(t);
                                    (this.imageReplace = `url("${e}")`),
                                        this.element.setAttribute(Yt, this.imageReplace),
                                        this.element.hasAttribute(Ut) &&
                                            this.outer.hasAttribute(Gt) &&
                                            parseInt(this.element.getAttribute(Ut)) === parseInt(this.outer.getAttribute(Gt)) &&
                                            (this.replaceImage(), this.swatchImageChange(), this.outer.removeAttribute(Gt));
                                })
                                .catch((t) => {
                                    console.log(`Error: ${t}`);
                                });
                        }
                    }
                }
            });
        }
        handleClicks() {
            // this.element.addEventListener("click", () => {
            //     this.changeImageOnEvent();
            // }),
            //     this.element.addEventListener("keyup", (t) => {
            //         t.which === window.theme.keyboardKeys.ENTER && ((this.stopSlideAnimation = !0), this.changeImageOnEvent());
            //     });
        }
        changeImageOnEvent() {
            // this.outer.removeAttribute(Gt),
            //     (this.linkElements = this.outer.querySelectorAll(Nt)),
            //     this.linkElements.length &&
            //         this.linkElements.forEach((t) => {
            //             const e = ((i = t.getAttribute("href")), (s = this.variant), /variant=/.test(i) ? i.replace(/(variant=)[^&]+/, "$1" + s) : /\?/.test(i) ? i.concat("&variant=").concat(s) : i.concat("?variant=").concat(s));
            //             var i, s;
            //             t.setAttribute("href", e);
            //         }),
            //     !this.imageReplace && this.element.hasAttribute(Ut) && this.outer.setAttribute(Gt, parseInt(this.element.getAttribute(Ut))),
            //     this.replaceImage(),
            //     this.swatchImageChange();
        }
        swatchImageChange() {
            this.imageId && this.outer.dispatchEvent(new CustomEvent("theme:swatch:change", { bubbles: !0, detail: { id: this.imageId, stopSlideAnimation: this.stopSlideAnimation } }));
        }
        replaceImage() {
            if (this.imageReplace && this.imageSlide && this.imageId) {
                if (this.imageSlide.hasAttribute(Dt) && this.imageSlide.getAttribute(Dt) !== this.imageId) {
                    this.imageSlide.classList.add(Xt);
                    const t = 1e3 * parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue("animation-duration"));
                    setTimeout(() => {
                        this.imageSlide.classList.remove(Xt);
                    }, t);
                }
                this.imageSlide.setAttribute(Dt, this.imageId),
                    this.imageSlide.style.setProperty("background-color", "#fff"),
                    this.imageSlide.hasAttribute(Mt) || this.imageSlide.setAttribute(Mt, window.getComputedStyle(this.imageSlide).backgroundImage),
                    this.imageSlide.style.setProperty("background-image", this.imageReplace);
            }
        }
        constructor() {
            super(),
                (this.element = this.querySelector(`[${Ht}]`)),
                (this.colorString = this.element.getAttribute(Ht)),
                (this.image = this.element.getAttribute(Bt)),
                (this.imageId = this.element.getAttribute(Ft)),
                (this.variant = this.element.getAttribute(Ot)),
                (this.outer = this.element.closest(_t)),
                (this.media = null),
                (this.imageSlide = null),
                (this.imageDefault = null),
                (this.stopSlideAnimation = !1);
            const t = new (class {
                getColor() {
                    return this.match;
                }
                init() {
                    return Tt({ json: window.theme.assets.swatches })
                        .then((t) => this.matchColors(t, this.settings.color))
                        .catch((t) => {
                            console.log("failed to load swatch colors script"), console.log(t);
                        });
                }
                matchColors(t, e) {
                    let i = "#E5E5E5",
                        s = null;
                    const o = window.theme.assets.base || "/",
                        r = e.toLowerCase().replace(/\s/g, ""),
                        n = t.colors;
                    if (n) {
                        const t = (t) => Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === r,
                            e = n.findIndex(t);
                        if (e > -1) {
                            const t = Object.values(n[e])[0],
                                r = t.toLowerCase();
                            r.includes(".jpg") || r.includes(".jpeg") || r.includes(".png") || r.includes(".svg") ? ((s = `${o}${encodeURIComponent(t)}`), (i = "#888888")) : (i = t);
                        }
                    }
                    return { color: this.settings.color, path: s, hex: i };
                }
                constructor(t = {}) {
                    (this.settings = { ...$t, ...t }), (this.match = this.init());
                }
            })({ color: this.colorString });
            t.getColor().then((t) => {
                (this.colorMatch = t), this.init();
            });
        }
    };
    function Zt(t) {
        t.querySelectorAll(zt).forEach((t) => {
            new (class {
                init() {
                    (this.wrap.innerHTML = ""),
                        this.swatches.forEach((t, e) => {
                            let i = this.product.variants.find((e) => e.options.includes(t));
                            const s = i.featured_media ? i.featured_media.preview_image.src : "",
                                o = i.featured_media ? i.featured_media.id : "",
                                r = Math.floor(9999 * Math.random());
                            this.wrap.innerHTML += u.render(this.template, { color: t, uniq: `${this.product.id}-${i.id}-${r}`, variant: i.id, product_id: this.product.id, image_id: o, image: s, index: e });
                        }),
                        new j(this.wrap);
                }
                constructor(t) {
                    (this.template = document.querySelector(Rt).innerHTML), (this.wrap = t), (this.handle = t.getAttribute(jt));
                    const e = t.getAttribute(Vt).trim().toLowerCase();
                    Et(this.handle).then((t) => {
                        (this.product = t),
                            (this.colorOption = t.options.find(function (t) {
                                return t.name.toLowerCase() === e || null;
                            })),
                            this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                    });
                }
            })(t);
        });
    }
    const te = {
            onLoad() {
                Zt(this.container), Pt(this.container);
            },
        },
        ee = "[data-custom-scrollbar-items]",
        ie = "[data-custom-scrollbar]",
        se = "[data-custom-scrollbar-track]",
        oe = "hide",
        re = {};
    let ne = class {
        events() {
            this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)),
                this.holderItems.addEventListener("theme:carousel:scroll", this.calculatePosition.bind(this)),
                document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)),
                document.addEventListener("theme:resize:width", this.calculatePosition.bind(this));
        }
        calculateTrackWidth() {
            const t = document.createElement("div");
            this.holderItems.prepend(t), (t.style.display = "none"), (t.style.width = getComputedStyle(this.holderItems).getPropertyValue("--outer"));
            const e = parseInt(getComputedStyle(t).getPropertyValue("width"));
            this.holderItems.firstChild.remove(),
                (this.scrollbarWidth = 0 === this.scrollbar.clientWidth ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth),
                setTimeout(() => {
                    const t = this.children[0].clientWidth,
                        i = Number(getComputedStyle(this.children[0]).marginRight.replace("px", "")),
                        s = Number(getComputedStyle(this.children[0]).marginLeft.replace("px", ""));
                    (this.scrollWidth = this.children.length * (t + i + s) + e - i),
                        (this.trackWidth = ((this.scrollbarWidth + e) / this.scrollWidth) * 100),
                        (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
                        this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                    const o = Math.ceil(this.trackWidth) >= 100;
                    this.scrollbar.classList.toggle(oe, o);
                }, 100);
        }
        calculatePosition() {
            let t = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
            (t *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth),
                (t = t < 0 ? 0 : t),
                (t = isNaN(t) ? 0 : t),
                this.scrollbar.style.setProperty("--position", `${Math.round(t)}px`),
                document.dispatchEvent(new CustomEvent("theme:scrollbar:scroll", { bubbles: !0, detail: { holder: this.holderItems } }));
        }
        constructor(t, e = null) {
            (this.holderItems = t.querySelector(ee)),
                (this.scrollbar = t.querySelector(ie)),
                (this.scrollbarTrack = t.querySelector(se)),
                (this.trackWidth = 0),
                (this.scrollWidth = 0),
                this.scrollbar && this.holderItems && ((this.children = e || this.holderItems.children), this.events(), this.calculateTrackWidth());
        }
    };
    const ae = {
            onLoad() {
                re[this.id] = new ne(this.container);
            },
        },
        le = "[data-carousel]",
        ce = "data-carousel-progress",
        he = "[data-carousel-slide]",
        de = "[data-grid-slide]",
        ue = "[data-wrapper]",
        pe = "[data-carousel-track]",
        me = "data-options",
        ge = "data-custom-scrollbar-items",
        ye = ".flickity-button.previous",
        fe = ".flickity-button.next",
        we = "data-recently-viewed-products",
        be = "data-related-products",
        ve = "[data-section-id]",
        Se = "wrapper--full",
        Ee = "not-moved-arrows",
        Le = "hide",
        Te = "flickity-enabled",
        ke = "hidden-arrows",
        Ae = "flickity-static",
        qe = 112;
    let Ce = class extends HTMLElement {
        connectedCallback() {
            (this.carousel = this.container.querySelector(le)),
                (this.carouselTrack = this.container.querySelector(pe)),
                (this.wrapper = this.container.closest(ue)),
                (this.section = this.container.closest(ve)),
                (this.slidesVisible = null),
                (this.carouselInstance = null),
                (this.carouselPrev = null),
                (this.carouselNext = null),
                (this.customOptions = {}),
                (this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier()),
                this.carousel && this.carousel.hasAttribute(we)
                    ? this.section.addEventListener("theme:recent-products:added", () => {
                          this.init();
                      })
                    : this.carousel && this.carousel.hasAttribute(be)
                    ? this.section.addEventListener("theme:related-products:added", () => {
                          this.init();
                      })
                    : this.init();
        }
        init() {
            this.carousel &&
                ((this.slidesTotal = this.carousel.querySelectorAll(he).length),
                this.getGridLayout(),
                this.trackVisibleSlides(),
                this.carousel.hasAttribute(me) && (this.customOptions = JSON.parse(decodeURIComponent(this.carousel.getAttribute(me)))),
                this.initCarousel(),
                this.calculatedArrowsTopPosition(),
                this.toggleWrapperModifier(),
                document.addEventListener("theme:resize:width", this.toggleWrapperModifierEvent),
                this.carousel.hasAttribute(ce) && this.progressBarCalculate(),
                this.carousel.hasAttribute(ge) && new ne(this.container));
        }
        initCarousel() {
            (this.options = {
                accessibility: !0,
                contain: !0,
                freeScroll: !0,
                prevNextButtons: !0,
                wrapArround: !1,
                groupCells: !1,
                autoPlay: !1,
                pageDots: !1,
                cellAlign: window.isRTL ? "right" : "left",
                rightToLeft: window.isRTL,
                dragThreshold: 10,
                arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
                on: {
                    resize: () => {
                        this.toggleArrows(),
                            this.calculatedArrowsTopPosition(),
                            setTimeout(() => {
                                this.visibleSlides();
                            }, 100);
                    },
                },
                ...this.customOptions,
            }),
                (this.carouselInstance = new s(this.carousel, this.options)),
                (this.carouselPrev = this.carousel.querySelector(ye)),
                (this.carouselNext = this.carousel.querySelector(fe)),
                this.container.addEventListener("theme:tab:change", () => {
                    this.carouselInstance.resize(), (this.carouselPrev = this.carousel.querySelector(ye)), (this.carouselNext = this.carousel.querySelector(fe));
                }),
                this.carouselInstance.on("dragStart", () => {
                    (this.carouselInstance.slider.style.pointerEvents = "none"), this.containDrag();
                }),
                this.carouselInstance.on("dragEnd", () => {
                    (this.carouselInstance.slider.style.pointerEvents = "auto"), this.containDrag();
                }),
                this.carouselInstance.on("change", (t) => this.lockArrows(t)),
                setTimeout(() => {
                    this.visibleSlides();
                }, 100),
                Shopify.designMode &&
                    setTimeout(() => {
                        this.carouselInstance.options.watchCSS && !this.carousel.classList.contains(Te)
                            ? (this.carouselInstance.destroy(),
                              (this.carouselInstance = new s(this.carousel, this.options)),
                              this.carouselInstance.resize(),
                              (this.carouselPrev = this.carousel.querySelector(ye)),
                              (this.carouselNext = this.carousel.querySelector(fe)))
                            : this.carouselInstance.resize();
                    }, 10),
                this.carousel.classList.toggle(Ae, this.smallItems === this.carousel.querySelectorAll(he).length),
                Zt(this.container),
                new U(this.container);
        }
        calculatedArrowsTopPosition() {
            const t = this.container.querySelector(de);
            if (t) {
                const e = t.offsetHeight / 2;
                this.carousel.style.setProperty("--buttons-top", `${e}px`);
            }
        }
        toggleWrapperModifier() {
            if (!this.wrapper) return;
            const t = Number(getComputedStyle(document.documentElement).getPropertyValue("--scrollbar-width").replace("px", "")),
                e = this.wrapper.clientWidth;
            (this.wrapperWidthWithGutter = e + qe + t), this.wrapper.classList.toggle(Se, this.wrapperWidthWithGutter >= window.innerWidth), this.section.classList.toggle(Ee, !(this.wrapperWidthWithGutter >= window.innerWidth));
        }
        progressBarCalculate() {
            null !== this.carouselInstance &&
                this.carouselTrack &&
                this.carouselInstance.on("scroll", (t) => {
                    (t = 100 * Math.max(0, Math.min(1, t)) + "%"), (this.carouselTrack.style.width = t);
                });
        }
        getGridLayout() {
            (this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")) || 3),
                (this.mediumItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-medium-items")) || this.largeItems),
                (this.smallItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-small-items")) || this.mediumItems || this.largeItems);
        }
        visibleSlides() {
            if (!this.carousel) return;
            this.getGridLayout();
            const t = this.carousel.clientWidth || this.carouselInstance.size.width,
                e = null !== this.carouselInstance && this.carouselInstance.selectedElement ? this.carouselInstance.selectedElement.clientWidth : this.carousel.querySelector(he).clientWidth,
                i = null !== this.carouselInstance && this.carouselInstance.slides ? this.carouselInstance.slides.length : this.carousel.querySelectorAll(he).length,
                s = Math.floor(t / e);
            this.section.classList.remove(ke),
                this.carouselPrev && this.carouselNext && (this.carouselPrev.classList.remove(Le), this.carouselNext.classList.remove(Le)),
                window.innerWidth > window.theme.sizes.large && !this.options.groupCells && s <= this.largeItems && i <= this.largeItems && this.carouselPrev && this.carouselNext && this.hideArrows(),
                window.innerWidth >= window.theme.sizes.medium &&
                    window.innerWidth <= window.theme.sizes.large &&
                    !this.options.groupCells &&
                    s <= this.mediumItems &&
                    i <= this.mediumItems &&
                    this.carouselPrev &&
                    this.carouselNext &&
                    this.hideArrows(),
                window.innerWidth < window.theme.sizes.medium && !this.options.groupCells && s <= this.smallItems && i <= this.smallItems && this.carouselPrev && this.carouselNext && this.hideArrows();
        }
        trackVisibleSlides() {
            const t = window.matchMedia(`(max-width: ${window.theme.sizes.medium - 1}px)`),
                e = window.matchMedia(`(min-width: ${window.theme.sizes.medium}px) and (max-width: ${window.theme.sizes.large - 1}px)`),
                i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
            t.addEventListener("change", (t) => {
                !t.matches || (this.slidesVisible = this.smallItems);
            }),
                !t.matches || (this.slidesVisible = this.smallItems),
                e.addEventListener("change", (t) => {
                    !t.matches || (this.slidesVisible = this.mediumItems);
                }),
                !e.matches || (this.slidesVisible = this.mediumItems),
                i.addEventListener("change", (t) => {
                    !t.matches || (this.slidesVisible = this.largeItems);
                }),
                !i.matches || (this.slidesVisible = this.largeItems);
        }
        containDrag() {
            const t = this.slidesTotal - this.slidesVisible;
            this.carouselInstance.selectedIndex >= t && (this.carouselInstance.select(t), this.lockArrows(this.carouselInstance.selectedIndex));
        }
        lockArrows(t) {
            if (this.options.wrapAround || this.options.groupCells) return;
            const e = parseInt(t),
                i = this.slidesTotal - this.slidesVisible;
            this.carouselNext.disabled = e >= i;
        }
        showArrows() {
            this.carouselPrev.classList.remove(Le), this.carouselNext.classList.remove(Le), this.section.classList.remove(ke);
        }
        hideArrows() {
            this.carouselPrev.classList.add(Le), this.carouselNext.classList.add(Le), this.section.classList.add(ke);
        }
        toggleArrows() {
            this.carouselPrev && this.carouselNext && (this.carouselPrev.disabled && this.carouselNext.disabled ? this.hideArrows() : this.showArrows());
        }
        constructor() {
            super(), (this.container = this);
        }
    };
    customElements.get("flickity-carousel") || customElements.define("flickity-carousel", Ce);
    const Pe = "[data-address-wrapper]",
        xe = "[data-new-address-form]",
        $e = "[new-address-form-inner]",
        He = ".address-new-toggle",
        _e = ".address-edit-toggle",
        Ie = ".address-delete",
        Me = "hide",
        De = "data-form-id",
        We = "data-confirm-message",
        Be = "Are you sure you wish to delete this address?",
        Fe = "#EditAddress",
        Oe = "AddressCountryNew",
        Ne = "AddressProvinceNew",
        ze = "AddressProvinceContainerNew",
        Re = ".address-country-option",
        je = "AddressCountry",
        Ve = "AddressProvince",
        Ue = "AddressProvinceContainer";
    const Je = document.querySelector(Pe);
    Je &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const t = this.section,
                        e = this.addressNewForm.querySelector($e);
                    this.customerAddresses();
                    const i = t.querySelectorAll(He);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", function () {
                                e.classList.toggle(Me);
                            });
                        });
                    const s = t.querySelectorAll(_e);
                    s.length &&
                        s.forEach((e) => {
                            e.addEventListener("click", function () {
                                const e = this.getAttribute(De);
                                t.querySelector(`${Fe}_${e}`).classList.toggle(Me);
                            });
                        });
                    const o = t.querySelectorAll(Ie);
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function () {
                                const t = this.getAttribute(De),
                                    e = this.getAttribute(We);
                                confirm(e || Be) && Shopify.postLink(window.theme.routes.account_addresses_url + "/" + t, { parameters: { _method: "delete" } });
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(Oe, Ne, { hideElement: ze }),
                    this.section.querySelectorAll(Re).forEach((t) => {
                        const e = t.getAttribute(De),
                            i = `${je}_${e}`,
                            s = `${Ve}_${e}`,
                            o = `${Ue}_${e}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
                    });
            }
            constructor(t) {
                (this.section = t), (this.addressNewForm = this.section.querySelector(xe)), this.init();
            }
        })(Je),
        document.querySelector("#RecoverPassword") &&
            (function () {
                var t = { recoverPasswordForm: "#RecoverPassword", hideRecoverPasswordLink: "#HideRecoverPasswordLink" };
                function e(t) {
                    t.preventDefault(), s();
                }
                function i() {
                    "#recover" === window.location.hash && s();
                }
                function s() {
                    var t = document.querySelector("#CustomerEmail").value;
                    (document.querySelector("#RecoverEmail").value = t), document.querySelector("#RecoverPasswordForm").classList.toggle("display-none"), document.querySelector("#CustomerLoginForm").classList.toggle("display-none");
                }
                function o() {
                    document.querySelector(".reset-password-success") && document.querySelector("#ResetSuccess").classList.remove("display-none");
                }
                i(), o(), document.querySelector(t.recoverPasswordForm).addEventListener("click", e), document.querySelector(t.hideRecoverPasswordLink).addEventListener("click", e);
            })(),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const Ke = window.Shopify.theme.sections.registered,
        Ye = window.Shopify.theme.sections.instances,
        Ge = "data-section-id",
        Xe = "data-section-type";
    let Qe = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t) => {
                const i = { id: this.id, type: this.type, container: this.container };
                e ? t.call(i, e) : t.call(i);
            });
        }
        onLoad() {
            this.callFunctions("onLoad");
        }
        onUnload() {
            this.callFunctions("onUnload");
        }
        onSelect(t) {
            this.callFunctions("onSelect", t);
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t);
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t);
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t);
        }
        onReorder(t) {
            this.callFunctions("onReorder", t);
        }
        constructor(t, e) {
            (this.container = (function (t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(Ge)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + Ge + " attribute.");
                return t;
            })(t)),
                (this.id = t.getAttribute(Ge)),
                (this.type = e.type),
                (this.callStack = e.getStack());
            try {
                this.onLoad();
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
            }
        }
    };
    function Ze(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Ke[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new (class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i));
                        }
                    });
            }
        })(t, e);
        return (Ke[t] = i), Ke;
    }
    function ti(t, e) {
        (t = si(t)),
            void 0 === e && (e = document.querySelectorAll("[" + Xe + "]")),
            (e = oi(e)),
            t.forEach(function (t) {
                const i = Ke[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return !(ei(e).length > 0) && null !== e.getAttribute(Xe) && (e.getAttribute(Xe) !== t || (Ye.push(new Qe(e, i)), !1));
                    }));
            });
    }
    function ei(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            oi(t).forEach(function (t) {
                e = e.concat(
                    Ye.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            si(t).forEach(function (t) {
                e = e.concat(
                    Ye.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function ii(t) {
        for (var e, i = 0; i < Ye.length; i++)
            if (Ye[i].id === t) {
                e = Ye[i];
                break;
            }
        return e;
    }
    function si(t) {
        return (
            "*" === t
                ? (t = Object.keys(Ke))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === Qe
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === Qe &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function oi(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    function ri(t, e) {
        (e = e || {}),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function i(s) {
                s.target.removeEventListener(s.type, i), void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function ni(t) {
        return (
            (t = t || {}),
            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                if ("#" === e.hash || "" === e.hash) return !1;
                if (t.ignore && e.matches(t.ignore)) return !1;
                if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                var i,
                    s = document.querySelector(e.hash);
                return (
                    !!s &&
                    (e.addEventListener("click", function () {
                        ri(s, t);
                    }),
                    !0)
                );
            })
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + Ge + '="' + e + '"]');
            null !== i && ti(i.getAttribute(Xe), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + Ge + '="' + e + '"]');
            "object" == typeof ei(i)[0] &&
                ei(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + Ge + '="' + e + '"]');
            "object" == typeof ei(i)[0] &&
                ei(i).forEach(function (t) {
                    var e = Ye.map(function (t) {
                        return t.id;
                    }).indexOf(t.id);
                    Ye.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = ii(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = ii(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = ii(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = ii(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    var ai = {};
    function li(t, e) {
        e = e || {};
        var i = (function (t) {
                return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]")).filter(function (t) {
                    return Boolean(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
                });
            })(t),
            s = e.elementToFocus || t,
            o = i[0],
            r = i[i.length - 1];
        ci(),
            (ai.focusin = function (e) {
                t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), (e.target !== t && e.target !== r && e.target !== o) || document.addEventListener("keydown", ai.keydown);
            }),
            (ai.focusout = function () {
                document.removeEventListener("keydown", ai.keydown);
            }),
            (ai.keydown = function (e) {
                9 === e.keyCode && (e.target !== r || e.shiftKey || (e.preventDefault(), o.focus()), (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), r.focus()));
            }),
            document.addEventListener("focusout", ai.focusout),
            document.addEventListener("focusin", ai.focusin),
            ri(s, e);
    }
    function ci() {
        document.removeEventListener("focusin", ai.focusin), document.removeEventListener("focusout", ai.focusout), document.removeEventListener("keydown", ai.keydown);
    }
    const hi = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
    function di(t) {
        const e = `data-popup-${t}`;
        r.init({
            openTrigger: e,
            disableScroll: !0,
            onShow: (t, e, i) => {
                i.preventDefault();
                const s = t.querySelector(hi);
                li(t, { elementToFocus: s });
            },
            onClose: (t, e, i) => {
                i.preventDefault(), ci(), e.focus();
            },
        });
    }
    const ui = "[data-toggle-password-modal]",
        pi = ".storefront-password-form .errors",
        mi = {};
    Ze("password", {
        onLoad() {
            mi[this.id] = new (class {
                init() {
                    di("password"), this.errors && this.trigger.click();
                }
                constructor(t) {
                    (this.container = t.container), (this.trigger = this.container.querySelector(ui)), (this.errors = this.container.querySelector(pi)), this.init();
                }
            })(this);
        },
    }),
        (function () {
            var t = "#QrCode",
                e = ".giftcard__code";
            const i = document.querySelector(t);
            if (i) {
                function o() {
                    const t = i.getAttribute("data-identifier");
                    new QRCode(i, { text: t, width: 120, height: 120 });
                }
                window.addEventListener("load", o);
            }
            const s = document.querySelector(e);
            if (s) {
                function r() {
                    var t = document.querySelector("#GiftCardDigits"),
                        e = "";
                    if (document.body.createTextRange) (e = document.body.createTextRange()).moveToElementText(t), e.select();
                    else if (window.getSelection) {
                        var i = window.getSelection();
                        (e = document.createRange()).selectNodeContents(t), i.removeAllRanges(), i.addRange(e);
                    }
                }
                s.addEventListener("click", r());
            }
        })();
    const gi = "[data-parallax-wrapper]",
        yi = "[data-parallax-img]";
    let fi = {};
    const wi = {
        onLoad() {
            fi[this.id] = [];
            this.container.querySelectorAll(gi).forEach((t) => {
                const e = t.querySelector(yi);
                fi[this.id].push(new n(e, { center: !0, round: !0, frame: t }));
            });
        },
        onUnload: function () {
            fi[this.id].forEach((t) => {
                "function" == typeof t.destroy && t.destroy();
            });
        },
    };
    Ze("article", wi);
    const bi = "[data-ticker-frame]",
        vi = "[data-ticker-scale]",
        Si = "[data-ticker-text]",
        Ei = "data-clone",
        Li = "ticker--animated",
        Ti = "ticker--unloaded",
        ki = "ticker__comparitor",
        Ai = 1.63,
        qi = 100,
        Ci = {};
    let Pi = class {
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent);
        }
        listen() {
            document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth();
        }
        checkWidth() {
            const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
            if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                if (
                    (this.text.classList.add(Li),
                    1 === this.scale.childElementCount && ((this.clone = this.text.cloneNode(!0)), this.clone.setAttribute("aria-hidden", !0), this.clone.setAttribute(Ei, ""), this.scale.appendChild(this.clone), this.stopClone))
                )
                    for (let t = 0; t < 10; t++) {
                        const t = this.text.cloneNode(!0);
                        t.setAttribute("aria-hidden", !0), t.setAttribute(Ei, ""), this.scale.appendChild(t);
                    }
                const t = (this.text.clientWidth / qi) * Ai;
                this.scale.style.setProperty("--animation-time", `${t}s`);
            } else {
                this.text.classList.add(Li);
                let t = this.scale.querySelector(`[${Ei}]`);
                t && this.scale.removeChild(t), this.text.classList.remove(Li);
            }
        }
        constructor(t, e = !1) {
            (this.frame = t),
                (this.stopClone = e),
                (this.scale = this.frame.querySelector(vi)),
                (this.text = this.frame.querySelector(Si)),
                (this.comparitor = this.text.cloneNode(!0)),
                this.comparitor.classList.add(ki),
                this.frame.appendChild(this.comparitor),
                this.scale.classList.remove(Ti),
                (this.resizeEvent = A(() => this.checkWidth(), 300)),
                this.listen();
        }
    };
    const xi = {
            onLoad() {
                Ci[this.id] = [];
                this.container.querySelectorAll(bi).forEach((t) => {
                    Ci[this.id].push(new Pi(t));
                });
            },
            onUnload() {
                Ci[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        $i = "data-slider-speed",
        Hi = "data-slide",
        _i = "data-slide-index";
    const Ii = "[data-cart-message]",
        Mi = "data-cart-message",
        Di = "[data-left-to-spend]",
        Wi = "[data-cart-progress]",
        Bi = "data-limit",
        Fi = "data-percent",
        Oi = "is-success";
    let Ni = class {
        init() {
            (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(Bi)) * this.rate),
                (this.shippingAmount = 0),
                (this.circumference = 28 * Math.PI),
                this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount),
                this.cartBarProgress(),
                this.listen();
        }
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (t) {
                    (this.cart = t.detail.cart), this.render();
                }.bind(this)
            );
        }
        render() {
            const t = this.cart.total_price;
            this.freeShippingMessageHandle(t), this.cart && this.cart.total_price && this.cartMessage.length > 0 && ((this.shippingAmount = t), this.updateProgress());
        }
        freeShippingMessageHandle(t) {
            this.cartMessage.length > 0 &&
                this.container.querySelectorAll(Ii).forEach((e) => {
                    const i = e.hasAttribute(Mi) && "true" === e.getAttribute(Mi) && t >= this.cartFreeLimitShipping && 0 !== t;
                    e.classList.toggle(Oi, i);
                });
        }
        cartBarProgress(t = null) {
            this.container.querySelectorAll(Wi).forEach((e) => {
                this.setProgress(e, null === t ? e.getAttribute(Fi) : t);
            });
        }
        setProgress(t, e) {
            const i = this.circumference - ((e / 100) * this.circumference) / 2;
            t.style.strokeDashoffset = i;
        }
        updateProgress() {
            const t = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
            this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(t > 100 ? 100 : t);
        }
        exchangeRateConversions(t, e) {
            const i = theme.settings.currency_code_enable ? a.formatMoney(t - e, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(t - e, theme.moneyFormat);
            this.container.querySelectorAll(Di).forEach((t) => {
                t.innerHTML = i.replace(".00", "");
            });
        }
        constructor(t) {
            (this.container = t), (this.cartMessage = this.container.querySelectorAll(Ii)), (this.rate = window.Shopify.currency.rate), this.cartMessage.length > 0 && this.init();
        }
    };
    const zi = "[data-bar]",
        Ri = "[data-slide]",
        ji = "[data-ticker-frame]",
        Vi = "[data-announcement-slider]",
        Ui = "data-slide",
        Ji = "[data-ticker-scale]",
        Ki = "[data-ticker-text]",
        Yi = "data-target-referrer",
        Gi = "data-slide",
        Xi = "mobile",
        Qi = "desktop",
        Zi = "ticker--animated",
        ts = {};
    Ze("announcement", {
        onLoad() {
            (ts[this.id] = []),
                ts[this.id].push(
                    new (class {
                        init() {
                            this.removeAnnouncement(), this.slider ? (this.slider && this.slides && this.slides.length > 1 ? this.initSliders() : this.initTickers()) : this.initTickers(!0);
                        }
                        removeAnnouncement() {
                            for (let t = 0; t < this.slides.length; t++) {
                                const e = this.slides[t];
                                e.hasAttribute(Yi) && (-1 !== this.locationPath.indexOf(e.getAttribute(Yi)) || window.Shopify.designMode || e.parentNode.removeChild(e));
                            }
                        }
                        initSliders() {
                            (this.slider = new (class {
                                init() {
                                    const t = {
                                        initialIndex: 0,
                                        autoPlay: this.speed,
                                        contain: !0,
                                        pageDots: !1,
                                        adaptiveHeight: !0,
                                        wrapAround: !0,
                                        groupCells: !1,
                                        cellAlign: "left",
                                        freeScroll: !1,
                                        prevNextButtons: !0,
                                        draggable: !0,
                                        rightToLeft: window.isRTL,
                                        on: {
                                            ready: () => {
                                                setTimeout(() => {
                                                    this.slideshow.dispatchEvent(new CustomEvent("theme:announcement:loaded", { bubbles: !0, detail: { slider: this } }));
                                                }, 50);
                                            },
                                        },
                                    };
                                    (this.flkty = new s(this.slideshow, t)), this.flkty && (document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:scroll", this.scrollEvent));
                                }
                                resizeEvents() {
                                    this.flkty.resize();
                                }
                                scrollEvents() {
                                    if (this.flkty && this.speed) {
                                        const t = this.flkty.element,
                                            e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                                        window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                                    }
                                }
                                onUnload() {
                                    this.slideshow &&
                                        this.flkty &&
                                        (document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:scroll", this.scrollEvent), (this.flkty.options.watchCSS = !1), this.flkty.destroy());
                                }
                                onBlockSelect(t) {
                                    if (!this.slideshow) return;
                                    const e = this.slideshow.querySelector(`[${Hi}="${t.detail.blockId}"]`);
                                    if (!e) return;
                                    const i = parseInt(e.getAttribute(_i));
                                    this.flkty.selectCell(i), this.flkty.stopPlayer();
                                }
                                onBlockDeselect() {
                                    this.flkty.playPlayer();
                                }
                                constructor(t, e) {
                                    (this.container = t), (this.slideshow = e);
                                    const i = this.slideshow.getAttribute($i);
                                    (this.speed = !!i && parseInt(i)), (this.scrollEvent = () => this.scrollEvents()), (this.resizeEvent = () => this.resizeEvents()), this.slideshow && ((this.flkty = null), this.init());
                                }
                            })(this.container, this.slider)),
                                this.slider.flkty.reposition(),
                                this.barHolder.addEventListener("theme:announcement:loaded", () => {
                                    this.initTickers();
                                });
                        }
                        initTickers(t = !1) {
                            const e = this.barHolder.querySelector(ji);
                            e && new Pi(e, t);
                        }
                        toggleTicker(t, e) {
                            const i = document.querySelector(Ji),
                                s = document.querySelector(`[${Ui}="${t.detail.blockId}"]`);
                            e &&
                                s &&
                                (i.setAttribute("data-stop", ""),
                                i.querySelectorAll(Ki).forEach((t) => {
                                    t.classList.remove(Zi), (t.style.transform = `translate3d(${-(s.offsetLeft - s.clientWidth)}px, 0, 0)`);
                                })),
                                !e &&
                                    s &&
                                    (i.querySelectorAll(Ki).forEach((t) => {
                                        t.classList.add(Zi), t.removeAttribute("style");
                                    }),
                                    i.removeAttribute("data-stop"));
                        }
                        onBlockSelect(t) {
                            this.slider && "function" == typeof this.slider.onBlockSelect
                                ? this.slider.onBlockSelect(t)
                                : (document.querySelectorAll(`[${Gi}="${t.detail.blockId}"]`).forEach((t) => {
                                      t.classList.contains(Xi) && (this.hasDeviceClass = Xi), t.classList.contains(Qi) && (this.hasDeviceClass = Qi), "" !== this.hasDeviceClass && t.classList.remove(this.hasDeviceClass);
                                  }),
                                  this.toggleTicker(t, !0));
                        }
                        onBlockDeselect(t) {
                            this.slider && "function" == typeof this.slider.onBlockDeselect
                                ? this.slider.onBlockDeselect(t)
                                : ("" !== this.hasDeviceClass &&
                                      document.querySelectorAll(`[${Gi}="${t.detail.blockId}"]`).forEach((t) => {
                                          t.classList.add(this.hasDeviceClass);
                                      }),
                                  this.toggleTicker(t, !1));
                        }
                        onUnload() {
                            this.slider && "function" == typeof this.slider.onUnload && this.slider.onUnload();
                        }
                        constructor(t) {
                            (this.container = t.container),
                                (this.barHolder = this.container.querySelector(zi)),
                                (this.locationPath = location.href),
                                (this.slides = this.barHolder.querySelectorAll(Ri)),
                                (this.slider = this.barHolder.querySelector(Vi)),
                                (this.hasDeviceClass = ""),
                                new Ni(this.container),
                                this.init();
                        }
                    })(this)
                );
        },
        onUnload() {
            ts[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            ts[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            ts[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
            });
        },
    });
    const es = "[data-ticker-frame]",
        is = "data-slide",
        ss = "[data-ticker-scale]",
        os = "[data-ticker-text]",
        rs = "ticker--animated",
        ns = {};
    Ze("logos", {
        onLoad() {
            (ns[this.id] = []),
                ns[this.id].push(
                    new (class {
                        init() {
                            this.initTickers(!0);
                        }
                        initTickers(t = !1) {
                            const e = this.container.querySelector(es);
                            e && new Pi(e, t);
                        }
                        toggleTicker(t, e) {
                            const i = this.container.querySelector(ss),
                                s = this.container.querySelector(`[${is}="${t.detail.blockId}"]`);
                            e &&
                                s &&
                                i &&
                                (i.setAttribute("data-stop", ""),
                                i.querySelectorAll(os).forEach((t) => {
                                    t.classList.remove(rs), (t.style.transform = `translate3d(${-(s.offsetLeft - s.clientWidth)}px, 0, 0)`);
                                })),
                                !e &&
                                    s &&
                                    i &&
                                    (i.querySelectorAll(os).forEach((t) => {
                                        t.classList.add(rs), t.removeAttribute("style");
                                    }),
                                    i.removeAttribute("data-stop"));
                        }
                        onBlockSelect(t) {
                            this.toggleTicker(t, !0);
                        }
                        onBlockDeselect(t) {
                            this.toggleTicker(t, !1);
                        }
                        constructor(t) {
                            (this.container = t.container), this.init();
                        }
                    })(this)
                );
        },
        onBlockSelect(t) {
            ns[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            ns[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
            });
        },
    }),
        Ze("blog", wi);
    var as = "[data-drawer]",
        ls = "[data-drawer-scrolls]",
        cs = "[data-drawer-underlay]",
        hs = "[data-stagger-animation]",
        ds = "data-drawer-toggle",
        us = ":scope > * > [data-animates]",
        ps = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        ms = "drawer--visible",
        gs = "display-none",
        ys = {};
    const fs = {
            onLoad() {
                ys[this.id] = [];
                this.container.querySelectorAll(as).forEach((t) => {
                    ys[this.id].push(
                        new (class {
                            unload() {}
                            connectToggle() {
                                this.buttons.forEach((t) => {
                                    t.addEventListener(
                                        "click",
                                        function (t) {
                                            t.preventDefault(), this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1 }));
                                        }.bind(this)
                                    );
                                });
                            }
                            connectDrawer() {
                                this.drawer.addEventListener(
                                    "theme:drawer:toggle",
                                    function () {
                                        this.drawer.classList.contains(ms)
                                            ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !1 }))
                                            : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                                    }.bind(this)
                                ),
                                    this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)),
                                    this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this));
                            }
                            staggerChildAnimations() {
                                this.staggers.forEach((t) => {
                                    t.querySelectorAll(us).forEach((t, e) => {
                                        t.style.transitionDelay = 50 * e + 10 + "ms";
                                    });
                                });
                            }
                            closers() {
                                this.drawer.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.ESCAPE && (this.hideDrawer(), this.buttons[0].focus());
                                    }.bind(this)
                                ),
                                    this.underlay.addEventListener(
                                        "click",
                                        function () {
                                            this.hideDrawer();
                                        }.bind(this)
                                    );
                            }
                            showDrawer() {
                                this.drawer.classList.remove(gs),
                                    setTimeout(() => {
                                        this.buttons.forEach((t) => t.setAttribute("aria-expanded", !0)),
                                            this.drawer.classList.add(ms),
                                            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.drawerScrolls }));
                                        const t = this.drawer.querySelector(ps);
                                        li(this.drawer, { elementToFocus: t });
                                    }, 1);
                            }
                            hideDrawer() {
                                this.buttons.forEach((t) => t.setAttribute("aria-expanded", !0)),
                                    this.drawer.classList.remove(ms),
                                    this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                                    document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 })),
                                    ci(),
                                    setTimeout(() => {
                                        this.drawer.classList.contains(ms) || this.drawer.classList.add(gs);
                                    }, 800);
                            }
                            constructor(t) {
                                (this.drawer = t), (this.drawerScrolls = this.drawer.querySelector(ls)), (this.underlay = this.drawer.querySelector(cs)), (this.key = this.drawer.dataset.drawer);
                                const e = `[${ds}='${this.key}']`;
                                (this.buttons = document.querySelectorAll(e)), (this.staggers = this.drawer.querySelectorAll(hs)), this.connectToggle(), this.connectDrawer(), this.closers(), this.staggerChildAnimations();
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                ys[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        ws = "#shopify-section-announcement",
        bs = "data-header-transparent",
        vs = "[data-header-wrapper] header",
        Ss = "js__header__stuck",
        Es = "js__header__stuck--animated",
        Ls = "js__header__stuck--trigger-animation",
        Ts = "js__header__stuck__backdrop";
    let ks = {};
    const As = {
            onLoad() {
                ks = new (class {
                    unload() {
                        document.removeEventListener("theme:scroll", this.listen), document.removeEventListener("theme:scroll:up", this.scrollUpDirectional), document.removeEventListener("theme:scroll:down", this.scrollDownDirectional);
                    }
                    listen() {
                        (this.sticks || this.animated) &&
                            document.addEventListener("theme:scroll", (t) => {
                                t.detail.down
                                    ? (!this.currentlyStuck && t.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && t.detail.position > this.blur && this.addBlur())
                                    : (t.detail.position <= this.stickUp && this.unstickSimple(), t.detail.position <= this.blur && this.removeBlur());
                            }),
                            this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)), document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)));
                    }
                    stickSimple() {
                        this.animated && this.cls.add(Es), this.cls.add(Ss), this.wrapper.setAttribute(bs, !1), (this.currentlyStuck = !0);
                    }
                    unstickSimple() {
                        this.cls.remove(Ss), this.wrapper.setAttribute(bs, this.transparent), this.animated && this.cls.remove(Es), (this.currentlyStuck = !1);
                    }
                    scrollDownInit() {
                        window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur();
                    }
                    stickDirectional() {
                        this.cls.add(Ls);
                    }
                    unstickDirectional() {
                        this.cls.remove(Ls);
                    }
                    scrollDownDirectional() {
                        this.unstickDirectional();
                    }
                    scrollUpDirectional() {
                        window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional();
                    }
                    addBlur() {
                        this.cls.add(Ts), (this.currentlyBlurred = !0);
                    }
                    removeBlur() {
                        this.cls.remove(Ts), (this.currentlyBlurred = !1);
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.type = this.wrapper.dataset.headerSticky),
                            (this.transparent = this.wrapper.dataset.headerTransparent),
                            (this.sticks = "sticky" === this.type),
                            (this.animated = "directional" === this.type),
                            (this.currentlyStuck = !1),
                            (this.cls = this.wrapper.classList);
                        const e = document.querySelector(ws),
                            i = e ? e.clientHeight : 0,
                            s = document.querySelector(vs).clientHeight;
                        (this.blur = s + i), (this.stickDown = s + i), (this.stickUp = i), "false" !== this.wrapper.getAttribute(bs) && (this.blur = i), this.sticks && ((this.stickDown = i), this.scrollDownInit()), this.listen();
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof ks.unload && ks.unload();
            },
        },
        qs = "data-hover-disclosure-toggle",
        Cs = "[data-hover-disclosure]",
        Ps = "[data-top-link]",
        xs = "[data-header-wrapper]",
        $s = "[data-stagger]",
        Hs = "[data-stagger-first]",
        _s = "[data-stagger-second]",
        Is = "[data-grid-item], [data-header-image]",
        Ms = "is-visible",
        Ds = "meganav--visible",
        Ws = "grandparent";
    let Bs = {},
        Fs = {};
    const Os = {
            onLoad() {
                (Bs[this.id] = []),
                    (Fs = this.container.querySelectorAll(Cs)),
                    Fs.forEach((t) => {
                        Bs[this.id].push(
                            new (class {
                                onBlockSelect(t) {
                                    this.disclosure.contains(t.target) && this.showDisclosure();
                                }
                                onBlockDeselect(t) {
                                    this.disclosure.contains(t.target) && this.hideDisclosure();
                                }
                                showDisclosure() {
                                    this.grandparent ? this.wrapper.classList.add(Ds) : this.wrapper.classList.remove(Ds), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(Ms), this.disclosure.classList.add(Ms);
                                }
                                hideDisclosure() {
                                    this.disclosure.classList.remove(Ms), this.trigger.classList.remove(Ms), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(Ds);
                                }
                                staggerChildAnimations() {
                                    this.disclosure.querySelectorAll($s).forEach((t, e) => {
                                        t.style.transitionDelay = 50 * e + 10 + "ms";
                                    }),
                                        this.disclosure.querySelectorAll(Hs).forEach((t, e) => {
                                            const i = 150 * e;
                                            (t.style.transitionDelay = `${i}ms`),
                                                t.parentElement.querySelectorAll(_s).forEach((t, e) => {
                                                    const s = 20 * (e + 1);
                                                    t.style.transitionDelay = `${i + s}ms`;
                                                });
                                        }),
                                        this.disclosure.querySelectorAll(Is).forEach((t, e) => {
                                            t.style.transitionDelay = 80 * (e + 1) + "ms";
                                        });
                                }
                                handleTablets() {
                                    this.trigger.addEventListener(
                                        "touchstart",
                                        function (t) {
                                            this.disclosure.classList.contains(Ms) || (t.preventDefault(), this.showDisclosure());
                                        }.bind(this),
                                        { passive: !0 }
                                    );
                                }
                                connectHoverToggle() {
                                    this.trigger.addEventListener("mouseenter", this.showDisclosure.bind(this)),
                                        this.link.addEventListener("focus", this.showDisclosure.bind(this)),
                                        this.trigger.addEventListener("mouseleave", this.hideDisclosure.bind(this)),
                                        this.trigger.addEventListener(
                                            "focusout",
                                            function (t) {
                                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                            }.bind(this)
                                        ),
                                        this.disclosure.addEventListener(
                                            "keyup",
                                            function (t) {
                                                t.which === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                                            }.bind(this)
                                        );
                                }
                                constructor(t) {
                                    (this.disclosure = t), (this.wrapper = t.closest(xs)), (this.key = this.disclosure.id);
                                    const e = `[${qs}='${this.key}']`;
                                    (this.trigger = document.querySelector(e)),
                                        (this.link = this.trigger.querySelector(Ps)),
                                        (this.grandparent = this.trigger.classList.contains(Ws)),
                                        this.trigger.setAttribute("aria-haspopup", !0),
                                        this.trigger.setAttribute("aria-expanded", !1),
                                        this.trigger.setAttribute("aria-controls", this.key),
                                        this.connectHoverToggle(),
                                        this.handleTablets(),
                                        this.staggerChildAnimations();
                                }
                            })(t)
                        );
                    });
            },
            onBlockSelect(t) {
                Bs[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Bs[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
            onUnload: function () {
                Bs[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Ns = "[data-main-menu-text-item]",
        zs = "[data-text-items-wrapper]",
        Rs = ".navtext",
        js = "data-menu-active",
        Vs = "[data-header-wrapper]",
        Us = "data-underline-current",
        Js = ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
    let Ks = {},
        Ys = null;
    const Gs = {
            onLoad() {
                Ks[this.id] = [];
                this.container.querySelectorAll(zs).forEach((t) => {
                    Ks[this.id].push(
                        new (class {
                            init() {
                                if (this.itemList.length) {
                                    if ((this.listen(), this.listenResize(), (this.textBottom = null), this.setHeight(), Ys)) {
                                        if (this.defaultItem) {
                                            const t = this.defaultItem.offsetLeft || 0;
                                            this.sectionOuter.style.setProperty("--bar-left", `${t}px`);
                                        }
                                        this.reset();
                                    } else {
                                        const t = this.sectionOuter.querySelector(Ns).offsetLeft;
                                        this.sectionOuter.style.setProperty("--bar-left", `${t}px`), this.sectionOuter.style.setProperty("--bar-width", "0px");
                                    }
                                    this.sectionOuter.style.setProperty("--bar-opacity", "1");
                                }
                            }
                            unload() {
                                document.removeEventListener("theme:resize", this.reset), (Ys = null);
                            }
                            listenResize() {
                                document.addEventListener("theme:resize", this.reset.bind(this));
                            }
                            setDefault() {
                                this.defaultItem && (Ys = { left: this.defaultItem.offsetLeft || null, width: this.defaultItem.clientWidth || null });
                            }
                            setHeight() {
                                const t = this.wrapper.clientHeight,
                                    e = this.itemList[0].querySelector(Rs).clientHeight,
                                    i = Math.floor(t / 2 - e / 2) - 4;
                                this.textBottom !== i && (this.sectionOuter.style.setProperty("--bar-text", `${e}px`), this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`), (this.textBottom = i));
                            }
                            listen() {
                                this.itemList.forEach((t) => {
                                    t.addEventListener("mouseenter", (t) => {
                                        const e = t.target.querySelector(Rs);
                                        this.startBar(e);
                                    });
                                }),
                                    this.wrapper.addEventListener("mouseleave", this.clearBar.bind(this));
                            }
                            startBar(t) {
                                this.setHeight();
                                let e = "false" !== this.sectionOuter.getAttribute(js),
                                    i = t.offsetLeft,
                                    s = t.clientWidth;
                                e
                                    ? this.render(s, i)
                                    : (this.sectionOuter.setAttribute(js, !0),
                                      this.render(0, i),
                                      setTimeout(() => {
                                          this.render(s, i);
                                      }, 10));
                            }
                            render(t, e) {
                                this.sectionOuter.style.setProperty("--bar-left", `${e}px`), this.sectionOuter.style.setProperty("--bar-width", `${t}px`);
                            }
                            reset() {
                                this.setDefault(),
                                    Ys && Ys.left && Ys.width
                                        ? (this.sectionOuter.style.setProperty("--bar-left", `${Ys.left}px`), this.sectionOuter.style.setProperty("--bar-width", `${Ys.width}px`))
                                        : this.sectionOuter.style.setProperty("--bar-width", "0px");
                            }
                            clearBar() {
                                this.sectionOuter.setAttribute(js, !1),
                                    setTimeout(() => {
                                        "false" !== this.sectionOuter.getAttribute(js) || this.reset();
                                    }, 150);
                            }
                            constructor(t) {
                                (this.wrapper = t),
                                    (this.itemList = this.wrapper.querySelectorAll(Ns)),
                                    (this.sectionOuter = document.querySelector(Vs)),
                                    (this.underlineCurrent = "true" === this.sectionOuter.getAttribute(Us)),
                                    (this.defaultItem = null),
                                    this.underlineCurrent && (this.defaultItem = this.wrapper.querySelector(Js)),
                                    this.setDefault(),
                                    document.fonts.ready.then(() => {
                                        this.init();
                                    });
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                Ks[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                }),
                    delete Ks[this.id];
            },
        },
        Xs = "data-header-cart-price",
        Qs = "data-header-cart-count",
        Zs = "data-header-cart-full";
    const to = {
            onLoad() {
                new (class {
                    listen() {
                        document.addEventListener(
                            "theme:cart:change",
                            function (t) {
                                (this.cart = t.detail.cart), this.update();
                            }.bind(this)
                        );
                    }
                    update() {
                        this.cart &&
                            (this.prices.forEach((t) => {
                                t.setAttribute(Xs, this.cart.total_price);
                                const e = a.formatMoney(this.cart.total_price, theme.moneyFormat);
                                t.innerHTML = e;
                            }),
                            this.counts.forEach((t) => {
                                t.setAttribute(Qs, this.cart.item_count), (t.innerHTML = `(${this.cart.item_count})`);
                            }),
                            this.dots.forEach((t) => {
                                const e = this.cart.item_count > 0;
                                t.setAttribute(Zs, e);
                            }));
                    }
                    constructor(t) {
                        (this.section = t),
                            (this.counts = this.section.querySelectorAll(`[${Qs}]`)),
                            (this.prices = this.section.querySelectorAll(`[${Xs}]`)),
                            (this.dots = this.section.querySelectorAll(`[${Zs}]`)),
                            (this.cart = null),
                            this.listen();
                    }
                })(this.container);
            },
        },
        eo = "[data-search-popdown-wrap]",
        io = "data-popdown-toggle",
        so = "[data-close-popdown]",
        oo = "[data-predictive-search-input]",
        ro = "[data-search-underlay]",
        no = "underlay--visible",
        ao = "is-visible";
    let lo = {};
    const co = {
            onLoad() {
                lo[this.id] = {};
                const t = this.container.querySelector(`[${io}]`);
                t &&
                    (lo[this.id] = new (class {
                        initTriggerEvents() {
                            this.trigger.setAttribute("aria-haspopup", !0),
                                this.trigger.setAttribute("aria-expanded", !1),
                                this.trigger.setAttribute("aria-controls", this.key),
                                this.trigger.addEventListener(
                                    "click",
                                    function (t) {
                                        t.preventDefault(), this.showPopdown();
                                    }.bind(this)
                                ),
                                this.trigger.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.SPACE && this.showPopdown();
                                    }.bind(this)
                                );
                        }
                        initPopdownEvents() {
                            this.popdown.addEventListener(
                                "keyup",
                                function (t) {
                                    t.which === window.theme.keyboardKeys.ESCAPE && this.hidePopdown();
                                }.bind(this)
                            ),
                                this.close.addEventListener(
                                    "click",
                                    function () {
                                        this.hidePopdown();
                                    }.bind(this)
                                ),
                                this.underlay.addEventListener(
                                    "click",
                                    function () {
                                        this.hidePopdown();
                                    }.bind(this)
                                );
                        }
                        hidePopdown() {
                            this.popdown.classList.remove(ao),
                                this.underlay.classList.remove(no),
                                this.trigger.focus(),
                                (this.input.value = ""),
                                ci(),
                                this.input.dispatchEvent(new CustomEvent("theme:search:clear", { bubbles: !1 })),
                                this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }
                        showPopdown() {
                            (this.input.value = ""),
                                this.popdown.classList.add(ao),
                                this.underlay.classList.add(no),
                                li(this.popdown, { elementToFocus: this.input }),
                                this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                        }
                        constructor(t) {
                            (this.trigger = t),
                                (this.key = this.trigger.getAttribute(io)),
                                (this.popdown = document.querySelector(`[id='${this.key}']`)),
                                (this.input = this.popdown.querySelector(oo)),
                                (this.close = this.popdown.querySelector(so)),
                                (this.wrapper = this.popdown.closest(eo)),
                                (this.underlay = this.wrapper.querySelector(ro)),
                                this.initTriggerEvents(),
                                this.initPopdownEvents();
                        }
                    })(t));
            },
            onUnload: function () {
                "function" == typeof lo[this.id].unload && lo[this.id].unload();
            },
        },
        ho = "[data-grid-link]",
        uo = "data-grid-images",
        po = "data-grid-image",
        mo = "data-grid-image-target",
        go = "data-grid-image-target-default",
        yo = "data-grid-pagination",
        fo = "data-grid-page",
        wo = "data-sibling-product",
        bo = "data-sibling-index",
        vo = "data-sibling-fetch-index",
        So = "data-sibling-id",
        Eo = "data-upsell",
        Lo = "data-upsell-holder",
        To = "data-stop-slideshow-mobile",
        ko = "data-popup-",
        Ao = "--width",
        qo = "is-active",
        Co = "is-fade",
        Po = "is-slideshow",
        xo = "is-mobile",
        $o = "siblings__link--current",
        Ho = "product-grid-item__pagination",
        _o = "product-grid-item__image",
        Io = 1500;
    let Mo = class extends HTMLElement {
        connectedCallback() {
            this.images.length > 1 &&
                (this.createPaging(),
                this.container.addEventListener("theme:swatch:change", (t) => {
                    const e = t.detail.id,
                        i = this.container.querySelector(`[${mo}="${e}"]`);
                    if (i) {
                        const e = i.getAttribute(po);
                        (this.pagingProgressCounter = 0), this.changeImage(e), t.detail.stopSlideAnimation && this.stopPaging();
                    }
                })),
                (this.images.length > 1 || (this.siblingProducts.length && this.imagesHolder && this.imagesLimit > 1)) &&
                    (this.mobileStopSlideshow && (this.checkMobile(), document.addEventListener("theme:resize:width", () => this.checkMobile())),
                    this.container.addEventListener("mouseenter", () => {
                        (this.pagingProgressPause = this.mobileStopProgress), this.progressPaging();
                    }),
                    this.container.addEventListener("mouseleave", () => {
                        (this.pagingProgressPause = !0), this.progressPaging();
                    })),
                this.siblingProducts.length &&
                    this.imagesHolder &&
                    this.siblingProducts.forEach((t) => {
                        t.hasAttribute(wo) && (this.siblingHoverEvent(t), this.siblingClickEvent(t));
                    });
        }
        checkMobile() {
            const t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            (this.mobileStopProgress = t < window.theme.sizes.medium), this.container.classList.toggle(xo, this.mobileStopProgress);
        }
        siblingHoverEvent(t) {
            t.addEventListener("mouseenter", () => {
                if (!t.hasAttribute(vo)) {
                    Et(t.getAttribute(wo)).then((e) => {
                        t.setAttribute(vo, this.siblingsFetchCounter),
                            this.siblingProductsArr.push(e),
                            t.hasAttribute(bo) &&
                                this.siblingLoadImageIndex === parseInt(t.getAttribute(bo)) &&
                                (this.siblingImagesCreate(this.siblingProductsArr[this.siblingsFetchCounter]), this.imagesHolder.setAttribute(vo, this.siblingsFetchCounter), (this.siblingLoadImageIndex = null)),
                            this.siblingsFetchCounter++;
                    });
                }
            });
        }
        siblingClickEvent(t) {
            t.addEventListener("click", (e) => {
                e.preventDefault();
                const i = this.container.querySelector(`[${wo}].${$o}`);
                if ((i && i.classList.remove($o), (this.siblingLoadImageIndex = null), t.classList.add($o), t.hasAttribute(vo) && this.imagesHolder.hasAttribute(vo) && t.getAttribute(vo) === this.imagesHolder.getAttribute(vo)))
                    return (this.pagingProgressCounter = 0), void this.changeImage(0);
                if (t.hasAttribute(vo) && this.siblingProductsArr.length) {
                    const e = parseInt(t.getAttribute(vo));
                    this.imagesHolder.setAttribute(vo, e), this.siblingImagesCreate(this.siblingProductsArr[e]);
                } else t.hasAttribute(bo) && (this.siblingLoadImageIndex = parseInt(t.getAttribute(bo)));
                this.links.length &&
                    this.links.forEach((e) => {
                        e.href = t.href;
                    });
                const s = this.container.querySelector(`[${Eo}]`),
                    o = this.container.querySelector(`[${Lo}]`);
                if (s && o && t.hasAttribute(So) && t.hasAttribute(wo)) {
                    const e = t.getAttribute(So),
                        i = s.getAttribute(Eo),
                        r = this.container.querySelector(`[${ko}${i}]`);
                    o.setAttribute(Lo, e), r && (r.removeAttribute(`${ko}${i}`), r.setAttribute(`${ko}${e}`, t.getAttribute(wo))), s.setAttribute(Eo, e);
                }
            });
        }
        siblingImagesCreate(t) {
            if (!t) return;
            const e = t.media;
            let i = "";
            if (e && e.length) {
                const t = window.devicePixelRatio || 1,
                    s = this.imagesHolder.offsetWidth * t,
                    o = 180 * Math.ceil(s / 180);
                for (const [t, s] of e.entries()) {
                    const e = ut(s.preview_image.src, `${o}x`);
                    let r = "";
                    if ((0 === t && (r = ` ${qo}`), (i += `<div class="${_o}${r}" ${po}="${t}" ${mo}="${s.id}" ${go}="${s.id}" style="background-color: #fff; background-image: url('${e}');">&nbsp;</div>`), t + 1 === this.imagesLimit))
                        break;
                }
            }
            (this.imagesHolder.innerHTML = i), (this.images = this.container.querySelectorAll(`[${po}]`)), this.container.classList.toggle(Po, this.images.length > 1), this.imagesHolder.classList.add(Co);
            const s = 1e3 * parseFloat(window.getComputedStyle(this.imagesHolder).getPropertyValue("animation-duration"));
            setTimeout(() => {
                this.imagesHolder.classList.remove(Co);
            }, s),
                this.images.length > 1 ? (this.createPaging(), (this.pagingProgressCounter = 0), this.progressPaging()) : (this.stopPaging(), this.removePaging());
        }
        changeImage(t = null) {
            const e = this.container.querySelector(`[${po}].${qo}`),
                i = null !== t ? this.images[t] : e.nextSibling ? e.nextSibling : this.images[0];
            if ((e && e.classList.remove(qo), i)) {
                const t = i.hasAttribute(po) ? i.getAttribute(po) : 0;
                i.classList.add(qo), this.changePaging(t);
            }
        }
        changePaging(t = 0) {
            const e = this.container.querySelector(`[${fo}].${qo}`),
                i = this.container.querySelector(`[${fo}="${t}"]`);
            e && (e.style.setProperty(Ao, "100%"), e.classList.remove(qo)), i && (i.classList.add(qo), this.progressPaging());
        }
        progressPaging() {
            const t = this.container.querySelector(`[${fo}].${qo}`);
            t &&
                !this.mobileStopProgress &&
                (this.stopPaging(),
                0 === this.pagingProgressCounter && t.style.setProperty(Ao, "0%"),
                (this.interval = setInterval(() => {
                    this.pagingProgressCounter >= 100 && !this.pagingProgressPause
                        ? (this.stopPaging(), (this.pagingProgressCounter = 0), this.changeImage())
                        : this.pagingProgressPause || (this.pagingProgressCounter++, t.style.setProperty(Ao, `${this.pagingProgressCounter}%`));
                }, this.timeout / 100)));
        }
        stopPaging() {
            this.interval && clearInterval(this.interval);
        }
        createPaging() {
            if (this.imagesHolder) {
                let t = "";
                for (let e = 0; e < this.images.length; e++) {
                    let i = "";
                    0 === e && (i = `class="${qo}"`), (t += `<span ${i} ${fo}="${e}">${e + 1}</span>`);
                }
                if ("" !== t) {
                    let e = this.container.querySelector(`[${yo}]`);
                    e || ((e = document.createElement("div")), (e.className = Ho), e.setAttribute(yo, "")), (e.innerHTML = t), this.imagesHolder.parentElement.prepend(e);
                }
            }
        }
        removePaging() {
            const t = this.container.querySelector(`[${yo}]`);
            t && t.remove();
        }
        constructor() {
            super(),
                (this.container = this),
                (this.mobileStopSlideshow = "true" === this.container.getAttribute(To)),
                (this.imagesHolder = this.container.querySelector(`[${uo}]`)),
                (this.images = this.container.querySelectorAll(`[${po}]`)),
                (this.links = this.container.querySelectorAll(ho)),
                (this.siblingProducts = this.container.querySelectorAll(`[${wo}]`)),
                (this.imagesLimit = this.imagesHolder && this.imagesHolder.hasAttribute(uo) ? parseInt(this.imagesHolder.getAttribute(uo)) : 5),
                (this.timeout = Io),
                (this.interval = null),
                (this.mobileStopProgress = !1),
                (this.pagingProgressPause = !1),
                (this.pagingProgressCounter = 0),
                (this.siblingProductsArr = []),
                (this.siblingsFetchCounter = 0),
                (this.siblingLoadImageIndex = null);
        }
    };
    const Do = "[data-popout]",
        Wo = "[data-popout-list]",
        Bo = "data-popout-list-scroll",
        Fo = "data-popout-toggle",
        Oo = "[data-popout-input]",
        No = "[data-popout-option]",
        zo = "data-popout-prevent",
        Ro = "data-quantity-field",
        jo = "data-value",
        Vo = "aria-expanded",
        Uo = "aria-current",
        Jo = "popout-list--visible",
        Ko = "--current";
    let Yo = class extends HTMLElement {
        unload() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((t) => {
                    t.removeEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.removeEventListener("click", this._connectOptionsDispatch.bind(this));
                }),
                this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)),
                this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.removeEventListener("keyup", this.containerKeyup.bind(this)),
                this.outsidePopupToggle && (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)));
        }
        popupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute(Vo);
            t.currentTarget.setAttribute(Vo, !e),
                this.popoutList.classList.toggle(Jo),
                this.popupListMaxWidth(),
                this.popoutList.hasAttribute(Bo) &&
                    setTimeout(() => {
                        this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                    }, 1);
        }
        popupToggleFocusout(t) {
            this.container.contains(t.relatedTarget) || this._hideList();
        }
        popupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains(Jo) && !e && this._hideList();
        }
        popupListMaxWidth() {
            this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`;
        }
        popupOptionsClick(t) {
            if ("#" === t.target.closest(No).attributes.href.value) {
                t.preventDefault();
                let e = "";
                if ((t.currentTarget.getAttribute(jo) && (e = t.currentTarget.getAttribute(jo)), (this.popoutInput.value = e), this.popoutPrevent)) {
                    this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(Ro) && this.popoutInput.dispatchEvent(new Event("input"));
                    const i = this.popoutList.querySelector(`[class*="${Ko}"]`);
                    let s = Ko;
                    if (i && i.classList.length)
                        for (const t of i.classList)
                            if (t.includes(Ko)) {
                                s = t;
                                break;
                            }
                    const o = this.popoutList.querySelector(`.${s}`);
                    o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                    const r = this.popoutList.querySelector(`[${Uo}]`);
                    r && r.hasAttribute(`${Uo}`) && (r.removeAttribute(`${Uo}`), t.currentTarget.setAttribute(`${Uo}`, "true")),
                        "" !== e && ((this.popoutToggle.textContent = e), this.outsidePopupToggle && (this.outsidePopupToggle.textContent = e)),
                        this.popupToggleFocusout(t),
                        this.popupListFocusout(t);
                } else this._submitForm(e);
            }
        }
        updatePopout(t) {
            const e = this.popoutList.querySelector(`[${jo}="${this.popoutInput.value}"]`);
            e && e.dispatchEvent(new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !0 } }));
        }
        containerKeyup(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
        }
        bodyClick(t) {
            const e = this.container.contains(t.target),
                i = this.popoutList.classList.contains(Jo);
            this.outsidePopupToggle, t.target, i && !e && this._hideList();
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this));
        }
        _connectOptions() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((t) => {
                    t.addEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.addEventListener("click", this._connectOptionsDispatch.bind(this));
                });
        }
        _connectOptionsDispatch(t) {
            const e = new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !1 } });
            t.target.dispatchEvent(e) || t.preventDefault();
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.addEventListener("keyup", this.containerKeyup.bind(this)),
                document.body.addEventListener("click", this.bodyClick.bind(this));
        }
        _submitForm(t) {
            const e = this.container.closest("form");
            e && e.submit();
        }
        _hideList() {
            this.popoutList.classList.remove(Jo), this.popoutToggle.setAttribute(Vo, !1), this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(Vo, !1);
        }
        constructor() {
            super(),
                (this.container = this.querySelector(Do)),
                (this.popoutList = this.container.querySelector(Wo)),
                (this.popoutToggle = this.container.querySelector(`[${Fo}]`)),
                (this.outsidePopupToggle = document.querySelector(`[${Fo}="${this.popoutList.id}"]`)),
                (this.popoutInput = this.container.querySelector(Oo)),
                (this.popoutOptions = this.container.querySelectorAll(No)),
                (this.popoutPrevent = "true" === this.container.getAttribute(zo)),
                this._connectOptions(),
                this._connectToggle(),
                this._onFocusOut(),
                this.popupListMaxWidth(),
                this.popoutInput && this.popoutInput.hasAttribute(Ro) && document.addEventListener("theme:popout:update", this.updatePopout.bind(this)),
                document.addEventListener("theme:resize", () => {
                    this.popupListMaxWidth();
                });
        }
    };
    const Go = (t, e = 500, i = !0) => {
            let s = window.getComputedStyle(t).display;
            if (i && "none" !== s) return;
            t.style.removeProperty("display"), "none" === s && (s = "block"), (t.style.display = s);
            let o = t.offsetHeight;
            (t.style.overflow = "hidden"),
                (t.style.height = 0),
                (t.style.paddingTop = 0),
                (t.style.paddingBottom = 0),
                (t.style.marginTop = 0),
                (t.style.marginBottom = 0),
                t.offsetHeight,
                (t.style.boxSizing = "border-box"),
                (t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (t.style.transitionProperty = "height, margin, padding"),
                (t.style.transitionDuration = e + "ms"),
                (t.style.height = o + "px"),
                t.style.removeProperty("padding-top"),
                t.style.removeProperty("padding-bottom"),
                t.style.removeProperty("margin-top"),
                t.style.removeProperty("margin-bottom"),
                window.setTimeout(() => {
                    t.style.removeProperty("height"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property"), t.style.removeProperty("transition-timing-function");
                }, e);
        },
        Xo = (t, e = 500) => {
            (t.style.transitionProperty = "height, margin, padding"),
                (t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (t.style.transitionDuration = e + "ms"),
                (t.style.boxSizing = "border-box"),
                (t.style.height = t.offsetHeight + "px"),
                t.offsetHeight,
                (t.style.overflow = "hidden"),
                (t.style.height = 0),
                (t.style.paddingTop = 0),
                (t.style.paddingBottom = 0),
                (t.style.marginTop = 0),
                (t.style.marginBottom = 0),
                window.setTimeout(() => {
                    (t.style.display = "none"),
                        t.style.removeProperty("height"),
                        t.style.removeProperty("padding-top"),
                        t.style.removeProperty("padding-bottom"),
                        t.style.removeProperty("margin-top"),
                        t.style.removeProperty("margin-bottom"),
                        t.style.removeProperty("overflow"),
                        t.style.removeProperty("transition-duration"),
                        t.style.removeProperty("transition-property"),
                        t.style.removeProperty("transition-timing-function");
                }, e);
        };
    let Qo = {};
    const Zo = "[data-add-action-wrapper]",
        tr = "[data-add-to-cart]",
        er = "[data-add-action-errors]",
        ir = "data-add-to-cart-variant",
        sr = "[data-product-add-popdown-wrapper]",
        or = '[data-ajax-disable="true"]',
        rr = "[data-upsell-modal]",
        nr = "[data-product-form]",
        ar = "[data-form-holder]",
        lr = '[type="file"]',
        cr = "loading",
        hr = "has-success",
        dr = 3500,
        ur = 5e3;
    let pr = class {
        initWithForm() {
            this.button.addEventListener(
                "click",
                function (t) {
                    t.preventDefault();
                    const e = t.target.closest(ar).querySelector(nr);
                    if (e.querySelector(lr)) return;
                    this.disabledAjax || t.preventDefault(), this.button.setAttribute("disabled", !0), this.button.classList.add(cr);
                    const i = new FormData(e),
                        s = new URLSearchParams(i).toString();
                    this.addToCartAction(s);
                }.bind(this)
            );
        }
        initDetached() {
            this.button.addEventListener(
                "click",
                function (t) {
                    this.disabledAjax || t.preventDefault(), this.button.setAttribute("disabled", !0), this.button.classList.add(cr);
                    const e = `form_type=product&id=${this.button.getAttribute(ir)}`;
                    this.addToCartAction(e);
                }.bind(this)
            );
        }
        addToCartAction(t) {
            const e = `${window.theme.routes.cart}/add.js`,
                i = this;
            l.post(e, t, { headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/x-www-form-urlencoded" } })
                .then(function (t) {
                    i.onSuccess(t.data);
                })
                .catch(function (t) {
                    console.warn(t), i.onError(t.data);
                });
        }
        onSuccess(t) {
            this.updateHeaderTotal(),
                this.button.classList.remove(cr),
                this.button.classList.add(hr),
                setTimeout(() => {
                    this.button.classList.remove(hr), this.button.removeAttribute("disabled");
                }, dr),
                this.button.closest(rr) && this.button.closest(rr).dispatchEvent(new CustomEvent("theme:upsell:close")),
                this.isCartItem ? document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 })) : this.popdown.dispatchEvent(new CustomEvent("theme:cart:popdown", { detail: { variant: t }, bubbles: !0 })),
                this.disabledAjax && window.location.reload();
        }
        onError(t) {
            let e = "Network error: please try again";
            t && t.description && (e = t.description);
            const i = `<div class="errors">${e}</div>`;
            this.button.classList.remove(cr),
                this.button.removeAttribute("disabled"),
                (this.errors.innerHTML = i),
                Go(this.errors),
                setTimeout(() => {
                    Xo(this.errors);
                }, ur);
        }
        updateHeaderTotal() {
            l.get(`${window.theme.routes.cart}.js`)
                .then((t) => {
                    document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t.data }, bubbles: !0 }));
                })
                .catch((t) => {
                    console.error(t);
                });
        }
        constructor(t, e) {
            if (
                ((this.wrapper = t),
                (this.isCartItem = e || !1),
                (this.button = this.wrapper.querySelector(tr)),
                (this.errors = this.wrapper.querySelector(er)),
                (this.popdown = document.querySelector(sr)),
                (this.disabledAjax = document.querySelector(or)),
                this.button)
            ) {
                this.button.hasAttribute(ir) ? this.initDetached() : this.initWithForm();
            }
        }
    };
    const mr = {
            onLoad() {
                Qo[this.id] = [];
                this.container.querySelectorAll(Zo).forEach((t) => {
                    Qo[this.id].push(new pr(t));
                });
            },
            onUnload: function () {
                Qo[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        gr = (t, e) => {
            let i, s;
            return function o(...r) {
                const n = Date.now();
                (s = clearTimeout(s)), !i || n - i >= e ? (t.apply(null, r), (i = n)) : (s = setTimeout(o.bind(null, ...r), e - (n - i)));
            };
        },
        yr = "[data-size-button]",
        fr = "[data-media-slide]",
        wr = "is-expanded";
    let br = class {
        init() {
            this.sizeButtons.forEach((t) => {
                t.addEventListener("click", () => {
                    t.classList.toggle(wr), t.closest(fr).classList.toggle(wr);
                });
            });
        }
        constructor(t) {
            (this.container = t), (this.sizeButtons = this.container.querySelectorAll(yr)), this.sizeButtons.length > 0 && this.init();
        }
    };
    const vr = "data-upsell",
        Sr = "data-upsell-holder",
        Er = "[data-add-action-wrapper]",
        Lr = "[data-product-upsell-ajax]",
        Tr = "[data-upsell-modal]",
        kr = "[data-drawer-scrolls]",
        Ar = "[data-upsell-modal-template]",
        qr = "[data-upsell-head]",
        Cr = "[data-upsell-form-area]",
        Pr = "[data-toggle-button]",
        xr = "[data-media-slide]",
        $r = "[data-media-id]",
        Hr = "[data-line-items]",
        _r = "data-popup-",
        Ir = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Mr = "hide",
        Dr = "is-active",
        Wr = "is-expanded",
        Br = "loading",
        Fr = 250,
        Or = 400;
    let Nr = class extends HTMLElement {
        static get observedAttributes() {
            return [vr];
        }
        attributeChangedCallback(t, e, i) {
            e && (this.disconnectedCallback(), this.connectedCallback());
        }
        connectedCallback() {
            if (((this.upsellHolder = this.container.querySelector(`[${Sr}]`)), (this.modalCloseEvent = () => this.modalClose()), (this.clickUpsellEvent = (t) => this.clickUpsellButton(t)), this.upsellHolder)) {
                if (
                    ((this.isCartItem = Boolean(this.upsellHolder.closest(Hr))),
                    (this.modalTemplate = this.upsellHolder.querySelector(Ar)),
                    (this.modal = document.querySelector(Tr)),
                    (this.modalID = this.upsellHolder.getAttribute(Sr)),
                    (this.modalContent = null),
                    (this.modalScroll = null),
                    (this.scrollLockEnable = !0),
                    (this.windowH = window.innerHeight),
                    (this.triggerButton = this.upsellHolder.querySelector(`[${_r}${this.modalID}]`)),
                    (this.handle = this.triggerButton ? this.triggerButton.getAttribute(`${_r}${this.modalID}`) : null),
                    this.modalTemplate && !this.modal)
                ) {
                    const t = this.modalTemplate.innerHTML,
                        e = document.createElement("div");
                    (e.innerHTML = t), (this.modalHtml = e.querySelector(Tr)), document.body.appendChild(this.modalHtml), (this.modal = document.querySelector(Tr));
                }
                this.modalTemplate && this.triggerButton && this.triggerButton.addEventListener("click", this.clickUpsellEvent), this.isCartItem && new pr(this.upsellHolder, this.isCartItem);
            }
        }
        clickUpsellButton(t) {
            t.preventDefault(), this.modal && this.modalID && (this.modal.id = this.modalID), document.documentElement.hasAttribute("data-scroll-locked") && (this.scrollLockEnable = !1), this.getUpsellHTML();
        }
        getUpsellHTML() {
            window
                .fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-upsell`)
                .then(this.handleErrors)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    (e.innerHTML = t), (this.modalContent = this.modal.querySelector(Lr)), (this.modalContent.innerHTML = e.querySelector("[data-api-content]").innerHTML), (this.modalScroll = this.modal.querySelector(kr));
                    const i = this.modalContent.querySelector($r);
                    if (i) {
                        const t = document.createElement("div");
                        (t.innerHTML = i.parentElement.innerHTML), this.upsellHolder.dispatchEvent(new CustomEvent("theme:upsell:media", { bubbles: !0, detail: { media: t } }));
                    }
                    this.modalCreate();
                });
        }
        modalCreate() {
            r.show(this.modalID, {
                onShow: (t, e, i) => {
                    (this.upsellHead = t.querySelector(qr)),
                        (this.upsellFormArea = t.querySelector(Cr)),
                        (this.toggleButton = t.querySelector(Pr)),
                        this.toggleForm("loading"),
                        document.addEventListener(
                            "theme:resize",
                            gr(() => {
                                this.toggleForm("resize");
                            }, 500)
                        ),
                        this.clickEventToggleForm();
                    const s = t.querySelector(Er);
                    new pr(s, this.isCartItem);
                    const o = t.querySelector(Ir);
                    li(t, { elementToFocus: o }),
                        this.modal.addEventListener("theme:upsell:close", this.modalCloseEvent),
                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.modalScroll })),
                        new br(this.modal);
                },
                onClose: (t, e, i) => {
                    t.querySelectorAll(xr).forEach((t) => {
                        t.dispatchEvent(new CustomEvent("pause"));
                    }),
                        ci(),
                        e.focus(),
                        this.modal.removeEventListener("theme:upsell:close", this.modalCloseEvent),
                        this.scrollLockEnable ? document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })) : (this.scrollLockEnable = !0);
                },
            });
        }
        modalClose() {
            r.close(this.modalID);
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new B({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        toggleForm(t) {
            (this.windowH === window.innerHeight && "resize" === t) ||
                (this.toggleButton.classList.contains(Mr) || this.toggleButton.classList.add(Mr),
                this.upsellFormArea.classList.contains(Wr) || this.upsellFormArea.classList.add(Wr),
                "resize" === t && (this.upsellFormArea.classList.add(Wr), this.toggleButton.classList.add(Mr), (this.windowH = window.innerHeight)),
                setTimeout(() => {
                    const e = window.innerHeight - this.upsellHead.offsetHeight - this.upsellFormArea.offsetHeight,
                        i = e < Fr;
                    (e < Or && e > Fr) || i ? (this.toggleButton.classList.remove(Mr), this.toggleButton.classList.add(Dr)) : this.toggleButton.classList.add(Mr),
                        i
                            ? ("loading" === t &&
                                  (this.upsellFormArea.classList.add(Br),
                                  setTimeout(() => {
                                      this.upsellFormArea.classList.remove(Br);
                                  }, 50)),
                              this.upsellFormArea.classList.remove(Wr),
                              this.toggleButton.classList.remove(Dr))
                            : this.upsellFormArea.classList.add(Wr);
                }, 200));
        }
        clickEventToggleForm() {
            this.toggleButton &&
                this.toggleButton.addEventListener("click", () => {
                    this.toggleButton.classList.toggle(Dr), this.upsellFormArea.classList.toggle(Wr);
                });
        }
        disconnectedCallback() {
            this.modalTemplate && this.triggerButton && this.triggerButton.removeEventListener("click", this.clickUpsellEvent);
        }
        constructor() {
            super(), (this.container = this);
        }
    };
    const zr = "[data-cart-note]";
    class Rr {
        initInputs() {
            this.inputs.forEach((t) => {
                t.addEventListener(
                    "change",
                    function (t) {
                        const e = t.target.value.toString() || "";
                        this.saveNotes(e);
                    }.bind(this)
                );
            });
        }
        saveNotes(t) {
            window.fetch(`${window.theme.routes.cart}/update.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ note: t }) }).catch((t) => {
                console.error(t);
            });
        }
        constructor(t) {
            (this.inputs = t.querySelectorAll(zr)), this.initInputs();
        }
    }
    const jr = (t, e = [], i = !1) => {
            const s = Object.keys(t)
                .map((s) => {
                    let o = t[s];
                    if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(s), jr(o, e, Array.isArray(o));
                    {
                        let t = s;
                        if (e.length > 0) {
                            t = (i ? e : [...e, s]).reduce((t, e) => ("" === t ? e : `${t}[${e}]`), "");
                        }
                        return i ? `${t}[]=${o}` : `${t}=${o}`;
                    }
                })
                .join("&");
            return e.pop(), s;
        },
        Vr = "html",
        Ur = "[data-submit-shipping]",
        Jr = "[data-shipping-estimate-form]",
        Kr = "[data-response-template]",
        Yr = "#estimate_address_country",
        Gr = "#estimate_address_province",
        Xr = "#estimate_address_zip",
        Qr = "[data-response-wrapper]",
        Zr = "lang",
        tn = "data-default",
        en = "shipping--success",
        sn = "errors",
        on = "disabled";
    class rn {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove(on);
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add(on);
        }
        render(t) {
            if (this.template && this.ratesWrapper) {
                const e = u.render(this.template, t);
                this.ratesWrapper.innerHTML = e;
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display");
        }
        estimate(t) {
            const e = encodeURI(jr({ shipping_address: t })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${e}`,
                s = this;
            l.get(i)
                .then(function (t) {
                    const e = s.sanitize(t);
                    s.render(e), s.enableButtons(), s.ratesWrapper.style.removeProperty("display");
                })
                .catch(function (t) {
                    const e = s.sanitizeErrors(t);
                    s.render(e);
                });
        }
        sanitize(t) {
            const e = {};
            if (((e.class = en), (e.items = []), t.data.shipping_rates && t.data.shipping_rates.length > 0)) {
                t.data.shipping_rates.forEach((t) => {
                    let i = {};
                    (i.title = t.presentment_name), (i.value = a.formatMoney(t.price, theme.moneyFormat)), e.items.push(i);
                });
            } else e.items[0] = { value: theme.strings.noShippingAvailable };
            return e;
        }
        sanitizeErrors(t) {
            const e = {};
            if (((e.class = sn), (e.items = []), "object" == typeof t.data))
                for (const [i, s] of Object.entries(t.data)) {
                    let t = {};
                    (t.title = i.toString()), (t.value = s.toString()), e.items.push(t);
                }
            else e.items[0] = { value: theme.strings.noShippingAvailable };
            return e;
        }
        init() {
            const t = document.querySelector(Vr);
            let e = "en";
            t.hasAttribute(Zr) && "" !== t.getAttribute(Zr) && (e = t.getAttribute(Zr)),
                this.form && c.AddressForm(this.form, e, { shippingCountriesOnly: !0 }),
                this.country &&
                    this.country.hasAttribute(tn) &&
                    this.province &&
                    this.province.hasAttribute(tn) &&
                    this.country.addEventListener("change", function () {
                        this.country.removeAttribute(tn), this.province.removeAttribute(tn);
                    }),
                this.button &&
                    this.button.addEventListener(
                        "click",
                        function (t) {
                            for (t.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild; ) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                            this.ratesWrapper.style.display = "none";
                            const e = {};
                            let i = this.country.value,
                                s = this.province.value;
                            const o = this.country.getAttribute(tn);
                            "" === i && o && "" !== o && (i = o);
                            const r = this.province.getAttribute(tn);
                            "" === s && r && "" !== r && (s = r), (e.zip = this.zip.value || ""), (e.country = i || ""), (e.province = s || ""), this.estimate(e);
                        }.bind(this)
                    );
        }
        constructor(t) {
            (this.button = t.container.querySelector(Ur)),
                (this.template = t.container.querySelector(Kr).innerHTML),
                (this.ratesWrapper = t.container.querySelector(Qr)),
                (this.form = t.container.querySelector(Jr)),
                (this.country = t.container.querySelector(Yr)),
                (this.province = t.container.querySelector(Gr)),
                (this.zip = t.container.querySelector(Xr)),
                this.init();
        }
    }
    const nn = "[data-quantity-selector]",
        an = "[data-increase-quantity]",
        ln = "[data-decrease-quantity]",
        cn = "[data-quantity-input]";
    function hn(t) {
        t.querySelectorAll(nn).forEach((t) => {
            new (class {
                initButtons() {
                    this.increase.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault();
                            let e = parseInt(this.input.value, 10);
                            (e = isNaN(e) ? 0 : e), e++, (this.input.value = e), this.input.dispatchEvent(new Event("change"));
                        }.bind(this)
                    ),
                        this.decrease.addEventListener(
                            "click",
                            function (t) {
                                t.preventDefault();
                                let e = parseInt(this.input.value, 10);
                                (e = isNaN(e) ? 0 : e), e--, (e = Math.max(this.min, e)), (this.input.value = e), this.input.dispatchEvent(new Event("change"));
                            }.bind(this)
                        );
                }
                constructor(t) {
                    (this.wrapper = t),
                        (this.increase = this.wrapper.querySelector(an)),
                        (this.decrease = this.wrapper.querySelector(ln)),
                        (this.input = this.wrapper.querySelector(cn)),
                        (this.min = parseInt(this.input.getAttribute("min"), 10)),
                        this.initButtons();
                }
            })(t);
        });
    }
    const dn = '[data-drawer="drawer-cart"]',
        un = "[data-shipping-estimate-form]",
        pn = "[data-cart-loading]",
        mn = "[data-cart-form]",
        gn = "[data-cart-empty]",
        yn = "[data-cart-progress]",
        fn = "[data-line-items]",
        wn = "[data-cart-subtotal]",
        bn = "[data-cart-bottom]",
        vn = "[data-form-errors]",
        Sn = "[data-cart-item]",
        En = "[data-cart-final]",
        Ln = "data-update-cart",
        Tn = "data-remove-key",
        kn = "[data-upsell-holder]",
        An = '[data-section-type="cart"]',
        qn = "[data-cart-bar]",
        Cn = "[data-cart-message]",
        Pn = "[data-item-loadbar]",
        xn = "[data-cart-message-container]",
        $n = "[data-api-content]",
        Hn = "cart--hidden",
        _n = "cart--loading";
    let In = class {
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (t) {
                    (this.cart = t.detail.cart), (this.stale = !0);
                }.bind(this)
            ),
                document.addEventListener(
                    "theme:cart:init",
                    function () {
                        this.init();
                    }.bind(this)
                ),
                document.addEventListener(
                    "theme:cart:reload",
                    function () {
                        (this.stale = !0), this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML());
                    }.bind(this)
                ),
                this.drawer &&
                    this.drawer.addEventListener(
                        "theme:drawer:open",
                        function () {
                            this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML());
                        }.bind(this)
                    ),
                new Rr(this.container),
                new Ni(this.container);
        }
        init() {
            return window
                .fetch(`${window.theme.routes.cart}.js`)
                .then(this.handleErrors)
                .then((t) => t.json())
                .then((t) => ((this.cart = t), this.fireChange(t), t))
                .catch((t) => {
                    console.error(t);
                });
        }
        loadHTML() {
            this.stale &&
                (this.cart && this.cart.item_count > 0
                    ? this.loadForm()
                    : (this.showEmpty(),
                      this.cartMessages.forEach((t) => {
                          new Ni(t);
                      }))),
                (this.stale = !1);
        }
        initInputs() {
            (this.inputs = this.container.querySelectorAll(`[${Ln}]`)),
                this.inputs.forEach((t) => {
                    const e = t.getAttribute(Ln);
                    t.addEventListener(
                        "change",
                        function (t) {
                            const i = parseInt(t.target.value, 10);
                            (this.latestClick = t.target.closest(Sn)), this.lockState(), this.updateCart(e, i);
                        }.bind(this)
                    );
                });
        }
        initRemove() {
            (this.removers = this.container.querySelectorAll(`[${Tn}]`)),
                this.removers.forEach((t) => {
                    const e = t.getAttribute(Tn);
                    t.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), (this.latestClick = t.target.closest(Sn)), this.lockState(), this.updateCart(e, 0);
                        }.bind(this)
                    );
                });
        }
        lockState() {
            (this.latestClick.querySelector(Pn).style.display = "block"), this.loader.classList.add(_n);
        }
        updateCart(t, e) {
            let i = null,
                s = null,
                o = null;
            window
                .fetch(`${window.theme.routes.cart}.js`)
                .then(this.handleErrors)
                .then((t) => t.json())
                .then((s) => {
                    const r = s.items.findIndex((e) => e.key === t);
                    (i = s.item_count), (o = s.items[r].title);
                    const n = { line: `${r + 1}`, quantity: e };
                    return window.fetch(`${window.theme.routes.cart}/change.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify(n) });
                })
                .then(this.handleErrors)
                .then((t) => t.json())
                .then((t) => {
                    (this.cart = t), (s = t.item_count), i === s ? (this.stockoutError(o), (this.stale = !0)) : (Xo(this.errors), this.fireChange(t), (this.stale = !0)), this.loadHTML();
                })
                .catch((t) => {
                    console.error(t);
                    let e = "";
                    void 0 !== t.status && (e = `<p>${t.status}</p>`);
                    let i = t.json.description || "";
                    this.showError(`${e + i}`), this.loadHTML();
                });
        }
        fireChange(t) {
            document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t }, bubbles: !0 }));
        }
        updateTotal() {
            if (this.cart && this.cart.total_price) {
                const t = a.formatMoney(this.cart.total_price, theme.moneyFormat);
                this.finalPrice.innerHTML = t + ` ${theme.currencyCode}`;
            }
            this.subtotal &&
                this.cart &&
                window
                    .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        (e.innerHTML = t), (this.subtotal.innerHTML = e.querySelector($n).innerHTML);
                    });
        }
        showError(t) {
            Xo(this.errors),
                (this.errors.innerHTML = t),
                window.setTimeout(() => {
                    Go(this.errors);
                }, 600);
        }
        stockoutError(t) {
            let e = `<p><strong>${window.theme.strings.stockout}</strong></p>`,
                i = `<p>${t}</p>`;
            this.showError(`${e + i}`);
        }
        loadForm() {
            window
                .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
                .then(this.handleErrors)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    (e.innerHTML = t), (this.items.innerHTML = e.querySelector($n).innerHTML), this.showForm(), this.initQuantity(), this.initUpsell(), this.updateTotal();
                });
        }
        initUpsell() {
            const t = this.items.querySelector(kn),
                e = this.bottom.querySelector(kn);
            e && e.remove(), this.cartPage && t && this.bottom.insertBefore(t, this.bottom.firstChild);
        }
        initQuantity() {
            hn(this.container), this.initInputs(), this.initRemove();
        }
        showForm() {
            this.bar && this.bar.classList.remove(Hn),
                this.ship && this.ship.classList.remove(Hn),
                this.progress && this.progress.classList.remove(Hn),
                this.form.classList.remove(Hn),
                this.bottom.classList.remove(Hn),
                this.loader.classList.remove(_n),
                this.emptystate.classList.add(Hn);
        }
        showEmpty() {
            this.bar && this.bar.classList.add(Hn),
                this.ship && this.ship.classList.add(Hn),
                this.progress && this.progress.classList.add(Hn),
                this.emptystate.classList.remove(Hn),
                this.loader.classList.remove(_n),
                this.form.classList.add(Hn),
                this.bottom.classList.add(Hn);
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new B({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        constructor(t) {
            (this.section = t),
                (this.container = t.container),
                (this.cartMessages = document.querySelectorAll(xn)),
                (this.bar = this.container.querySelector(qn)),
                (this.ship = this.container.querySelector(Cn)),
                (this.drawer = this.container.querySelector(dn)),
                (this.form = this.container.querySelector(mn)),
                (this.loader = this.container.querySelector(pn)),
                (this.bottom = this.container.querySelector(bn)),
                (this.items = this.container.querySelector(fn)),
                (this.subtotal = this.container.querySelector(wn)),
                (this.errors = this.container.querySelector(vn)),
                (this.finalPrice = this.container.querySelector(En)),
                (this.emptystate = this.container.querySelector(gn)),
                (this.progress = this.container.querySelector(yn)),
                (this.latestClick = null),
                (this.cart = null),
                (this.stale = !0),
                (this.cartPage = document.querySelector(An)),
                this.listen();
        }
    };
    const Mn = {
            onLoad() {
                this.container.querySelector(dn) && (this.cart = new In(this));
                this.container.querySelector(un) && new rn(this);
            },
            onUnload: function () {
                this.cart && "function" == typeof this.cart.unload && this.cart.unload();
            },
        },
        Dn = "[data-accordion-group]",
        Wn = "data-accordion-trigger",
        Bn = "[data-accordion-body]",
        Fn = "data-accordion-body-mobile",
        On = "data-range-holder",
        Nn = "[data-section-id]",
        zn = "accordion-is-open";
    let Rn = {},
        jn = class {
            mobileAccordions() {
                window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style")),
                    document.addEventListener("theme:resize", () => {
                        window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style"));
                    });
            }
            init() {
                this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.setDefaultState(),
                    this.trigger.addEventListener("click", this.toggleEvent),
                    this.body.addEventListener("keyup", this.keyboardEvent),
                    this.body.addEventListener("theme:accordion:close", this.hideEvent);
            }
            hideEvents() {
                this.hideAccordion();
            }
            clickEvents(t) {
                t.preventDefault(), this.toggleState();
            }
            keyboardEvents(t) {
                t.which === window.theme.keyboardKeys.ESCAPE && (this.hideAccordion(), this.trigger.focus());
            }
            resetMobileAccordions() {
                this.trigger.removeEventListener("click", this.toggleEvent), this.body.removeEventListener("keyup", this.keyboardEvent), this.body.removeEventListener("theme:accordion:close", this.hideEvent);
            }
            setDefaultState() {
                this.trigger.classList.contains(zn) ? W(this.body) : this.hideAccordion();
            }
            getSiblings() {
                const t = [...this.body.closest(Nn).querySelectorAll(Dn)].filter((t) => t.contains(this.body)).shift();
                if (t) {
                    return [...t.querySelectorAll(Bn)].filter((t) => !t.contains(this.body));
                }
                return [];
            }
            closeSiblings() {
                this.syncBodies.forEach((t) => {
                    t.dispatchEvent(new CustomEvent("theme:accordion:close", { bubbles: !1 }));
                });
            }
            toggleState() {
                this.trigger.classList.contains(zn)
                    ? this.hideAccordion()
                    : (this.showAccordion(),
                      this.closeSiblings(),
                      this.body.hasAttribute(On) &&
                          setTimeout(() => {
                              document.dispatchEvent(new CustomEvent("theme:price-range:reset", { bubbles: !1 }));
                          }, 400));
            }
            hideAccordion() {
                this.trigger.classList.remove(zn), Xo(this.body);
            }
            showAccordion() {
                this.trigger.classList.add(zn),
                    Go(this.body),
                    setTimeout(() => {
                        this.checkInViewportAndScrollTo();
                    }, 600);
            }
            checkInViewportAndScrollTo() {
                const t = this.trigger.getBoundingClientRect(),
                    e = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
                (t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                    window.scrollTo({ top: e + t.top, left: 0, behavior: "smooth" });
            }
            onBlockSelect(t) {
                this.body.contains(t.target) && this.showAccordion();
            }
            onBlockDeselect(t) {
                this.body.contains(t.target) && this.hideAccordion();
            }
            constructor(t) {
                (this.body = t), (this.key = this.body.id);
                const e = `[${Wn}='${this.key}']`;
                (this.trigger = document.querySelector(e)),
                    (this.toggleEvent = (t) => this.clickEvents(t)),
                    (this.keyboardEvent = (t) => this.keyboardEvents(t)),
                    (this.hideEvent = () => this.hideEvents()),
                    (this.syncBodies = this.getSiblings()),
                    this.body.hasAttribute(Fn) ? this.mobileAccordions() : this.init();
            }
        };
    const Vn = {
            onLoad() {
                Rn[this.id] = [];
                this.container.querySelectorAll(Bn).forEach((t) => {
                    Rn[this.id].push(new jn(t));
                });
            },
            onUnload: function () {
                Rn[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
            onSelect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${Wn}]`).click();
            },
            onDeselect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${Wn}]`).click();
            },
            onBlockSelect(t) {
                Rn[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Rn[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                });
            },
        },
        Un = "on-sale",
        Jn = "sold-out";
    const Kn = "[data-search-popdown-wrap]",
        Yn = "[data-predictive-search-results]",
        Gn = "[data-predictive-search-input]",
        Xn = "[data-search-product-template]",
        Qn = "[data-search-other-template]",
        Zn = "[data-predictive-search-title-template]",
        ta = "[data-predictive-search-aria-template]",
        ea = "[data-product-title-wrap]",
        ia = "[data-product-wrap]",
        sa = "[data-collection-wrap]",
        oa = "[data-article-wrap]",
        ra = "[data-page-wrap]",
        na = "[data-predictive-search-aria]",
        aa = "[data-popdown-outer]",
        la = "[data-loading-indicator]",
        ca = "dirty",
        ha = "search--empty";
    let da = {};
    u.filters.define("animationDelay", function (t) {
        return 90 * t + 10;
    });
    const ua = {
            onLoad() {
                da[this.id] = [];
                document.querySelectorAll(Kn).forEach((t) => {
                    da[this.id].push(
                        new (class {
                            initSearch() {
                                this.input.addEventListener(
                                    "input",
                                    A(
                                        function (t) {
                                            const e = t.target.value;
                                            e && e.length > 1 ? ((this.loader.style.display = "block"), this.render(e)) : (this.resetTemplates(), this.outer.classList.remove(ca));
                                        }.bind(this),
                                        300
                                    )
                                ),
                                    this.input.addEventListener("theme:search:clear", this.reset.bind(this));
                            }
                            render(t) {
                                let e = "";
                                (e += window.theme.settings.search_products ? "product," : ""),
                                    (e += window.theme.settings.search_collections ? "collection," : ""),
                                    (e += window.theme.settings.search_articles ? "article," : ""),
                                    (e += window.theme.settings.search_pages ? "page," : ""),
                                    (e = e.slice(0, -1)),
                                    fetch(`/search/suggest.json?q=${t}&resources[type]=${e}&resources[options][unavailable_products]=last`)
                                        .then(this.handleErrors)
                                        .then((t) => t.json())
                                        .then((e) => {
                                            this.resetTemplates(), this.outer.classList.add(ca);
                                            const i = e.resources.results,
                                                s = [];
                                            for (const t in i) ({}.hasOwnProperty.call(i, t) && s.push(...i[t]));
                                            s.length ? (this.outer.classList.remove(ha), this.injectOther(i), this.injectProduct(i.products)) : this.noResults(t), this.injectAria(t, s), li(this.outer, { elementToFocus: this.input });
                                        })
                                        .catch((t) => {
                                            console.error(t);
                                        })
                                        .finally(() => {
                                            this.loader.style.display = "none";
                                        });
                            }
                            injectAria(t, e) {
                                let i = window.theme.strings.noResultsFor,
                                    s = null;
                                e.length && ((s = e.length), (i = window.theme.strings.resultsFor)), (this.ariaWrapper.innerHTML = u.render(this.ariaTemplate, { count: s, title: i, query: t }));
                            }
                            noResults() {
                                this.resetTemplates(), this.outer.classList.add(ca), this.outer.classList.add(ha);
                            }
                            resetTemplates() {
                                (this.productTitleWrapper.innerHTML = ""),
                                    (this.collectionWrapper.innerHTML = ""),
                                    (this.articleWrapper.innerHTML = ""),
                                    (this.productWrapper.innerHTML = ""),
                                    (this.pageWrapper.innerHTML = ""),
                                    (this.ariaWrapper.innerHTML = "");
                            }
                            reset() {
                                this.resetTemplates(), this.outer.classList.remove(ca), this.outer.classList.remove(ha), (this.input.val = "");
                            }
                            injectOther(t) {
                                const e = t.collections;
                                if (((this.productTitleWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.products, count: t.products.length })), e && e.length)) {
                                    for (let t = e.length - 1; t >= 0; t--) {
                                        const i = e[t];
                                        theme.settings.excluded_collections_strict.forEach((s) => {
                                            s.trim() == i.handle && e.splice(t, 1);
                                        }),
                                            theme.settings.excluded_collections.forEach((s) => {
                                                i.handle.includes(s.trim()) && e.splice(t, 1);
                                            });
                                    }
                                    (this.collectionWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.collections, count: e.length })), (this.collectionWrapper.innerHTML += u.render(this.otherTemplate, e));
                                }
                                t.pages &&
                                    t.pages.length &&
                                    ((this.pageWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.pages, count: t.pages.length })), (this.pageWrapper.innerHTML += u.render(this.otherTemplate, t.pages))),
                                    t.articles &&
                                        t.articles.length &&
                                        ((this.articleWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.articles, count: t.articles.length })),
                                        (this.articleWrapper.innerHTML += u.render(this.otherTemplate, t.articles)));
                            }
                            injectProduct(t) {
                                let e = [];
                                t.forEach((t) => {
                                    let i = t;
                                    (i = (function (t) {
                                        const e = t.price < t.compare_at_price_min;
                                        let i = e ? Un : "";
                                        if (
                                            ((i += t.available ? "" : Jn),
                                            (t.price = theme.settings.currency_code_enable ? a.formatMoney(t.price, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(t.price, theme.moneyFormat)),
                                            t.price_min !== t.price_max)
                                        ) {
                                            let e = theme.settings.currency_code_enable ? a.formatMoney(t.price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(t.price_min, theme.moneyFormat);
                                            t.price = `${window.theme.strings.from} ${e}`;
                                        }
                                        return {
                                            ...t,
                                            classes: i,
                                            on_sale: e,
                                            sold_out: !t.available,
                                            sold_out_translation: window.theme.strings.soldOut,
                                            compare_at_price: theme.settings.currency_code_enable
                                                ? a.formatMoney(t.compare_at_price_min, theme.moneyFormat) + ` ${theme.currencyCode}`
                                                : a.formatMoney(t.compare_at_price_min, theme.moneyFormat),
                                            compare_at_price_max: theme.settings.currency_code_enable
                                                ? a.formatMoney(t.compare_at_price_max, theme.moneyFormat) + ` ${theme.currencyCode}`
                                                : a.formatMoney(t.compare_at_price_max, theme.moneyFormat),
                                            compare_at_price_min: theme.settings.currency_code_enable
                                                ? a.formatMoney(t.compare_at_price_min, theme.moneyFormat) + ` ${theme.currencyCode}`
                                                : a.formatMoney(t.compare_at_price_min, theme.moneyFormat),
                                            price_max: theme.settings.currency_code_enable ? a.formatMoney(t.price_max, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(t.price_max, theme.moneyFormat),
                                            price_min: theme.settings.currency_code_enable ? a.formatMoney(t.price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(t.price_min, theme.moneyFormat),
                                        };
                                    })(i)),
                                        (i.image = null),
                                        i.featured_image && (i.thumb = ut(i.featured_image.url, "360x360")),
                                        e.push(i);
                                });
                                const i = u.render(this.productTemplate, e);
                                this.productWrapper.innerHTML += i;
                            }
                            handleErrors(t) {
                                return t.ok
                                    ? t
                                    : t.json().then(function (e) {
                                          throw new B({ status: t.statusText, headers: t.headers, json: e });
                                      });
                            }
                            constructor(t) {
                                (this.wrapper = t),
                                    (this.input = this.wrapper.querySelector(Gn)),
                                    (this.loader = this.wrapper.querySelector(la)),
                                    (this.results = this.wrapper.querySelector(Yn)),
                                    (this.outer = this.input.closest(aa)),
                                    (this.productTemplate = this.wrapper.querySelector(Xn).innerHTML),
                                    (this.otherTemplate = this.wrapper.querySelector(Qn).innerHTML),
                                    (this.titleTemplate = this.wrapper.querySelector(Zn).innerHTML),
                                    (this.ariaTemplate = this.wrapper.querySelector(ta).innerHTML),
                                    (this.productTitleWrapper = this.results.querySelector(ea)),
                                    (this.productWrapper = this.results.querySelector(ia)),
                                    (this.collectionWrapper = this.results.querySelector(sa)),
                                    (this.articleWrapper = this.results.querySelector(oa)),
                                    (this.pageWrapper = this.results.querySelector(ra)),
                                    (this.ariaWrapper = this.results.querySelector(na)),
                                    this.initSearch();
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                da[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        pa = "[data-drawer-search]",
        ma = "[data-search-popdown-wrap]",
        ga = "[data-predictive-search-input]",
        ya = "[data-clear-input]";
    const fa = {
            onLoad() {
                this.searchDrawer = new (class {
                    init() {
                        this.clear.addEventListener(
                            "click",
                            function (t) {
                                t.preventDefault(), this.clearInput();
                            }.bind(this)
                        );
                    }
                    clearInput() {
                        (this.input.value = ""), this.input.dispatchEvent(new CustomEvent("theme:search:clear", { bubbles: !1 })), this.input.focus();
                    }
                    constructor(t) {
                        (this.outer = t.container.querySelector(pa)), this.outer && ((this.wrapper = this.outer.querySelector(ma)), (this.input = this.outer.querySelector(ga)), (this.clear = this.outer.querySelector(ya)), this.init());
                    }
                })(this);
            },
            onUnload: function () {
                this.searchDrawer && "function" == typeof this.searchDrawer.unload && this.searchDrawer.unload();
            },
        },
        wa = {
            drawer: "data-drawer-scrolls",
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            dataAnimates: "data-animates",
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *",
        },
        ba = "is-visible",
        va = "is-hiding",
        Sa = "is-hidden";
    let Ea = {};
    const La = {
            onLoad() {
                Ea[this.id] = [];
                this.container.querySelectorAll(wa.slideruleWrappper).forEach((t) => {
                    Ea[this.id].push(
                        new (class {
                            clickEvents() {
                                this.trigger.addEventListener(
                                    "click",
                                    function () {
                                        this.showSliderule();
                                    }.bind(this)
                                ),
                                    this.exit.forEach((t) => {
                                        t.addEventListener(
                                            "click",
                                            function () {
                                                this.hideSliderule();
                                            }.bind(this)
                                        );
                                    });
                            }
                            keyboardEvents() {
                                this.trigger.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.SPACE && this.showSliderule();
                                    }.bind(this)
                                ),
                                    this.sliderule.addEventListener(
                                        "keyup",
                                        function (t) {
                                            t.which === window.theme.keyboardKeys.ESCAPE && (this.hideSliderule(), this.buttons[0].focus());
                                        }.bind(this)
                                    );
                            }
                            staggerChildAnimations(t = !1) {
                                (t ? Array.prototype.slice.call(this.children).slice().reverse() : this.children).forEach((t, e) => {
                                    t.style.transitionDelay = 50 * e + 10 + "ms";
                                });
                            }
                            hideSliderule(t = !1) {
                                const e = window.getComputedStyle(this.pane),
                                    i = 1e3 * parseFloat(e.getPropertyValue("transition-duration")),
                                    s = t ? this.pane.querySelectorAll(`.${ba}`) : this.children;
                                this.pane.style.setProperty("--sliderule-height", "auto"),
                                    this.staggerChildAnimations(!0),
                                    this.pane.classList.add(va),
                                    this.sliderule.classList.add(va),
                                    this.sliderule.classList.remove(ba),
                                    s.forEach((t) => {
                                        t.classList.remove(ba);
                                    });
                                const o = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                                this.pane.setAttribute(wa.sliderulePane, o);
                                const r = t ? `[${wa.dataAnimates}].${Sa}` : `[${wa.dataAnimates}="${o}"].${Sa}`,
                                    n = this.pane.querySelectorAll(r);
                                n.length &&
                                    n.forEach((t) => {
                                        t.classList.remove(Sa);
                                    }),
                                    setTimeout(() => {
                                        this.pane.classList.remove(va), this.sliderule.classList.remove(va), this.staggerChildAnimations();
                                    }, i);
                            }
                            showSliderule() {
                                this.pane.style.setProperty("--sliderule-height", "auto"),
                                    this.sliderule.classList.add(ba),
                                    this.children.forEach((t) => {
                                        t.classList.add(ba);
                                    });
                                const t = parseInt(this.pane.dataset.sliderulePane, 10),
                                    e = t + 1;
                                this.pane.setAttribute(wa.sliderulePane, e);
                                const i = this.pane.querySelectorAll(`[${wa.dataAnimates}="${t}"]`);
                                if (i.length) {
                                    const t = 1e3 * parseFloat(window.getComputedStyle(i[0]).getPropertyValue("transition-duration"));
                                    setTimeout(() => {
                                        i.forEach((t) => {
                                            t.classList.add(Sa);
                                        });
                                    }, t);
                                }
                                const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                                this.pane.style.setProperty("--sliderule-height", `${s}px`);
                                const o = this.drawer.scrollTop,
                                    r = this.pane.offsetTop;
                                r < o && this.pane.offsetHeight >= this.drawer.offsetHeight && this.drawer.scrollTo({ top: r, left: 0, behavior: "smooth" });
                            }
                            closeSliderule() {
                                this.pane &&
                                    this.pane.hasAttribute(wa.sliderulePane) &&
                                    parseInt(this.pane.getAttribute(wa.sliderulePane)) > 0 &&
                                    (this.hideSliderule(!0), parseInt(this.pane.getAttribute(wa.sliderulePane)) > 0 && this.pane.setAttribute(wa.sliderulePane, 0));
                            }
                            constructor(t) {
                                (this.sliderule = t), (this.wrapper = t.closest(wa.wrapper)), (this.key = this.sliderule.id);
                                const e = `[${wa.slideruleOpen}='${this.key}']`,
                                    i = `[${wa.slideruleClose}='${this.key}']`;
                                (this.trigger = document.querySelector(e)),
                                    (this.drawer = document.querySelector(`[${wa.drawer}]`)),
                                    (this.exit = document.querySelectorAll(i)),
                                    (this.pane = document.querySelector(`[${wa.sliderulePane}]`)),
                                    (this.children = this.sliderule.querySelectorAll(wa.children)),
                                    this.trigger.setAttribute("aria-haspopup", !0),
                                    this.trigger.setAttribute("aria-expanded", !1),
                                    this.trigger.setAttribute("aria-controls", this.key),
                                    this.clickEvents(),
                                    this.staggerChildAnimations(),
                                    document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this));
                            }
                        })(t)
                    );
                });
            },
        },
        Ta = "[data-product-add-popdown-wrapper]",
        ka = "[data-close-popdown]",
        Aa = "[data-api-content]",
        qa = '[data-ajax-disable="false"]',
        Ca = '[data-ajax-disable="true"]',
        Pa = '[data-drawer-toggle="drawer-cart"]',
        xa = '[data-drawer="drawer-cart"]',
        $a = "is-visible";
    let Ha;
    const _a = {
            onLoad() {
                new (class {
                    renderPopdown(t) {
                        const e = t.detail.variant,
                            i = `${window.theme.routes.root_url}variants/${e.id}/?section_id=api-product-popdown`,
                            s = this;
                        l.get(i)
                            .then(function (t) {
                                const e = document.createElement("div");
                                (e.innerHTML = t.data), (s.drawer.innerHTML = e.querySelector(Aa).innerHTML), s.connectCartButton(), s.connectCloseButton();
                            })
                            .catch(function (t) {
                                console.warn(t);
                            });
                    }
                    connectCloseButton() {
                        this.drawer.classList.add($a),
                            this.drawer.querySelector(ka).addEventListener(
                                "click",
                                function (t) {
                                    t.preventDefault(), this.drawer.classList.remove($a);
                                }.bind(this)
                            ),
                            this.popdownTimer();
                    }
                    connectCartButton() {
                        const t = this.drawer.querySelector(Pa),
                            e = document.querySelector(xa);
                        e &&
                            t.addEventListener(
                                "click",
                                function (t) {
                                    t.preventDefault(), this.drawer.classList.remove($a), e.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                                }.bind(this)
                            );
                    }
                    popdownTimer() {
                        clearTimeout(Ha),
                            (Ha = setTimeout(() => {
                                this.drawer.classList.remove($a);
                            }, 5e3));
                    }
                    constructor() {
                        (this.drawer = document.querySelector(Ta)),
                            (this.cartSectionAjax = document.querySelector(qa)),
                            (this.ajaxDisabled = document.querySelector(Ca)),
                            document.addEventListener("theme:cart:popdown", (t) => {
                                this.cartSectionAjax ? this.cartSectionAjax.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 })) : this.ajaxDisabled ? window.location.reload() : this.renderPopdown(t);
                            });
                    }
                })(this);
            },
        },
        Ia = "[data-takes-space]",
        Ma = "[data-header-desktop]",
        Da = "js__header__clone",
        Wa = "js__show__mobile",
        Ba = "[data-header-backfill]",
        Fa = "data-header-transparent",
        Oa = "header-override-border",
        Na = ".main-content > .shopify-section:first-child [data-overlay-header]",
        za = ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
        Ra = '.navlink[href="#"]',
        ja = "has-overlay";
    let Va = {};
    Ze("header", [
        {
            onLoad() {
                Va = new (class {
                    unload() {
                        document.removeEventListener("theme:resize", this.checkWidth);
                    }
                    checkForImage() {
                        this.overlayedImages = document.querySelectorAll(Na);
                        let t = document.querySelectorAll(za).length;
                        this.overlayedImages.length && !t && this.transparent ? ((document.querySelector(Ba).style.display = "none"), this.listenOverlay()) : this.wrapper.setAttribute(Fa, !1),
                            !this.overlayedImages.length || t || this.transparent || (this.wrapper.classList.add(Oa), this.subtractHeaderHeight());
                    }
                    listenOverlay() {
                        document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.subtractAnnouncementHeight();
                    }
                    listenWidth() {
                        document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth();
                    }
                    killDeadLinks() {
                        this.deadLinks.forEach((t) => {
                            t.onclick = (t) => {
                                t.preventDefault();
                            };
                        });
                    }
                    subtractAnnouncementHeight() {
                        const { windowHeight: t, announcementHeight: e } = w();
                        this.overlayedImages.forEach((i) => {
                            i.style.setProperty("--full-screen", t - e + "px"), i.classList.add(ja);
                        });
                    }
                    subtractHeaderHeight() {
                        const { windowHeight: t, headerHeight: e } = w();
                        this.overlayedImages.forEach((i) => {
                            i.style.setProperty("--full-screen", t - e + "px");
                        });
                    }
                    checkWidth() {
                        document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(Wa) : this.wrapper.classList.remove(Wa);
                    }
                    getMinWidth() {
                        const t = this.wrapper.cloneNode(!0);
                        t.classList.add(Da), document.body.appendChild(t);
                        const e = t.querySelectorAll(Ia);
                        let i = 0;
                        return (
                            (i =
                                3 === e.length
                                    ? (function (t) {
                                          let e = [];
                                          return (
                                              t.forEach((t) => {
                                                  e.push(t.clientWidth);
                                              }),
                                              e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                                              e.reduce((t, e) => t + e)
                                          );
                                      })(e)
                                    : (function (t) {
                                          let e = 0;
                                          return (
                                              t.forEach((t) => {
                                                  e += t.clientWidth;
                                              }),
                                              e
                                          );
                                      })(e)),
                            document.body.removeChild(t),
                            i + 20 * e.length
                        );
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.style = this.wrapper.dataset.style),
                            (this.desktop = this.wrapper.querySelector(Ma)),
                            (this.transparent = "false" !== this.wrapper.getAttribute(Fa)),
                            (this.overlayedImages = document.querySelectorAll(Na)),
                            (this.deadLinks = document.querySelectorAll(Ra)),
                            this.killDeadLinks(),
                            "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                            this.checkForImage(),
                            window.dispatchEvent(new Event("resize")),
                            document.addEventListener("theme:header:check", this.checkForImage.bind(this));
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof Va.unload && Va.unload();
            },
        },
        fs,
        La,
        As,
        Os,
        Gs,
        to,
        co,
        ua,
        fa,
        te,
        Mn,
        _a,
        Vn,
        xi,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", Yo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Mo);
    const Ua = "[data-newsletter-form]",
        Ja = "has-success",
        Ka = "has-error",
        Ya = {};
    const Ga = {
        onLoad() {
            Ya[this.id] = [];
            this.container.querySelectorAll(Ua).forEach((t) => {
                Ya[this.id].push(
                    new (class {
                        init() {
                            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                        }
                        newsletterSubmitEvent(t) {
                            this.stopSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                        }
                        checkForChallengePage() {
                            this.isChallengePage = "/challenge" === window.location.pathname;
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem("newsletter_form_id");
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem("newsletter_form_id");
                        }
                        showMessage() {
                            if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                const t = document.getElementById(this.formID);
                                -1 !== window.location.search.indexOf("?customer_posted=true")
                                    ? (t.classList.remove(Ka), t.classList.add(Ja))
                                    : -1 !== window.location.search.indexOf("accepts_marketing") && (t.classList.remove(Ja), t.classList.add(Ka)),
                                    this.scrollToForm(t);
                            }
                        }
                        scrollToForm(t) {
                            const e = t.getBoundingClientRect();
                            (e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                                setTimeout(() => {
                                    window.scroll({ top: e.top, left: 0, behavior: "smooth" });
                                }, 400);
                        }
                        unload() {
                            this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                        }
                        constructor(t) {
                            (this.sessionStorage = window.sessionStorage),
                                (this.newsletter = t),
                                (this.stopSubmit = !0),
                                (this.isChallengePage = !1),
                                (this.formID = null),
                                this.checkForChallengePage(),
                                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                this.isChallengePage || this.init();
                        }
                    })(t)
                );
            });
        },
        onUnload() {
            Ya[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    };
    function Xa() {
        const t = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        return document.documentElement.classList.toggle("supports-touch", t), t;
    }
    Ze("footer", [Vn, Ga]), customElements.get("popout-select") || customElements.define("popout-select", Yo), Xa();
    const Qa = { cc_load_policy: 1, iv_load_policy: 3, modestbranding: 1, playsinline: 1, controls: 1, showinfo: 0, ecver: 2, fs: 1, rel: 0 },
        Za = "iframe, [data-replace]",
        tl = "data-video-id";
    function el(t, e) {
        const i = { ...Qa, ...e },
            s = document.querySelector(`[data-player="${t}"]`),
            o = s.querySelector(Za),
            r = s.querySelector(`[${tl}]`).getAttribute(tl);
        Tt({ url: "https://www.youtube.com/iframe_api" });
        return window.youtubeLoaderPromise
            .then(function () {
                let t = new window.YT.Player(o, { videoId: r, playerVars: { ...i } });
                return (
                    s.addEventListener("pause", function () {
                        try {
                            t.pauseVideo && t.pauseVideo();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("theme:media:play-desktop", function () {
                        Xa() || s.dispatchEvent(new Event("play"));
                    }),
                    s.addEventListener("play", function () {
                        try {
                            t.playVideo
                                ? t.playVideo()
                                : t.addEventListener("onReady", function (t) {
                                      t.target.playVideo();
                                  });
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("destroy", function () {
                        try {
                            t.destroy && t.destroy();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    t
                );
            })
            .catch(function (t) {
                console.error(t);
            });
    }
    window.youtubeLoaderPromise = new Promise((t) => {
        window.onYouTubeIframeAPIReady = function () {
            t();
        };
    });
    const il = { autoplay: !0, loop: !0, controls: !0, muted: !1, playsinline: !0 },
        sl = "iframe, [data-replace]",
        ol = "data-video-id";
    const rl = "[data-video-popup]",
        nl = "[data-video-autoplay]",
        al = "data-unique",
        ll = "data-video-id",
        cl = "data-video-type",
        hl = "data-player";
    const dl = {
            onLoad() {
                new (class {
                    init() {
                        this.triggers.forEach((t) => {
                            const e = t.getAttribute(al),
                                i = t.getAttribute(ll),
                                s = t.getAttribute(cl),
                                o = `${i}-${e}`,
                                n = document.querySelector(`[${hl}="${o}"]`);
                            r.init({
                                onShow: () => {
                                    this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && this.backgroundVideo.pause();
                                    let t = {};
                                    "youtube" === s
                                        ? (t = el(o))
                                        : "vimeo" === s &&
                                          (t = (function (t, e) {
                                              const i = { ...il, ...e },
                                                  s = document.querySelector(`[data-player="${t}"]`),
                                                  o = s.querySelector(sl),
                                                  r = s.querySelector(`[${ol}]`).getAttribute(ol),
                                                  n = Tt({ url: "https://player.vimeo.com/api/player.js" }),
                                                  a = `select-${t}`;
                                              return (
                                                  o.setAttribute("id", a),
                                                  n
                                                      .then(function () {
                                                          const t = new window.Vimeo.Player(a, { ...i, id: r });
                                                          return (
                                                              s.addEventListener("pause", function () {
                                                                  try {
                                                                      t.pause && t.pause();
                                                                  } catch (t) {
                                                                      console.warn(t);
                                                                  }
                                                              }),
                                                              s.addEventListener("theme:media:play-desktop", function () {
                                                                  Xa() || s.dispatchEvent(new Event("play"));
                                                              }),
                                                              s.addEventListener("play", function () {
                                                                  t.play && t.play();
                                                              }),
                                                              s.addEventListener("destroy", function () {
                                                                  try {
                                                                      t.destroy && t.destroy();
                                                                  } catch (t) {
                                                                      console.log(t);
                                                                  }
                                                              }),
                                                              t
                                                          );
                                                      })
                                                      .catch(function (t) {
                                                          console.error(t);
                                                      })
                                              );
                                          })(o)),
                                        t.then(() => {
                                            n.dispatchEvent(new CustomEvent("play"));
                                        });
                                },
                                onClose: (t, e, i) => {
                                    i.preventDefault(), n.dispatchEvent(new CustomEvent("destroy")), this.backgroundVideo && "function" == typeof this.backgroundVideo.play && this.backgroundVideo.play();
                                },
                                openTrigger: `data-trigger-${i}-${e}`,
                            });
                        });
                    }
                    constructor(t) {
                        (this.container = t.container), (this.triggers = this.container.querySelectorAll(rl)), (this.backgroundVideo = this.container.querySelector(nl)), this.init();
                    }
                })(this);
            },
        },
        ul = "[data-scroll-down]";
    const pl = {
        onLoad() {
            this.scrollButton = new (class {
                init() {
                    const t = this.wrapper.querySelectorAll(ul);
                    t &&
                        t.forEach((t) => {
                            t.addEventListener("click", this.scroll.bind(this));
                        });
                }
                scroll() {
                    const t = this.wrapper.offsetTop + this.wrapper.clientHeight;
                    window.scroll({ top: t, left: 0, behavior: "smooth" });
                }
                constructor(t) {
                    (this.wrapper = t), this.init();
                }
            })(this.container);
        },
        onUnload: function () {
            delete this.scrollButton;
        },
    };
    Ze("video", [wi, pl, dl]), Ze("page-faq", Vn), Ze("hero", [wi, pl, ae]);
    const ml = "[data-slider]",
        gl = "[data-grid-slide]",
        yl = "[data-wrapper]",
        fl = "data-custom-scrollbar-items",
        wl = "data-show-dots",
        bl = "wrapper",
        vl = "wrapper--full",
        Sl = window.innerWidth - document.documentElement.clientWidth,
        El = 112,
        Ll = {};
    const Tl = {
        onLoad() {
            Ll[this.id] = [];
            this.container.querySelectorAll(ml).forEach((t) => {
                Ll[this.id].push(
                    new (class {
                        init() {
                            const t = this,
                                e = {
                                    initialIndex: 0,
                                    accessibility: !0,
                                    autoPlay: !1,
                                    contain: !0,
                                    pageDots: this.pageDots,
                                    adaptiveHeight: !1,
                                    wrapAround: !1,
                                    groupCells: !1,
                                    cellAlign: "left",
                                    freeScroll: !0,
                                    prevNextButtons: !0,
                                    draggable: !0,
                                    rightToLeft: window.isRTL,
                                    watchCSS: !0,
                                    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
                                    on: {
                                        ready: function () {
                                            t.removeIncorrectAria();
                                        },
                                    },
                                };
                            (this.flkty = new s(this.slideshow, e)),
                                this.container.addEventListener("theme:tab:change", () => {
                                    this.flkty.resize();
                                }),
                                this.toggleWrapperModifier(),
                                document.addEventListener("theme:resize:width", this.toggleWrapperModifier.bind(this)),
                                this.slideshow.hasAttribute(fl) && new ne(this.container),
                                new U(this.container);
                        }
                        toggleWrapperModifier() {
                            this.wrapper.classList.contains(bl) && this.wrapper.classList.toggle(vl, this.wrapperWidthWithGutter >= window.innerWidth);
                        }
                        removeIncorrectAria() {
                            this.slideshow.querySelectorAll('[aria-hidden="true"]').forEach((t) => t.removeAttribute("aria-hidden"));
                        }
                        onUnload() {
                            this.slideshow && this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
                        }
                        constructor(t, e) {
                            if (
                                ((this.container = t),
                                (this.slideshow = e),
                                (this.wrapper = this.container.closest(yl)),
                                (this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue("--LAYOUT-WIDTH").replace("px", ""))),
                                (this.wrapperWidthWithGutter = this.wrapperWidth + El + Sl),
                                (this.pageDots = "true" === this.slideshow.getAttribute(wl)),
                                (this.firstPhoto = this.container.querySelector(gl)),
                                this.firstPhoto)
                            ) {
                                const t = this.firstPhoto.offsetHeight / 2;
                                this.slideshow.style.setProperty("--buttons-top", `${t}px`);
                            }
                            this.slideshow && ((this.flkty = null), this.init());
                        }
                    })(this.container, t)
                );
            });
        },
        onUnload(t) {
            Ll[this.id].forEach((e) => {
                "function" == typeof e.onUnload && e.onUnload(t);
            });
        },
    };
    Ze("custom-content", [wi, dl, te, Tl]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Mo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr);
    const kl = [],
        Al = "[data-slideshow-wrapper]",
        ql = "data-slideshow-speed",
        Cl = "data-slideshow-autoplay",
        Pl = "data-slideshow-slides",
        xl = "[data-slide-custom-prev]",
        $l = "[data-slide-custom-next]",
        Hl = "data-slideshow-index",
        _l = "flickity-enabled";
    Ze("slideshow", [
        {
            onLoad() {
                kl[this.id] = new (class {
                    init() {
                        const e = {
                            autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
                            contain: !1,
                            pageDots: !0,
                            adaptiveHeight: !0,
                            accessibility: !0,
                            wrapAround: 2 !== this.slideCount,
                            prevNextButtons: !1,
                            draggable: !0,
                            fade: !0,
                            rightToLeft: window.isRTL,
                        };
                        (this.flkty = new t(this.wrapper, e)),
                            this.prevButtons.length &&
                                this.prevButtons.forEach((t) => {
                                    t.onclick = () => {
                                        this.flkty.previous(!0, !1);
                                    };
                                }),
                            this.nextButtons.length &&
                                this.nextButtons.forEach((t) => {
                                    t.onclick = () => {
                                        this.flkty.next(!0, !1);
                                    };
                                }),
                            document.addEventListener("theme:scroll", this.scrollEvent);
                    }
                    scrollEvents() {
                        if (this.flkty && this.autoplay && this.speed) {
                            const t = this.flkty.element,
                                e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                            window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                        }
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty && this.wrapper && this.wrapper.classList.contains(_l) && this.flkty.destroy();
                    }
                    onBlockSelect(t) {
                        const e = t.target.closest(`[${Hl}]`).getAttribute(Hl),
                            i = parseInt(e);
                        this.flkty.selectCell(i), this.flkty.stopPlayer();
                    }
                    onBlockDeselect() {
                        this.autoplay && this.flkty.playPlayer();
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.wrapper = t.container.querySelector(Al)),
                            (this.speed = this.wrapper.getAttribute(ql)),
                            (this.autoplay = "true" === this.wrapper.getAttribute(Cl)),
                            (this.slideCount = parseInt(this.wrapper.getAttribute(Pl), 10)),
                            (this.prevButtons = this.wrapper.querySelectorAll(xl)),
                            (this.nextButtons = this.wrapper.querySelectorAll($l)),
                            (this.flkty = null),
                            (this.scrollEvent = () => this.scrollEvents()),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                "function" == typeof kl[this.id].unload && kl[this.id].unload();
            },
            onBlockSelect(t) {
                "function" == typeof kl[this.id].onBlockSelect && kl[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                "function" == typeof kl[this.id].onBlockSelect && kl[this.id].onBlockDeselect(t);
            },
        },
        wi,
        pl,
    ]);
    const Il = "[data-range-slider]",
        Ml = "[data-range-left]",
        Dl = "[data-range-right]",
        Wl = "[data-range-line]",
        Bl = "[data-range-holder]",
        Fl = "data-se-min",
        Ol = "data-se-max",
        Nl = "data-se-min-value",
        zl = "data-se-max-value",
        Rl = "data-se-step",
        jl = "data-range-filter-update",
        Vl = "[data-field-price-min]",
        Ul = "[data-field-price-max]",
        Jl = "is-initialized";
    let Kl = class {
        init() {
            this.setDefaultValues(),
                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                this.touchLeft.addEventListener("touchstart", this.onStartEvent),
                this.touchRight.addEventListener("touchstart", this.onStartEvent),
                this.slider.classList.add(Jl);
        }
        setDefaultValues() {
            let t = this.min;
            this.slider.hasAttribute(Nl) && (t = parseFloat(this.slider.getAttribute(Nl)));
            let e = this.max;
            this.slider.hasAttribute(zl) && (e = parseFloat(this.slider.getAttribute(zl))),
                t < this.min && (t = this.min),
                e > this.max && (e = this.max),
                t > e && (t = e),
                this.slider.getAttribute(Rl) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(Rl)))),
                this.reset(),
                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                (this.selectedTouch = null),
                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                this.setMinValue(t),
                this.setMaxValue(e);
        }
        reset() {
            (this.touchLeft.style.left = "0px"),
                (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.lineSpan.style.marginLeft = "0px"),
                (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.startX = 0),
                (this.x = 0);
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(Nl, t);
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(zl, t);
        }
        onStart(t) {
            t.preventDefault();
            let e = t;
            t.touches && (e = t.touches[0]),
                t.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                (this.startX = e.pageX - this.x),
                (this.selectedTouch = t.currentTarget),
                document.addEventListener("mousemove", this.onMoveEvent),
                document.addEventListener("mouseup", this.onStopEvent),
                document.addEventListener("touchmove", this.onMoveEvent),
                document.addEventListener("touchend", this.onStopEvent);
        }
        onMove(t) {
            let e = t;
            if (
                (t.touches && (e = t.touches[0]),
                (this.x = e.pageX - this.startX),
                this.selectedTouch === this.touchLeft
                    ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                      (this.selectedTouch.style.left = this.x + "px"))
                    : this.selectedTouch === this.touchRight &&
                      (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                      (this.selectedTouch.style.left = this.x + "px")),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.calculateValue(),
                this.slider.getAttribute("on-change"))
            ) {
                new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(Nl), this.slider.getAttribute(zl));
            }
            this.onChange(this.slider.getAttribute(Nl), this.slider.getAttribute(zl));
        }
        onStop(t) {
            document.removeEventListener("mousemove", this.onMoveEvent),
                document.removeEventListener("mouseup", this.onStopEvent),
                document.removeEventListener("touchmove", this.onMoveEvent),
                document.removeEventListener("touchend", this.onStopEvent),
                (this.selectedTouch = null),
                this.calculateValue(),
                this.onChanged(this.slider.getAttribute(Nl), this.slider.getAttribute(zl));
        }
        onChange(t, e) {
            const i = this.slider.closest(Bl);
            if (i) {
                const s = i.querySelector(Vl),
                    o = i.querySelector(Ul);
                s && o && ((s.value = t), (o.value = e));
            }
        }
        onChanged(t, e) {
            this.slider.hasAttribute(jl) && this.slider.dispatchEvent(new CustomEvent("theme:range:update", { bubbles: !0 }));
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                i = e + t;
            if (((e = e * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)) {
                let t = Math.floor(e / this.step);
                (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(Nl, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(zl, i);
        }
        constructor(t) {
            (this.container = t.container),
                (this.slider = t.querySelector(Il)),
                this.slider &&
                    ((this.onMoveEvent = (t) => this.onMove(t)),
                    (this.onStopEvent = (t) => this.onStop(t)),
                    (this.onStartEvent = (t) => this.onStart(t)),
                    (this.startX = 0),
                    (this.x = 0),
                    (this.touchLeft = this.slider.querySelector(Ml)),
                    (this.touchRight = this.slider.querySelector(Dl)),
                    (this.lineSpan = this.slider.querySelector(Wl)),
                    (this.min = parseFloat(this.slider.getAttribute(Fl))),
                    (this.max = parseFloat(this.slider.getAttribute(Ol))),
                    (this.step = 0),
                    (this.normalizeFact = 26),
                    this.init(),
                    document.addEventListener("theme:price-range:reset", () => {
                        this.setDefaultValues();
                    }));
        }
    };
    const Yl = "data-filters",
        Gl = "[data-filters-underlay]",
        Xl = "data-default-hide",
        Ql = "data-filters-toggle",
        Zl = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        tc = "data-group-heading",
        ec = "data-show-more",
        ic = "drawer--visible",
        sc = "filters--default-visible",
        oc = "hidden",
        rc = "is-hidden",
        nc = "focus-enabled",
        ac = {};
    let lc = class {
        unload() {
            this.filtersToggleButtons.length &&
                this.filtersToggleButtons.forEach((t) => {
                    t.removeEventListener("click", this.connectToggleMemory);
                }),
                this.showMoreButtons.length &&
                    this.showMoreButtons.forEach((t) => {
                        t.removeEventListener("click", this.connectShowHiddenOptions);
                    });
        }
        expandingEvents() {
            this.showMoreButtons.length &&
                this.showMoreButtons.forEach((t) => {
                    t.addEventListener("click", gr(this.connectShowHiddenOptions, 500));
                });
        }
        showHiddenOptions(t) {
            const e = t.target.hasAttribute(ec) ? t.target : t.target.closest(`[${ec}]`);
            e.classList.add(rc),
                e.previousElementSibling.querySelectorAll(`.${rc}`).forEach((t) => {
                    t.classList.remove(rc);
                });
        }
        connectToggle(t = !1) {
            this.filtersToggleButtons.forEach((e) => {
                const i = null !== e.closest(`[${Yl}]`);
                ((i && t) || (i && !t) || (!i && !t)) && e.addEventListener("click", this.connectToggleMemory.bind(this));
            });
        }
        connectToggleFunction(t) {
            "true" === t.currentTarget.getAttribute("aria-expanded") ? this.hideFilters() : this.showFilters();
        }
        onFocusOut() {
            this.container.addEventListener(
                "focusout",
                function (t) {
                    if (window.innerWidth >= window.theme.sizes.medium) return;
                    const e = t.currentTarget.contains(t.relatedTarget),
                        i = this.container.classList.contains(ic);
                    document.body.classList.contains(nc) && i && !e && this.hideFilters();
                }.bind(this)
            ),
                this.container.addEventListener(
                    "keyup",
                    function (t) {
                        t.which === window.theme.keyboardKeys.ESCAPE && (this.hideFilters(), this.filtersToggleButtons[0].focus());
                    }.bind(this)
                ),
                this.underlay.addEventListener(
                    "click",
                    function () {
                        this.hideFilters();
                    }.bind(this)
                );
        }
        getShowOnLoad() {
            const t = `[${Xl}='false']`,
                e = document.querySelector(t),
                i = window.innerWidth >= window.theme.sizes.medium;
            return !(!e || !i);
        }
        showFilters() {
            (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                this.container.classList.remove(oc),
                setTimeout(() => {
                    this.filtersToggleButtons.forEach((t) => t.setAttribute("aria-expanded", !0)), this.filtersToggleButtons.forEach((t) => t.classList.add(ic)), this.container.classList.add(ic), this.container.querySelector(Zl).focus();
                }, 1);
        }
        hideFilters() {
            (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                this.filtersToggleButtons.forEach((t) => t.setAttribute("aria-expanded", !1)),
                this.container.classList.remove(ic),
                this.container.classList.remove(sc),
                this.filtersToggleButtons.forEach((t) => t.classList.remove(ic)),
                this.filtersToggleButtons.forEach((t) => t.classList.remove(sc)),
                setTimeout(() => {
                    this.container.classList.contains(ic) || this.container.classList.add(oc);
                }, 800);
        }
        constructor(t, e = !1) {
            (this.container = t),
                (this.underlay = this.container.querySelector(Gl)),
                (this.groupHeadings = this.container.querySelectorAll(`[${tc}]`)),
                (this.showMoreButtons = this.container.querySelectorAll(`[${ec}]`)),
                (this.triggerKey = this.container.getAttribute(Yl)),
                (this.selector = `[${Ql}='${this.triggerKey}']`),
                (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                (this.connectToggleMemory = (t) => this.connectToggleFunction(t)),
                (this.connectShowHiddenOptions = (t) => this.showHiddenOptions(t)),
                this.connectToggle(e),
                this.onFocusOut(),
                this.expandingEvents(),
                this.getShowOnLoad() ? this.showFilters() : this.hideFilters();
        }
    };
    const cc = {
            onLoad() {
                ac[this.id] = [];
                this.container.querySelectorAll(`[${Yl}]`).forEach((t) => {
                    ac[this.id].push(new lc(t));
                });
            },
            onUnload: function () {
                ac[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        hc = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-sidebar-filter-form]",
            inputs: "input, select, label, textarea",
            priceMin: "data-field-price-min",
            priceMax: "data-field-price-max",
            rangeMin: "data-se-min-value",
            rangeMax: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFiltersHolder: "[data-active-filters]",
            activeFiltersCount: "[data-active-filters-count]",
            productsCount: "[data-products-count]",
            dataSort: "data-sort-enabled",
            collectionTools: "[data-collection-tools]",
            filtersWrappper: "[data-filters]",
            headerSticky: '[data-header-sticky="sticky"]',
            headerHeight: "[data-header-height]",
            gridLarge: "data-grid-large",
            gridSmall: "data-grid-small",
            accordionBody: "[data-accordion-body]",
            checkedOption: "input:checked",
            optionHolder: "[data-option-holder]",
        },
        dc = "is-hidden",
        uc = "is-loading",
        pc = 1e3,
        mc = 1e3;
    const gc = {
        onLoad() {
            this.filterForm = new (class {
                init() {
                    this.showAllOptions(),
                        this.form &&
                            (new Kl(this.form),
                            this.sidebar.addEventListener(
                                "input",
                                A((t) => {
                                    const e = t.type,
                                        i = t.target;
                                    if (!hc.inputs.includes(e) || !this.form || "function" != typeof this.form.submit) return;
                                    const s = this.form.querySelector(`[${hc.priceMin}]`),
                                        o = this.form.querySelector(`[${hc.priceMax}]`);
                                    if (i.hasAttribute(hc.priceMin) || i.hasAttribute(hc.priceMax)) {
                                        const t = this.form.querySelector(`[${hc.rangeMin}]`),
                                            e = this.form.querySelector(`[${hc.rangeMax}]`);
                                        parseInt(t.getAttribute(hc.rangeMinDefault));
                                        const i = parseInt(e.getAttribute(hc.rangeMaxDefault));
                                        s.value && !o.value && (o.value = i),
                                            o.value && !s.value && (s.value = rangeMinDefault),
                                            s.value <= rangeMinDefault && o.value >= i && ((s.placeholder = rangeMinDefault), (o.placeholder = i), (s.value = ""), (o.value = ""));
                                    }
                                    this.filtering(t);
                                }, 1500)
                            ),
                            this.form.addEventListener("theme:range:update", (t) => this.updateRange(t))),
                        this.sidebar && this.sidebar.addEventListener("click", (t) => this.updateFilterFromUrl(t)),
                        this.activeFiltersHolder && this.activeFiltersHolder.addEventListener("click", (t) => this.updateFilterFromUrl(t)),
                        this.productsContainer && this.productsContainer.addEventListener("click", (t) => this.updateFilterFromUrl(t)),
                        Pt(this.sidebar);
                }
                updateRange(t) {
                    if (this.form && "function" == typeof this.form.submit) {
                        const e = this.form.querySelector(`[${hc.rangeMin}]`),
                            i = this.form.querySelector(`[${hc.rangeMax}]`),
                            s = this.form.querySelector(`[${hc.priceMin}]`),
                            o = this.form.querySelector(`[${hc.priceMax}]`);
                        if (e && i && s && o && e.hasAttribute(hc.rangeMin) && i.hasAttribute(hc.rangeMax)) {
                            const r = parseInt(s.placeholder),
                                n = parseInt(o.placeholder),
                                a = parseInt(e.getAttribute(hc.rangeMin)),
                                l = parseInt(i.getAttribute(hc.rangeMax));
                            (r === a && n === l) || ((s.value = a), (o.value = l), this.filtering(t));
                        }
                    }
                }
                updateFilterFromUrl(t) {
                    const e = t.target;
                    if (e.matches(hc.filterUpdateUrlButton) || (e.closest(hc.filterUpdateUrlButton) && e)) {
                        t.preventDefault();
                        const i = e.matches(hc.filterUpdateUrlButton) ? e : e.closest(hc.filterUpdateUrlButton);
                        this.filtering(t, i.getAttribute("href"));
                    }
                }
                addToHistory(t, e = "") {
                    const i = this.sort ? this.sort.getAttribute(hc.dataSort) : "";
                    if (!t || (t && "popstate" !== t.type)) {
                        if ("" === e) {
                            const e = new window.URL(window.location.href).searchParams,
                                s = Object.fromEntries(e),
                                o = e.toString();
                            if (o.includes("filter.") || o.includes("sort_by") || o.includes("page")) for (const t in s) (t.includes("filter.") || t.includes("sort_by") || t.includes("page")) && e.delete(t);
                            if (this.form) {
                                const t = new URLSearchParams(new FormData(this.form));
                                for (let [i, s] of t.entries()) i.includes("filter.") && s && e.append(i, s);
                                const i = this.form.querySelector(`[${hc.rangeMin}]`),
                                    s = this.form.querySelector(`[${hc.rangeMax}]`),
                                    o = this.form.querySelector(`[${hc.priceMin}]`),
                                    r = this.form.querySelector(`[${hc.priceMax}]`);
                                if (i && s && o && r && i.hasAttribute(hc.rangeMinDefault) && s.hasAttribute(hc.rangeMaxDefault)) {
                                    const t = parseFloat(i.getAttribute(hc.rangeMinDefault), 10),
                                        n = parseFloat(s.getAttribute(hc.rangeMaxDefault), 10),
                                        a = "" === o.value ? parseFloat(o.placeholder, 10) : parseFloat(o.value, 10),
                                        l = "" === r.value ? parseFloat(r.placeholder, 10) : parseFloat(r.value, 10);
                                    a <= t && l >= n && (e.delete("filter.v.price.gte"), e.delete("filter.v.price.lte"));
                                }
                            }
                            if (i || (t && t.detail && t.detail.href)) {
                                const s = i || t.detail.params;
                                e.set("sort_by", s);
                            }
                            const r = e.toString(),
                                n = r ? `?${r}` : location.pathname;
                            return void window.history.pushState(null, "", n);
                        }
                        window.history.pushState(null, "", e);
                    }
                }
                getFilterResult() {
                    this.productsContainer.classList.add(uc),
                        this.getGridValues(),
                        fetch(`${window.location.pathname}${window.location.search}`)
                            .then((t) => t.text())
                            .then((t) => {
                                const e = document.createElement("div");
                                (e.innerHTML = t),
                                    this.sidebar && (this.sidebar.innerHTML = e.querySelector(hc.collectionSidebar).innerHTML),
                                    this.activeFiltersCount && (this.activeFiltersCount.innerHTML = e.querySelector(hc.activeFiltersCount).innerHTML),
                                    (this.productsContainer.innerHTML = e.querySelector(hc.productsContainer).innerHTML),
                                    (this.activeFiltersHolder.innerHTML = e.querySelector(hc.activeFiltersHolder).innerHTML),
                                    this.activeFiltersHolder.parentNode.classList.toggle(dc, "" === this.activeFiltersHolder.innerHTML),
                                    this.productsCount && (this.productsCount.innerHTML = e.querySelector(hc.productsCount).innerHTML),
                                    this.setGridValues(),
                                    this.refreshFunctionalities(),
                                    setTimeout(() => {
                                        this.productsContainer.classList.remove(uc);
                                    }, pc);
                            });
                }
                refreshFunctionalities() {
                    (this.form = this.container.querySelector(hc.form)),
                        this.form && (new Kl(this.form), this.form.addEventListener("theme:range:update", (t) => this.updateRange(t))),
                        this.container.querySelectorAll(hc.filtersWrappper).forEach((t) => {
                            new lc(t, !0);
                        }),
                        this.container.querySelectorAll(hc.accordionBody).forEach((t) => {
                            new jn(t);
                        }),
                        new U(this.container),
                        this.sidebar && Pt(this.sidebar),
                        Zt(this.container),
                        this.showAllOptions();
                }
                getGridValues() {
                    this.layoutLarge && (this.layoutLargeValue = this.layoutLarge.getAttribute(hc.gridLarge)), this.layoutSmall && (this.layoutSmallValue = this.layoutSmall.getAttribute(hc.gridSmall));
                }
                setGridValues() {
                    this.layoutLarge && ((this.layoutLarge = this.container.querySelector(`[${hc.gridLarge}]`)), this.layoutLarge.setAttribute(hc.gridLarge, this.layoutLargeValue)),
                        this.layoutSmall && ((this.layoutSmall = this.container.querySelector(`[${hc.gridSmall}]`)), this.layoutSmall.setAttribute(hc.gridSmall, this.layoutSmallValue));
                }
                showAllOptions() {
                    this.container.querySelectorAll(hc.checkedOption).forEach((t) => {
                        if (t.closest(hc.optionHolder) && t.closest(hc.optionHolder).classList.contains(dc)) {
                            const e = t.closest(hc.accordionBody).nextElementSibling;
                            e.classList.contains(hc.classHidden) || e.dispatchEvent(new Event("click"));
                        }
                    });
                }
                filtering(t, e = "") {
                    const i = window.scrollY || window.pageYOffset,
                        s = this.headerIsSticky ? document.querySelector(hc.headerHeight).getBoundingClientRect().height : 0,
                        o = this.container.querySelector(hc.collectionTools),
                        r = o.offsetTop - s,
                        n = o.offsetTop + o.getBoundingClientRect().height < i - s;
                    n && window.scrollTo({ top: r, left: 0, behavior: "smooth" }),
                        setTimeout(
                            () => {
                                this.addToHistory(t, e), this.getFilterResult();
                            },
                            n ? mc : 10
                        );
                }
                constructor(t) {
                    (this.section = t),
                        (this.container = this.section.container),
                        (this.sidebar = this.container.querySelector(hc.collectionSidebar)),
                        (this.form = t.container.querySelector(hc.form)),
                        (this.sort = this.container.querySelector(`[${hc.dataSort}]`)),
                        (this.productsContainer = this.container.querySelector(hc.productsContainer)),
                        (this.activeFiltersHolder = this.container.querySelector(hc.activeFiltersHolder)),
                        (this.activeFiltersCount = this.container.querySelector(hc.activeFiltersCount)),
                        (this.productsCount = this.container.querySelector(hc.productsCount)),
                        (this.headerIsSticky = null !== document.querySelector(hc.headerSticky)),
                        (this.layoutLarge = this.container.querySelector(`[${hc.gridLarge}]`)),
                        (this.layoutSmall = this.container.querySelector(`[${hc.gridSmall}]`)),
                        this.productsContainer && this.sidebar && this.init(),
                        this.sort && this.container.addEventListener("theme:form:filter", (t) => this.filtering(t)),
                        (this.sidebar || this.sort) && window.addEventListener("popstate", (t) => this.filtering(t));
                }
            })(this);
        },
        onUnload() {
            this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload();
        },
    };
    Ze("search-page", [cc, gc, te, Vn]),
        customElements.get("popout-select") || customElements.define("popout-select", Yo),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Mo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr);
    const yc = "[data-image-zoom]",
        fc = "[data-modal-container]",
        wc = "data-unique",
        bc = "data-src";
    const vc = {
        onLoad() {
            new (class {
                init() {
                    this.triggers.forEach((t) => {
                        const e = t.getAttribute(wc),
                            i = this.modalContainer.querySelector(`#zoom-${e}`);
                        if (i) {
                            const t = this.container.querySelector(`#zoom-${e}`);
                            t && (i.parentNode.removeChild(i), this.modalContainer.appendChild(t));
                        }
                        r.init({
                            disableScroll: !0,
                            openTrigger: `data-popup-${e}`,
                            onShow: (t) => {
                                t.querySelectorAll(`[${bc}]`, t).forEach((t) => {
                                    if (null === t.getAttribute("src")) {
                                        const e = t.getAttribute(bc);
                                        t.setAttribute("src", e);
                                    }
                                });
                            },
                            onClose: (t, e, i) => {
                                i.preventDefault();
                            },
                        });
                    });
                }
                constructor(t) {
                    (this.container = t), (this.triggers = this.container.querySelectorAll(yc)), (this.modalContainer = document.querySelector(fc)), this.init();
                }
            })(this.container);
        },
    };
    Ze("gallery", [vc, dl, ae]);
    const Sc = (t, e) => {
        const { el: i, elStyle: s, elHeight: o, rowsLimit: r, rowsWrapped: n, options: a } = t;
        let l = t.buffer,
            c = l;
        if (n === r + 1) return { ...t };
        const h = l;
        let d = n,
            u = o;
        return (
            (i.innerHTML = c = l.length ? `${l}${a.delimiter}${e}${a.replaceStr}` : `${e}${a.replaceStr}`),
            parseFloat(s.height) > parseFloat(o) && (d++, (u = s.height), d === r + 1)
                ? ((i.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`), { ...t, elHeight: u, rowsWrapped: d })
                : ((i.innerHTML = c = h.length ? `${h}${a.delimiter}${e}` : `${e}`), { ...t, buffer: c, elHeight: u, rowsWrapped: d })
        );
    };
    let Ec = {},
        Lc = {},
        Tc = {};
    const kc = "[data-product-slideshow]",
        Ac = "[data-shopify-xr]",
        qc = "data-media-id",
        Cc = "data-model-id",
        Pc = "model-viewer",
        xc = "data-shopify-model3d-id",
        $c = "#ModelJson-";
    function Hc(t) {
        if (t) console.warn(t);
        else if (window.ShopifyXR) {
            for (const t in Ec)
                if (Ec.hasOwnProperty(t)) {
                    const e = Ec[t];
                    if (e.loaded) continue;
                    const i = document.querySelector(`${$c}${t}`);
                    i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), (e.loaded = !0));
                }
            window.ShopifyXR.setupXRElements();
        } else
            document.addEventListener("shopify_xr_initialized", function () {
                Hc();
            });
    }
    function _c(t) {
        if (t) console.warn(t);
        else
            for (const t in Lc)
                if (Lc.hasOwnProperty(t)) {
                    const e = Lc[t];
                    e.modelViewerUi || (e.modelViewerUi = new Shopify.ModelViewerUI(e.$element)), Ic(e);
                }
    }
    function Ic(t) {
        const e = Tc[t.sectionId];
        t.$container.addEventListener("pause", function () {
            t.modelViewerUi.pause && t.modelViewerUi.pause();
        }),
            t.$container.addEventListener("theme:media:play-desktop", function () {
                t.modelViewerUi.play && !Xa() && t.modelViewerUi.play(), e && e.$element && t && t.modelId && xc && e.$element.setAttribute(xc, t.modelId);
            }),
            t.$container.addEventListener("play", function () {
                t.modelViewerUi.play && t.modelViewerUi.play();
            });
    }
    async function Mc(t) {
        const e = document.querySelector(`[data-player="${t}"]`),
            i = e.querySelector("video");
        await Tt({ name: "video-ui", version: "1.0" });
        const s = new window.Shopify.Plyr(i);
        return (
            e.addEventListener("pause", function () {
                s.pause && s.pause();
            }),
            e.addEventListener("theme:media:play-desktop", function () {
                s.play && !Xa() && e.dispatchEvent(new CustomEvent("play"));
            }),
            e.addEventListener("play", function () {
                try {
                    s.play
                        ? s.play()
                        : s.addEventListener("onReady", function (t) {
                              t.target.play();
                          });
                } catch (t) {
                    console.warn(t);
                }
            }),
            e.addEventListener("destroy", function () {
                try {
                    s.destroy && s.destroy();
                } catch (t) {
                    console.warn(t);
                }
            }),
            s
        );
    }
    const Dc = {
            productSlideshow: "[data-product-slideshow]",
            slideshowMobileStyle: "data-slideshow-mobile-style",
            slideshowDesktopStyle: "data-slideshow-desktop-style",
            productThumbs: "[data-product-thumbs]",
            leftThumbsHolder: "[data-thumbs-holder]",
            thumbImage: "[data-slideshow-thumbnail]",
            mediaSlide: "[data-media-slide]",
            dataMediaId: "data-media-id",
            dataMediaSelect: "data-media-select",
            mediaType: "data-type",
            videoPlayerExternal: '[data-type="external_video"]',
            videoPlayerNative: '[data-type="video"]',
            modelViewer: '[data-type="model"]',
            allPlayers: "[data-player]",
            loopVideo: "data-enable-video-looping",
            verticalAlignment: "[data-thumbnails-left]",
            arrowPrev: "[data-thumbs-arrow-prev]",
            arrowNext: "[data-thumbs-arrow-next]",
            aspectRatio: "data-aspect-ratio",
            flickitylockHeight: "flickity-lock-height",
        },
        Wc = "is-activated",
        Bc = "show";
    function Fc(t) {
        return (
            t.addEventListener("onStateChange", function (t) {
                0 === t.data && t.target.playVideo();
            }),
            t
        );
    }
    const Oc = "data-store-availability-container",
        Nc = "[data-api-content]",
        zc = "[data-pickup-drawer]",
        Rc = "[data-pickup-drawer-open]",
        jc = "[data-pickup-drawer-close]",
        Vc = "[data-pickup-body]",
        Uc = "drawer--visible",
        Jc = "hide",
        Kc = "is-pickup-visible";
    let Yc = {};
    const Gc = {
            onLoad() {
                Yc[this.id] = new (class {
                    fetchPickupAvailability(t) {
                        const e = this.container.querySelector(`[${Oc}]`);
                        if (!e) return;
                        const i = t && t.detail.variant ? t.detail.variant.id : e.getAttribute(Oc);
                        !t || t.detail.variant
                            ? i &&
                              fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`)
                                  .then(this.handleErrors)
                                  .then((t) => t.text())
                                  .then((t) => {
                                      const i = new DOMParser().parseFromString(t, "text/html").querySelector(Nc).innerHTML;
                                      (e.innerHTML = i),
                                          e.classList.remove(Jc),
                                          (this.drawer = this.container.querySelector(zc)),
                                          (this.buttonDrawerOpen = this.container.querySelector(Rc)),
                                          (this.buttonDrawerClose = this.container.querySelectorAll(jc)),
                                          (this.drawerBody = this.container.querySelector(Vc)),
                                          this.buttonDrawerOpen && this.buttonDrawerOpen.addEventListener("click", () => this.openDrawer()),
                                          this.buttonDrawerClose.length &&
                                              this.buttonDrawerClose.forEach((t) => {
                                                  t.addEventListener("click", () => this.closeDrawer());
                                              });
                                  })
                                  .catch((t) => {
                                      console.error(t);
                                  })
                            : e.classList.add(Jc);
                    }
                    openDrawer() {
                        this.drawer &&
                            (document.body.classList.add(Kc),
                            this.drawer.classList.add(Uc),
                            this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                            this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                    }
                    closeDrawer() {
                        this.drawer &&
                            (document.body.classList.remove(Kc),
                            this.drawer.classList.remove(Uc),
                            this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                            this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
                    }
                    handleErrors(t) {
                        return t.ok
                            ? t
                            : t.json().then(function (e) {
                                  throw new B({ status: t.statusText, headers: t.headers, json: e });
                              });
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.drawer = null),
                            (this.buttonDrawerOpen = null),
                            (this.buttonDrawerClose = null),
                            (this.drawerBody = null),
                            this.fetchPickupAvailability(),
                            this.container.addEventListener("theme:variant:change", (t) => this.fetchPickupAvailability(t));
                    }
                })(this);
            },
        },
        Xc = (t) => {
            t && (t.style.display = "none");
        },
        Qc = "[data-product-form]",
        Zc = "data-option-position",
        th = '[name^="options"], [data-popout-option]',
        eh = "data-value",
        ih = "sold-out",
        sh = "unavailable";
    const oh = "[data-section-id]",
        rh = "[data-upsell-modal]",
        nh = "[data-product-form]",
        ah = "[data-product-slideshow]",
        lh = "[data-add-to-cart]",
        ch = "[data-add-to-cart-text]",
        hh = "[data-compare-price]",
        dh = "[data-compare-text]",
        uh = "[data-buttons-wrapper]",
        ph = "[data-product-select]",
        mh = "[data-price-wrapper]",
        gh = "[data-button-price]",
        yh = "[data-product-json]",
        fh = "[data-product-price]",
        wh = "[data-product-unit-price]",
        bh = "[data-product-base]",
        vh = "[data-product-unit]",
        Sh = "data-enable-history-state",
        Eh = "data-option-position",
        Lh = "[data-option-value]",
        Th = "[data-subscription-watch-price]",
        kh = "[data-subscription-selectors]",
        Ah = "[data-price-off]",
        qh = "[data-price-off-type]",
        Ch = "[data-price-off-amount]",
        Ph = "[data-toggles-group]",
        xh = "data-group-toggle",
        $h = "[data-plan-description]",
        Hh = "[data-remaining-count]",
        _h = "data-remaining-max",
        Ih = "[data-remaining-wrapper]",
        Mh = "[data-product-remaining-json]",
        Dh = "[data-product-preorder]",
        Wh = "hide",
        Bh = "variant--soldout",
        Fh = "variant--unavailable",
        Oh = "product__price--sale",
        Nh = "count-is-low",
        zh = "count-is-in",
        Rh = "count-is-out",
        jh = "count-is-unavailable";
    let Vh = class extends HTMLElement {
        connectedCallback() {
            (this.outerSection = this.container.closest(oh)),
                (this.upsell = this.container.closest(rh)),
                (this.outerWrapper = this.upsell ? this.upsell : this.outerSection),
                (this.productForm = this.container.querySelector(nh)),
                (this.slideshow = this.outerWrapper.querySelector(ah)),
                (this.enableHistoryState = !(!this.outerSection || !this.outerSection.hasAttribute(Sh)) && "true" === this.outerSection.getAttribute(Sh)),
                (this.hasUnitPricing = this.outerWrapper.querySelector(vh)),
                (this.subSelectors = this.outerWrapper.querySelector(kh)),
                (this.subPrices = this.outerWrapper.querySelector(Th)),
                (this.priceOffWrap = this.outerWrapper.querySelector(Ah)),
                (this.priceOffAmount = this.outerWrapper.querySelector(Ch)),
                (this.priceOffType = this.outerWrapper.querySelector(qh)),
                (this.planDecription = this.outerWrapper.querySelector($h)),
                (this.isPreOrder = this.container.querySelector(Dh)),
                (this.remainingWrapper = this.outerWrapper.querySelector(Ih));
            const t = this.outerWrapper.querySelector(`[${_h}]`);
            (this.sellout = null),
                this.remainingWrapper &&
                    t &&
                    ((this.remainingMaxInt = parseInt(t.getAttribute(_h), 10)),
                    (this.remainingCount = this.outerWrapper.querySelector(Hh)),
                    (this.remainingJSONWrapper = this.outerWrapper.querySelector(Mh)),
                    (this.remainingJSON = null),
                    this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)) : console.warn("Missing product quantity JSON")),
                hn(this.outerWrapper);
            let e = null;
            this.productJSON = null;
            const i = this.outerWrapper.querySelector(yh);
            i && (e = i.innerHTML),
                e && this.productForm
                    ? ((this.productJSON = JSON.parse(e)),
                      (this.sellout = new (class {
                          init() {
                              this.update();
                          }
                          update() {
                              this.getCurrentState(),
                                  this.optionElements.forEach((t) => {
                                      const e = t.value || t.getAttribute(eh),
                                          i = t.closest(`[${Zc}]`).getAttribute(Zc),
                                          s = parseInt(i, 10) - 1;
                                      let o = [...this.selections];
                                      o[s] = e;
                                      const r = this.productJSON.variants.find((t) => {
                                          let e = !0;
                                          for (let i = 0; i < o.length; i++) t.options[i] !== o[i] && (e = !1);
                                          return e;
                                      });
                                      t.classList.remove(ih, sh), void 0 === r ? t.classList.add(sh) : r && !1 === r.available && t.classList.add(ih);
                                  });
                          }
                          getCurrentState() {
                              for (var t of ((this.formData = new FormData(this.form)), (this.selections = []), this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1]);
                          }
                          constructor(t, e) {
                              (this.container = t),
                                  (this.productJSON = e),
                                  (this.form = this.container.querySelector(Qc)),
                                  (this.formData = new FormData(this.form)),
                                  (this.optionElements = this.container.querySelectorAll(th)),
                                  this.productJSON && this.form && this.init();
                          }
                      })(this.outerWrapper, this.productJSON)),
                      this.linkForm())
                    : console.warn("Missing product form or product JSON"),
                this.productJSON &&
                    new (class {
                        updateCookie() {
                            let t = this.cookie.read();
                            const e = t.indexOf(this.handle);
                            -1 === e ? (t.unshift(this.handle), (t = t.splice(0, X))) : (t.splice(e, 1), t.unshift(this.handle)), this.cookie.write(t);
                        }
                        constructor(t) {
                            (this.handle = t), (this.cookie = new Y(lt)), void 0 !== this.handle && (ht.push(this.handle), this.updateCookie());
                        }
                    })(this.productJSON.handle);
        }
        destroy() {
            this.productForm.destroy();
        }
        linkForm() {
            (this.productForm = new (class {
                destroy() {
                    this._listeners.removeAll();
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, function (t) {
                        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                variant() {
                    const t = this.options();
                    return t.length ? gt(this.product, t) : this.product.variants[0];
                }
                plan(t) {
                    let e = { allocation: null, group: null, detail: null };
                    const i = new FormData(this.form).get("selling_plan");
                    if (t && t.selling_plan_allocations && t.selling_plan_allocations.length > 0) {
                        const e = [...new Set(t.selling_plan_allocations.map((t) => t.selling_plan_group_id))],
                            i = this.element.querySelectorAll("[data-subscription-group]");
                        if (!i.length) return;
                        i.forEach((t) => (t.style.display = "none")),
                            e.forEach((t) => {
                                this.element.querySelector(`[data-selling-plan-group="${t}"]`).style.display = "block";
                            });
                    }
                    return (
                        i &&
                            t &&
                            (e.allocation = t.selling_plan_allocations.find(function (t) {
                                return t.selling_plan_id.toString() === i.toString();
                            })),
                        e.allocation &&
                            (e.group = this.product.selling_plan_groups.find(function (t) {
                                return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                            })),
                        e.group &&
                            (e.detail = e.group.selling_plans.find(function (t) {
                                return t.id.toString() === i.toString();
                            })),
                        e && e.allocation && e.detail && e.allocation ? e : null
                    );
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, function (t) {
                        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                }
                getFormState() {
                    const t = this.variant();
                    return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                }
                _setIdInputValue(t) {
                    t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                }
                _onSubmit(t, e) {
                    (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant);
                }
                _onFormEvent(t) {
                    return void 0 === t
                        ? Function.prototype
                        : function (e) {
                              (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                          }.bind(this);
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                        function (t) {
                            return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                        }.bind(this)
                    );
                }
                _serializeInputValues(t, e) {
                    return t.reduce(function (t, i) {
                        return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && t.push(e({ name: i.name, value: i.value })), t;
                    }, []);
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t;
                }
                constructor(t, e, i) {
                    (this.element = t),
                        (this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form")),
                        (this.product = this._validateProductObject(e)),
                        (this.variantElement = this.element.querySelector(ft)),
                        (i = i || {}),
                        (this.clickedElement = null),
                        (this._listeners = new mt()),
                        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
                        (this.optionInputs = this._initInputs(bt, i.onOptionChange)),
                        (this.planInputs = this._initInputs(wt, i.onPlanChange)),
                        (this.quantityInputs = this._initInputs(vt, i.onQuantityChange)),
                        (this.propertyInputs = this._initInputs(St, i.onPropertyChange));
                }
            })(this.outerWrapper, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this), onQuantityChange: this.onQuantityChange.bind(this) })),
                this.pushState(this.productForm.getFormState()),
                this.subsToggleListeners();
        }
        onOptionChange(t) {
            this.pushState(t.dataset);
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset);
        }
        onQuantityChange(t) {
            const e = t.dataset;
            (this.productState = this.setProductState(e)), this.updateButtonPrices(e);
        }
        pushState(t) {
            (this.productState = this.setProductState(t)),
                this.updateProductImage(t),
                this.updateAddToCartState(t),
                this.updateProductPrices(t),
                this.updateSaleText(t),
                this.updateSubscriptionText(t),
                this.updateLegend(t),
                this.updateRemaining(t),
                this.fireHookEvent(t),
                this.sellout && this.sellout.update(t),
                this.enableHistoryState && this.updateHistoryState(t);
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let i = theme.strings.addToCart;
            const s = this.outerWrapper.querySelectorAll(mh),
                o = this.outerWrapper.querySelector(uh),
                r = o.querySelectorAll(lh),
                n = o.querySelectorAll(ch);
            if (
                (this.isPreOrder && (i = theme.strings.preOrder),
                s.length &&
                    e &&
                    s.forEach((t) => {
                        t.classList.remove(Wh);
                    }),
                r.length &&
                    r.forEach((t) => {
                        e && e.available ? (t.disabled = !1) : (t.disabled = !0);
                    }),
                n.length &&
                    n.forEach((t) => {
                        e ? (e.available ? (t.innerHTML = i) : (t.innerHTML = theme.strings.soldOut)) : (t.innerHTML = theme.strings.unavailable);
                    }),
                o)
            )
                if (e) {
                    e.available ? o.classList.remove(Bh, Fh) : (o.classList.add(Bh), o.classList.remove(Fh));
                    const t = o.querySelector(ph);
                    t && (t.value = e.id);
                } else o.classList.add(Fh), o.classList.remove(Bh);
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                this.container.parentNode.querySelectorAll(Lh).forEach((t) => {
                    const i = t.closest(`[${Eh}]`);
                    if (i) {
                        const s = i.getAttribute(Eh),
                            o = parseInt(s, 10) - 1;
                        (this.newValue = e.options[o]), (t.innerHTML = this.newValue);
                    }
                });
            }
        }
        updateHistoryState(t) {
            const e = t.variant,
                i = t.plan,
                s = window.location.href;
            if (e && s.includes("/product")) {
                const t = new window.URL(s),
                    o = t.searchParams;
                o.set("variantss", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), (t.search = o.toString());
                const r = t.toString();
                //window.history.replaceState({ path: r }, "", r);
            }
        }
        updateRemaining(t) {
            const e = t.variant;
            if (e && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                const t = this.remainingJSON[e.id];
                t && t <= this.remainingMaxInt && t > 0
                    ? (this.remainingWrapper.classList.remove(zh, Rh, jh), this.remainingWrapper.classList.add(Nh), (this.remainingCount.innerHTML = t))
                    : this.productState.soldOut
                    ? (this.remainingWrapper.classList.remove(Nh, zh, jh), this.remainingWrapper.classList.add(Rh))
                    : this.productState.available && (this.remainingWrapper.classList.remove(Nh, Rh, jh), this.remainingWrapper.classList.add(zh));
            } else this.remainingWrapper && (this.remainingWrapper.classList.remove(zh, Rh, Nh), this.remainingWrapper.classList.add(jh));
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
            this.outerWrapper.querySelectorAll(Ph).forEach((t) => {
                t.addEventListener(
                    "change",
                    function (t) {
                        const e = t.target.value.toString(),
                            i = this.outerWrapper.querySelector(`[${xh}="${e}"]`),
                            s = this.outerWrapper.querySelectorAll(`[${xh}]`);
                        if (i) {
                            i.classList.remove(Wh);
                            const t = i.querySelector('[name="selling_plan"]');
                            (t.checked = !0), t.dispatchEvent(new Event("change"));
                        }
                        s.forEach((t) => {
                            if (t !== i) {
                                t.classList.add(Wh);
                                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                    (t.checked = !1), t.dispatchEvent(new Event("change"));
                                });
                            }
                        });
                    }.bind(this)
                );
            });
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(Wh);
        }
        updateSaleTextStandard(t) {
            if (!this.priceOffType) return;
            this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
            const e = t.variant;
            if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                const t = (e.compare_at_price - e.price) / e.compare_at_price,
                    i = Math.floor(100 * t);
                this.priceOffAmount.innerHTML = `${i}%`;
            } else {
                const t = e.compare_at_price - e.price;
                this.priceOffAmount.innerHTML = this.formattingMoney(t);
            }
            this.priceOffWrap.classList.remove(Wh);
        }
        updateSaleTextSubscription(t) {
            this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
            const e = t.variant,
                i = t.plan.detail.price_adjustments[0],
                s = i.value;
            i && "percentage" === i.value_type
                ? (this.priceOffAmount.innerHTML = `${s}%`)
                : i && "price" === i.value_type
                ? (this.priceOffAmount.innerHTML = this.formattingMoney(e.price - i.value))
                : (this.priceOffAmount.innerHTML = this.formattingMoney(s)),
                this.priceOffWrap.classList.remove(Wh);
        }
        updateSubscriptionText(t) {
            t.plan && this.planDecription && null !== t.plan.detail.description
                ? ((this.planDecription.innerHTML = t.plan.detail.description), this.planDecription.classList.remove(Wh))
                : this.planDecription && this.planDecription.classList.add(Wh);
        }
        getPrices(t) {
            const e = t.variant,
                i = t.plan;
            let s = "",
                o = "";
            return (
                this.productState.available && ((s = e.compare_at_price), (o = e.price)),
                this.productState.hasPlan && (o = i.allocation.price),
                this.productState.planSale && ((s = i.allocation.compare_at_price), (o = i.allocation.price)),
                { price: o, comparePrice: s }
            );
        }
        updateButtonPrices(t) {
            const e = this.outerWrapper.querySelectorAll(gh),
                { price: i } = this.getPrices(t);
            e.length &&
                e.forEach((e) => {
                    const s = t.quantity * i;
                    e.innerHTML = this.formattingMoney(s);
                });
        }
        updateProductPrices(t) {
            const e = t.variant,
                i = this.outerWrapper.querySelectorAll(mh),
                s = this.outerWrapper.querySelectorAll(gh),
                { price: o, comparePrice: r } = this.getPrices(t);
            i.forEach((t) => {
                const i = t.querySelector(hh),
                    s = t.querySelector(fh),
                    n = t.querySelector(dh);
                i &&
                    (this.productState.onSale || this.productState.planSale ? (i.classList.remove(Wh), n.classList.remove(Wh), s.classList.add(Oh)) : (i.classList.add(Wh), n.classList.add(Wh), s.classList.remove(Oh)),
                    (i.innerHTML = this.formattingMoney(r))),
                    s && (s.innerHTML = e ? this.formattingMoney(o) : "&nbsp;");
            }),
                s.length &&
                    s.forEach((e) => {
                        const i = t.quantity * o;
                        e.innerHTML = this.formattingMoney(i);
                    }),
                this.hasUnitPricing && this.updateProductUnits(t);
        }
        updateProductUnits(t) {
            const e = t.variant,
                i = t.plan;
            let s = null;
            if ((e && e.unit_price && (s = e.unit_price), i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price), s)) {
                const t = this.getBaseUnit(e);
                (this.outerWrapper.querySelector(wh).innerHTML = this.formattingMoney(s)), (this.outerWrapper.querySelector(bh).innerHTML = t), W(this.outerWrapper.querySelector(vh));
            } else Xc(this.outerWrapper.querySelector(vh));
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
        }
        setProductState(t) {
            const e = t.variant,
                i = t.plan,
                s = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
            return (
                !e || (e.requires_selling_plan && !i)
                    ? (s.available = !1)
                    : (e.available || (s.soldOut = !0),
                      e.compare_at_price > e.price && (s.onSale = !0),
                      e.unit_price && (s.showUnitPrice = !0),
                      this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0),
                      i && this.subPrices && ((s.hasPlan = !0), i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0))),
                s
            );
        }
        updateProductImage(t) {
            const e = t.variant;
            e && this.slideshow && e.featured_media && e.featured_media.id && this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: e.featured_media.id } }));
        }
        formattingMoney(t) {
            return theme.settings.currency_code_enable ? a.formatMoney(t, theme.moneyFormat) + ` ${theme.currencyCode}` : a.formatMoney(t, theme.moneyFormat);
        }
        constructor() {
            super(), (this.container = this);
        }
    };
    const Uh = "[data-product-slideshow]",
        Jh = "[data-product-image]",
        Kh = "[data-zoom-button]",
        Yh = "[data-zoom-wrapper]",
        Gh = "data-media-id";
    const Xh = "body",
        Qh = "[data-related-section]",
        Zh = "[data-tabs-holder]",
        td = "data-tab",
        ed = "data-tab-index",
        id = "data-block-id",
        sd = ".tabs > button",
        od = ".tab-link",
        rd = ".tab-link__recent",
        nd = ".tab-content",
        ad = "[data-scrollbar]",
        ld = "a:first-child, input:first-child",
        cd = "current",
        hd = "hide",
        dd = "alt",
        ud = "is-focused",
        pd = {};
    const md = {
            onLoad() {
                pd[this.id] = [];
                this.container.querySelectorAll(Zh).forEach((t) => {
                    pd[this.id].push(
                        new (class {
                            init() {
                                const t = this.container,
                                    e = t.querySelectorAll(sd),
                                    i = t.querySelector(`${od}-0`),
                                    s = t.querySelector(`${nd}-0`);
                                s && s.classList.add(cd),
                                    i && i.classList.add(cd),
                                    this.checkVisibleTabLinks(),
                                    this.container.addEventListener("theme:tabs:check", () => this.checkRecentTab()),
                                    this.container.addEventListener("theme:tabs:hide", () => this.hideRelatedTab()),
                                    e.length &&
                                        e.forEach((e) => {
                                            const i = parseInt(e.getAttribute(td)),
                                                s = t.querySelector(`${nd}-${i}`);
                                            e.addEventListener("click", () => {
                                                this.tabChange(e, s);
                                            }),
                                                e.addEventListener("keyup", (t) => {
                                                    (t.which !== window.theme.keyboardKeys.SPACE && t.which !== window.theme.keyboardKeys.ENTER) ||
                                                        !this.body.classList.contains(ud) ||
                                                        (this.tabChange(e, s), s.querySelector("a, input") && ((this.accessibility.lastFocused = e), this.accessibility.a11y.trapFocus(s, { elementToFocus: s.querySelector(ld) })));
                                                });
                                        });
                            }
                            tabChange(t, e) {
                                this.container.querySelector(`${sd}.${cd}`).classList.remove(cd),
                                    this.container.querySelector(`${nd}.${cd}`).classList.remove(cd),
                                    t.classList.add(cd),
                                    e.classList.add(cd),
                                    t.classList.contains(hd) && e.classList.add(hd),
                                    this.checkVisibleTabLinks(),
                                    this.container.dispatchEvent(new CustomEvent("theme:tab:change"));
                            }
                            initNativeScrollbar() {
                                this.scrollbarHolder.length &&
                                    this.scrollbarHolder.forEach((t) => {
                                        new j(t);
                                    });
                            }
                            checkVisibleTabLinks() {
                                const t = this.container.querySelectorAll(sd),
                                    e = this.container.querySelectorAll(`${od}.${hd}`);
                                t.length - e.length < 2 ? this.container.classList.add(dd) : this.container.classList.remove(dd);
                            }
                            checkRecentTab() {
                                const t = this.container.querySelector(rd);
                                if (t) {
                                    t.classList.remove(hd);
                                    const e = parseInt(t.getAttribute(td)),
                                        i = this.container.querySelector(`${nd}[${ed}="${e}"]`);
                                    i && i.classList.remove(hd), this.checkVisibleTabLinks(), this.initNativeScrollbar();
                                }
                            }
                            hideRelatedTab() {
                                const t = this.container.querySelector(Qh);
                                if (!t) return;
                                const e = t.closest(`${nd}.${cd}`);
                                if (!e) return;
                                const i = parseInt(e.getAttribute(ed)),
                                    s = this.container.querySelectorAll(sd);
                                if (s.length > i) {
                                    const t = s[i].nextSibling;
                                    t && (s[i].classList.add(hd), t.dispatchEvent(new Event("click")), this.initNativeScrollbar());
                                }
                            }
                            onBlockSelect(t) {
                                const e = this.container.querySelector(`${od}[${id}="${t.detail.blockId}"]`);
                                e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                            }
                            constructor(t) {
                                (this.container = t),
                                    (this.body = document.querySelector(Xh)),
                                    (this.accessibility = window.accessibility),
                                    this.container && ((this.scrollbarHolder = this.container.querySelectorAll(ad)), this.init(), this.initNativeScrollbar());
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                pd[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
        },
        gd = "[data-share-url]",
        yd = "data-section-type",
        fd = "[data-share-details]",
        wd = "[data-share-summary]",
        bd = "[data-share-copy]",
        vd = "[data-share-button]",
        Sd = "[data-close-button]",
        Ed = "[data-success-message]",
        Ld = "[data-share-holder]",
        Td = "is-hidden";
    let kd = class extends HTMLElement {
        init() {
            navigator.share
                ? (this.mainDetailsToggle.classList.add(Td),
                  this.shareButton.classList.remove(Td),
                  this.shareButton.addEventListener("click", () => {
                      navigator.share({ url: this.urlToShare, title: document.title });
                  }))
                : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)),
                  this.mainDetailsToggle.addEventListener("focusout", () => {
                      setTimeout(() => {
                          this.contains(document.activeElement) || this.close();
                      });
                  }),
                  this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)),
                  this.closeButton.addEventListener("click", this.close.bind(this)),
                  this.container.addEventListener("keyup", this.keyboardEvents.bind(this)));
        }
        updateShareLink() {
            // "product" == this.container.getAttribute(yd) &&
            //     this.container.addEventListener("theme:variant:change", (t) => {
            //         t.detail.variant && ((this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`), this.urlInput && (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`));
            //     });
        }
        toggleDetails() {
            this.mainDetailsToggle.open || (this.successMessage.classList.add(Td), (this.successMessage.textContent = ""), this.closeButton.classList.add(Td), this.shareCopy.focus());
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlInput.value).then(() => {
                this.successMessage.classList.remove(Td), (this.successMessage.textContent = theme.strings.successMessage), this.closeButton.classList.remove(Td), this.closeButton.focus();
            });
        }
        close() {
            this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1);
        }
        keyboardEvents(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this.mainDetailsToggle.focus(), this.close());
        }
        constructor() {
            super(),
                (this.container = this.closest(`[${yd}]`)),
                (this.mainDetailsToggle = this.querySelector(fd)),
                (this.shareButton = this.querySelector(vd)),
                (this.shareCopy = this.querySelector(bd)),
                (this.shareSummary = this.querySelector(wd)),
                (this.closeButton = this.querySelector(Sd)),
                (this.successMessage = this.querySelector(Ed)),
                (this.shareHolder = this.querySelector(Ld)),
                (this.urlInput = this.querySelector(gd)),
                (this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href),
                this.init();
                //this.updateShareLink();
        }
    };
    const Ad = "data-image-filter",
        qd = "[data-product-slideshow]",
        Cd = "[data-product-thumbs]",
        Pd = "[data-slideshow-thumbnail]",
        xd = "[data-media-slide]",
        $d = "hide",
        Hd = "flickity-enabled";
    const _d = "[data-product-json]",
        Id = "[data-zoom-button]",
        Md = "[data-truncated-holder]",
        Dd = "[data-truncated-button]",
        Wd = "data-truncated-content",
        Bd = "is-expanded",
        Fd = "is-visible",
        Od = [];
    const Nd = {
        onLoad() {
            Od[this.id] = new (class {
                init() {
                    var t, e;
                    (this.zoomEnabled = null !== this.container.querySelector(Id)),
                        this.zoomEnabled &&
                            ((t = this.container),
                            (e = this.product),
                            Tt({ url: window.theme.assets.photoswipe })
                                .then(() => {
                                    const i = window.themePhotoswipe.PhotoSwipe.default,
                                        s = window.themePhotoswipe.PhotoSwipeUI.default;
                                    t.querySelectorAll(Kh).forEach((o) => {
                                        o.addEventListener("click", (o) => {
                                            const r = t.querySelector(Yh),
                                                n = o.target.closest(`[${Gh}]`).getAttribute(Gh).toString(),
                                                a = [];
                                            for (let t = 0; t < e.media.length; t++) "image" === e.media[t].media_type && (a[a.length] = { src: e.media[t].src, w: e.media[t].width, h: e.media[t].height, id: e.media[t].id });
                                            const l = {
                                                index: a.findIndex((t) => t.id.toString() === n),
                                                showHideOpacity: !0,
                                                showAnimationDuration: 150,
                                                hideAnimationDuration: 250,
                                                bgOpacity: 1,
                                                spacing: 0,
                                                allowPanToNext: !1,
                                                maxSpreadZoom: 3,
                                                history: !1,
                                                loop: !0,
                                                pinchToClose: !1,
                                                modal: !1,
                                                closeOnScroll: !1,
                                                closeOnVerticalDrag: !0,
                                                getDoubleTapZoom: function (t, e) {
                                                    return t ? 1.67 : e.initialZoomLevel < 0.7 ? 1 : 1.3;
                                                },
                                                getThumbBoundsFn: function () {
                                                    let e = t.querySelector(Uh);
                                                    e || (e = t.querySelector(Jh));
                                                    const i = window.pageYOffset || document.documentElement.scrollTop,
                                                        s = e.getBoundingClientRect();
                                                    return { x: s.left, y: s.top + i, w: s.width };
                                                },
                                            };
                                            r.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                                            const c = new i(r, s, a, l);
                                            c.init(),
                                                c.listen("close", function () {
                                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                                });
                                        });
                                    });
                                })
                                .catch((t) => console.error(t))),
                        this.truncateElementHolder && this.truncateElement && (setTimeout(this.resizeEventTruncate, 50), document.addEventListener("theme:resize", this.resizeEventTruncate)),
                        new br(this.container);
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(Fd)) return;
                    const t = this.truncateElement.querySelectorAll("style");
                    t.length &&
                        t.forEach((t) => {
                            this.truncateElementHolder.prepend(t);
                        });
                    const e = this.truncateElement.cloneNode(!0),
                        i = this.truncateElement.getAttribute(Wd),
                        s = this.truncateElement.nextElementSibling;
                    s && s.remove(), this.truncateElement.parentElement.append(e);
                    const o = this.truncateElement.nextElementSibling;
                    o.classList.add(i),
                        o.removeAttribute(Wd),
                        W(o),
                        ((t = "", e = 1, i = {}) => {
                            const s = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...i },
                                o = t && (t instanceof NodeList ? t : 1 === t.nodeType ? [t] : document.querySelectorAll(t));
                            for (let t = 0; t < o.length; t++) {
                                const i = o[t],
                                    r = /<!--[\s\S]*?-->/g,
                                    n = i.innerHTML.replace(r, "").split(s.delimiter);
                                i.innerHTML = "";
                                const a = window.getComputedStyle(i);
                                n.reduce(Sc, { el: i, buffer: i.innerHTML, elStyle: a, elHeight: 0, rowsLimit: e, rowsWrapped: 0, options: s });
                            }
                        })(o, 5, { replaceStr: "", delimiter: " " }),
                        Xc(o),
                        this.truncateElement.innerHTML !== o.innerHTML ? this.truncateElementHolder.classList.add(Bd) : (o.remove(), this.truncateElementHolder.classList.remove(Bd)),
                        this.toggleTruncatedContent(this.truncateElementHolder);
                }
                toggleTruncatedContent(t) {
                    const e = t.querySelector(Dd);
                    e &&
                        e.addEventListener("click", (e) => {
                            e.preventDefault(), t.classList.remove(Bd), t.classList.add(Fd);
                        });
                }
                onBlockSelect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"));
                }
                onBlockDeselect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"));
                }
                onUnload() {
                    this.media.destroy(), this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEventTruncate);
                }
                constructor(e) {
                    (this.section = e),
                        (this.id = e.id),
                        (this.container = e.container),
                        (this.settings = e.settings),
                        di(this.id),
                        (this.media = new (class {
                            init() {
                                this.storeEvents(),
                                    this.connectSliderMediaEvents(),
                                    this.detectVideo(),
                                    this.detectYouTube(),
                                    this.detect3d(),
                                    this.scrollThumbs(),
                                    document.addEventListener("theme:resize:width", () => {
                                        this.scrollThumbs();
                                    });
                            }
                            connectSliderMediaEvents() {
                                const t = `(max-width: ${window.theme.sizes.medium}px)`,
                                    e = window.matchMedia(t);
                                e.addEventListener("change", (t) => {
                                    t.matches ? this.createMobileSlider() : this.createDesktopSlider();
                                }),
                                    e.matches ? this.createMobileSlider() : this.createDesktopSlider();
                            }
                            createMobileSlider() {
                                this.flkty && this.destroySlider();
                                const t = { autoPlay: !1, prevNextButtons: !1, pageDots: !1, adaptiveHeight: !0, accessibility: !0, watchCSS: !1, wrapAround: !0, rightToLeft: window.isRTL, dragThreshold: 80, contain: !0, fade: !0 };
                                "carousel" == this.mobileStyle && ((t.contain = !1), (t.dragThreshold = 10), (t.fade = !1)),
                                    "slideshow" == this.mobileStyle && ((t.pageDots = !0), (t.fade = !1), (t.dragThreshold = 10)),
                                    this.createSlider(t);
                            }
                            createDesktopSlider() {
                                if ((this.flkty && this.destroySlider(), "none" == this.desktopStyle)) return;
                                const t = { autoPlay: !1, prevNextButtons: !1, pageDots: !1, adaptiveHeight: !0, accessibility: !0, watchCSS: !1, wrapAround: !0, rightToLeft: window.isRTL, dragThreshold: 80, contain: !0, fade: !0 };
                                this.createSlider(t);
                            }
                            createSlider(t) {
                                (this.flkty = new s(this.slideshow, t)), this.flkty.resize(), (this.currentSlide = this.slideshow.querySelectorAll(Dc.mediaSlide)[0]), this.setDraggable(), this.addEventListeners();
                            }
                            destroySlider() {
                                this.removeEventListeners(), this.flkty.destroy();
                            }
                            storeEvents() {
                                (this.storeFlktyChange = (t) => this.doFlktyChange(t)),
                                    (this.storeFlktySettle = (t) => this.doFlktySettle(t)),
                                    (this.storeImageChange = (t) => this.doImageChange(t)),
                                    (this.storeArrowPrevClick = (t) => this.doArrowPrevClick(t)),
                                    (this.storeArrowNextClick = (t) => this.doArrowNextClick(t)),
                                    (this.storeThumbClick = (t) => this.doThumbClick(t)),
                                    (this.storeThumbContainerScroll = (t) => this.doThumbContainerScroll(t));
                            }
                            addEventListeners() {
                                var t, e, i;
                                this.flkty.on("change", this.storeFlktyChange),
                                    this.flkty.on("settle", this.storeFlktySettle),
                                    this.slideshow.addEventListener("theme:image:change", this.storeImageChange),
                                    null === (t = this.arrowPrev) || void 0 === t || t.addEventListener("click", this.storeArrowPrevClick),
                                    null === (e = this.arrowNext) || void 0 === e || e.addEventListener("click", this.storeArrowNextClick),
                                    null === (i = this.thumbs) || void 0 === i || i.addEventListener("scroll", this.storeThumbContainerScroll),
                                    this.thumbImages.forEach((t) => {
                                        t.addEventListener("click", this.storeThumbClick);
                                    });
                            }
                            removeEventListeners() {
                                var t, e, i;
                                this.flkty.on("change", this.storeFlktyChange),
                                    this.flkty.on("settle", this.storeFlktySettle),
                                    this.slideshow.removeEventListener("theme:image:change", this.storeImageChange),
                                    null === (t = this.arrowPrev) || void 0 === t || t.removeEventListener("click", this.storeArrowPrevClick),
                                    null === (e = this.arrowNext) || void 0 === e || e.removeEventListener("click", this.storeArrowNextClick),
                                    null === (i = this.thumbs) || void 0 === i || i.removeEventListener("scroll", this.storeThumbContainerScroll),
                                    this.thumbImages.forEach((t) => {
                                        t.removeEventListener("click", this.storeThumbClick);
                                    });
                            }
                            doFlktyChange(t) {
                                var e, i;
                                this.currentSlide.dispatchEvent(new CustomEvent("pause")), (this.currentSlide = this.flkty.cells[t].element), this.slideshow.classList.remove(Dc.flickitylockHeight);
                                const s = this.currentSlide.getAttribute(Dc.dataMediaId),
                                    o = null === (e = this.thumbWrapper) || void 0 === e ? void 0 : e.querySelector(`[${Dc.dataMediaSelect}="${s}"]`);
                                null === (i = this.thumbWrapper) || void 0 === i || i.querySelector(`.${Wc}`).classList.remove(Wc), null == o || o.classList.add(Wc), this.scrollThumbs();
                            }
                            doFlktySettle(t) {
                                (this.allSlides = this.flkty.cells),
                                    (this.currentSlide = this.flkty.cells[t].element),
                                    this.setDraggable(),
                                    this.currentSlide.dispatchEvent(new CustomEvent("theme:media:play-desktop")),
                                    document.body.classList.contains(Dc.focusEnabled) && this.currentSlide.dispatchEvent(new Event("focus")),
                                    this.scrollThumbs();
                            }
                            doImageChange(t) {
                                var e = t.detail.id;
                                const i = `[${Dc.dataMediaId}="${e}"]`,
                                    s = this.flkty.cells.findIndex((t) => t.element.matches(i));
                                this.flkty.select(s), this.scrollThumbs();
                            }
                            doThumbContainerScroll() {
                                this.scrollThumbs("scroll");
                            }
                            doArrowPrevClick() {
                                this.scrollThumbs("clickPrev");
                            }
                            doArrowNextClick() {
                                this.scrollThumbs("clickNext");
                            }
                            doThumbClick(t) {
                                const e = t.currentTarget.getAttribute(Dc.dataMediaSelect);
                                this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: e } }));
                            }
                            setDraggable() {
                                if (this.currentSlide) {
                                    const t = this.currentSlide.getAttribute(Dc.mediaType);
                                    "model" === t || "video" === t || "external_video" === t ? ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()) : ((this.flkty.options.draggable = !0), this.flkty.updateDraggable());
                                }
                            }
                            detect3d() {
                                const t = this.container.querySelectorAll(Dc.modelViewer);
                                t &&
                                    (t.forEach((t) => {
                                        !(function (t, e) {
                                            Ec[e] = { loaded: !1 };
                                            const i = t.getAttribute(qc),
                                                s = t.querySelector(Pc),
                                                o = s.getAttribute(Cc);
                                            if (null !== t.closest(kc)) {
                                                const i = t.closest(kc).parentElement.querySelector(Ac);
                                                Tc[e] = { $element: i, defaultId: o };
                                            }
                                            (Lc[i] = { modelId: o, mediaId: i, sectionId: e, $container: t, $element: s }),
                                                window.Shopify.loadFeatures([
                                                    { name: "shopify-xr", version: "1.0", onLoad: Hc },
                                                    { name: "model-viewer-ui", version: "1.0", onLoad: _c },
                                                ]);
                                        })(t, this.section.id);
                                    }),
                                    document.addEventListener(
                                        "shopify_xr_launch",
                                        function () {
                                            this.container.querySelectorAll(Dc.allPlayers).forEach((t) => {
                                                t.dispatchEvent(new CustomEvent("pause"));
                                            });
                                        }.bind(this)
                                    ));
                            }
                            detectVideo() {
                                const t = this.section.container.querySelectorAll(Dc.videoPlayerNative);
                                for (var e of t) {
                                    const t = Mc(e.dataset.player);
                                    !0 === this.loopVideo &&
                                        t
                                            .then((t) => ((t.loop = !0), t))
                                            .catch((t) => {
                                                console.error(t);
                                            });
                                }
                            }
                            detectYouTube() {
                                const t = this.section.container.querySelectorAll(Dc.videoPlayerExternal);
                                for (var e of t) {
                                    const t = el(e.dataset.player);
                                    !0 === this.loopVideo &&
                                        t
                                            .then((t) => Fc(t))
                                            .catch((t) => {
                                                console.error(t);
                                            });
                                }
                            }
                            pauseAllMedia() {
                                this.container.querySelector(Dc.mediaSlide).dispatchEvent(new CustomEvent("pause"));
                            }
                            pauseOtherMedia(t) {
                                this.container.querySelector(`${Dc.mediaSlide}:not([data-player="${t}"])`).dispatchEvent(new CustomEvent("pause"));
                            }
                            destroy() {
                                this.container.querySelectorAll(Dc.allPlayers).forEach((t) => {
                                    t.dispatchEvent(new CustomEvent("destroy"));
                                });
                            }
                            scrollThumbs(t) {
                                if (((this.thumbs = this.container.querySelector(Dc.productThumbs)), this.thumbs)) {
                                    if (((this.thumb = this.thumbs.querySelector(`.${Wc}`)), (this.thumbItems = this.container.querySelectorAll(Dc.thumbImage)), (this.lastThumb = this.thumbItems[this.thumbItems.length - 1]), !this.thumb))
                                        return;
                                    (this.thumbsScrollTop = this.thumbs.scrollTop),
                                        (this.thumbsScrollLeft = this.thumbs.scrollLeft),
                                        (this.thumbsWidth = this.thumbs.offsetWidth),
                                        (this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(Dc.aspectRatio)),
                                        (this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight),
                                        (this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth),
                                        this.checkThumbPositions(),
                                        this.toggleToActiveThumb(t),
                                        this.toggleArrows();
                                }
                            }
                            checkThumbPositions() {
                                (this.thumbWidth = this.thumb.offsetWidth),
                                    (this.thumbHeight = this.thumb.offsetHeight),
                                    (this.thumbPosTop = this.thumb.offsetTop),
                                    (this.thumbPosLeft = this.thumb.offsetLeft),
                                    (this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth),
                                    (this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight),
                                    (this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2),
                                    (this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2),
                                    (this.topCheck = this.thumbsScrollTop > 0),
                                    (this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos),
                                    (this.leftCheck = this.thumbsScrollLeft > 0),
                                    (this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos),
                                    (this.verticalCheck = this.bottomCheck || this.topCheck),
                                    (this.horizontalCheck = this.rightCheck || this.leftCheck);
                            }
                            toggleToActiveThumb(t) {
                                "scroll" !== t &&
                                    ("clickPrev" == t &&
                                        (this.verticalCheck
                                            ? ((this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight), (this.scrollLeftPosition = 0))
                                            : ((this.scrollTopPosition = 0), (this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth))),
                                    "clickNext" == t &&
                                        (this.verticalCheck
                                            ? ((this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight), (this.scrollLeftPosition = 0))
                                            : ((this.scrollTopPosition = 0), (this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth))),
                                    this.thumbs.scrollTo({ top: this.scrollTopPosition, left: this.scrollLeftPosition, behavior: "smooth" }));
                            }
                            toggleArrows() {
                                (this.verticalCheck || (this.verticalAlignment && !this.verticalCheck)) && (this.arrowPrev.classList.toggle(Bc, this.topCheck), this.arrowNext.classList.toggle(Bc, this.bottomCheck)),
                                    (this.horizontalCheck || (!this.verticalAlignment && !this.horizontalCheck)) && (this.arrowPrev.classList.toggle(Bc, this.leftCheck), this.arrowNext.classList.toggle(Bc, this.rightCheck));
                            }
                            constructor(t) {
                                (this.section = t),
                                    (this.container = t.container),
                                    (this.slideshow = this.container.querySelector(Dc.productSlideshow)),
                                    (this.mobileStyle = this.slideshow.getAttribute(Dc.slideshowMobileStyle)),
                                    (this.desktopStyle = this.slideshow.getAttribute(Dc.slideshowDesktopStyle)),
                                    (this.arrowPrev = this.container.querySelector(Dc.arrowPrev)),
                                    (this.arrowNext = this.container.querySelector(Dc.arrowNext)),
                                    (this.leftThumbsHolder = this.container.querySelector(Dc.leftThumbsHolder)),
                                    (this.thumbWrapper = this.container.querySelector(Dc.productThumbs)),
                                    (this.thumbImages = this.container.querySelectorAll(Dc.thumbImage)),
                                    (this.loopVideo = "true" === this.container.getAttribute(Dc.loopVideo)),
                                    (this.verticalAlignment = !!this.container.querySelector(Dc.verticalAlignment)),
                                    (this.flkty = null),
                                    (this.thumbs = this.container.querySelector(Dc.productThumbs)),
                                    (this.currentSlide = null),
                                    this.init();
                            }
                        })(e)),
                        new (class {
                            listen() {
                                this.container.addEventListener("theme:variant:change", (t) => {
                                    t.detail.variant && ((this.variantImage = t.detail.variant.featured_image), this.filterImages());
                                });
                            }
                            filterImages() {
                                null !== this.variantImage && null !== this.variantImage.alt ? ((this.variantImageAlt = this.variantImage.alt.split("#")[1]), this.showImages()) : this.resetImages(), this.refreshSliders();
                            }
                            resetImages() {
                                this.thumbs.forEach((t) => t.classList.remove($d)), this.slides.forEach((t) => t.classList.remove($d));
                            }
                            showImages() {
                                this.thumbs.forEach((t) => {
                                    "" === t.getAttribute(Ad) || t.getAttribute(Ad) === this.variantImageAlt ? t.classList.remove($d) : t.classList.add($d);
                                }),
                                    this.slides.forEach((t) => {
                                        "" === t.getAttribute(Ad) || t.getAttribute(Ad) === this.variantImageAlt ? t.classList.remove($d) : t.classList.add($d);
                                    });
                            }
                            refreshSliders() {
                                if (null !== this.slider && this.slider.classList.contains(Hd)) {
                                    const e = t.data(this.slider);
                                    void 0 !== e && e.reloadCells();
                                }
                                if (null !== this.thumbSlider && this.thumbSlider.classList.contains(Hd)) {
                                    const t = h.data(this.thumbSlider);
                                    void 0 !== t && t.reloadCells();
                                }
                            }
                            constructor(t) {
                                (this.section = t),
                                    (this.container = t.container),
                                    (this.slider = this.container.querySelector(qd)),
                                    (this.thumbSlider = this.container.querySelector(Cd)),
                                    (this.thumbs = this.container.querySelectorAll(Pd)),
                                    (this.slides = this.container.querySelectorAll(xd)),
                                    (this.variantImage = null),
                                    this.listen();
                            }
                        })(e);
                    const i = this.container.querySelector(_d);
                    i && "" !== i.innerHTML
                        ? ((this.product = JSON.parse(i.innerHTML)),
                          (this.truncateElementHolder = this.container.querySelector(Md)),
                          (this.truncateElement = this.container.querySelector(`[${Wd}]`)),
                          (this.resizeEventTruncate = () => this.truncateText()),
                          this.init())
                        : console.error("Missing product JSON");
                }
            })(this);
        },
        onUnload() {
            "function" == typeof Od[this.id].unload && Od[this.id].unload();
        },
        onBlockSelect(t) {
            "function" == typeof Od[this.id].onBlockSelect && Od[this.id].onBlockSelect(t);
        },
        onBlockDeselect(t) {
            "function" == typeof Od[this.id].onBlockDeselect && Od[this.id].onBlockDeselect(t);
        },
    };
    Ze("product", [Nd, Gc, mr, Vn, md, xt]),
        customElements.get("product-form") || customElements.define("product-form", Vh),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("popout-select") || customElements.define("popout-select", Yo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr),
        customElements.get("share-button") || customElements.define("share-button", kd);
    const zd = "data-toggle-grid",
        Rd = "data-grid-large",
        jd = "data-grid-small",
        Vd = "is-active",
        Ud = window.theme.sizes.small;
    var Jd = {};
    const Kd = {
            onLoad() {
                Jd[this.id] = [];
                this.container.querySelectorAll(`[${zd}]`).forEach((t) => {
                    Jd[this.id].push(
                        new (class {
                            init() {
                                this.toggle.addEventListener("click", this.toggleFunction), document.addEventListener("theme:resize:width", this.toggleFunction), this.toggleEvent(!1);
                            }
                            unload() {
                                this.toggle.removeEventListener("click", this.toggleFunction), document.removeEventListener("theme:resize:width", this.toggleFunction);
                            }
                            toggleEvent(t = !0) {
                                const e = t && "click" === t.type,
                                    i = window.innerWidth >= Ud ? Rd : jd,
                                    s = this.container.querySelector(`[${i}]`),
                                    o = s.getAttribute(i),
                                    r = this.toggle.parentElement.querySelector(`[${zd}].${Vd}`);
                                let n = this.toggle.parentElement.querySelector(`[${zd}="${o}"]`);
                                e && ((n = this.toggle), s.setAttribute(i, this.value), window.lazySizes && window.lazySizes.autoSizer.checkElems()), r && r.classList.remove(Vd), n && n.classList.add(Vd);
                            }
                            constructor(t, e) {
                                (this.container = e || document), (this.toggle = t), (this.value = this.toggle.getAttribute(zd)), (this.toggleFunction = (t) => this.toggleEvent(t)), this.init();
                            }
                        })(t, this.container)
                    );
                });
            },
            onUnload: function () {
                Jd[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Yd = "data-sort-enabled",
        Gd = "[data-sort-link]",
        Xd = "[data-sort-button-text]",
        Qd = "data-value",
        Zd = "popout-list__item--current";
    var tu = "[data-tag-group]",
        eu = ".link--add",
        iu = ".link--remove",
        su = "data-swatch";
    Ze("collection", [
        {
            onLoad() {
                this.collection = new (class {
                    init() {
                        new (class {
                            init() {
                                this.sortLinks.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault(), this.sortingResults(t);
                                    });
                                });
                            }
                            sortingResults(t) {
                                const e = t.currentTarget,
                                    i = e.getAttribute(Qd),
                                    s = e.innerText;
                                (this.sortButtonText.innerText = s),
                                    this.sortButtonText.parentNode.dispatchEvent(new Event("click")),
                                    this.sort.querySelector(`.${Zd}`).classList.remove(Zd),
                                    e.parentNode.classList.add(Zd),
                                    this.sort.setAttribute(Yd, i),
                                    this.container.dispatchEvent(new CustomEvent("theme:form:filter", { bubbles: !0, detail: { params: i } }));
                            }
                            constructor(t) {
                                (this.container = t.container),
                                    (this.sort = this.container.querySelector(`[${Yd}]`)),
                                    (this.sortLinks = this.container.querySelectorAll(Gd)),
                                    (this.sortButtonText = this.container.querySelector(Xd)),
                                    this.sort && this.init();
                            }
                        })(this.section),
                            this.removeUnusableFilters();
                    }
                    removeUnusableFilters() {
                        const t = this.container.querySelectorAll(tu);
                        t.length > 0 &&
                            t.forEach((t) => {
                                const e = t.querySelector(eu),
                                    i = t.querySelector(iu);
                                e || i || Xc(t);
                            });
                    }
                    constructor(t) {
                        (this.section = t), (this.container = this.section.container), (this.swatches = this.container.querySelectorAll(`[${su}]`)), this.init();
                    }
                })(this);
            },
        },
        cc,
        gc,
        Kd,
        te,
        Vn,
        J,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", Yo),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Mo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr),
        Ze("collection-row", [te, J, ae]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Mo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr),
        Ze("collection-tabs", [md, Tl, te]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Mo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr);
    var ou = {};
    function ru(t) {
        return ou[t];
    }
    (ou.basic = []),
        (ou.light = [
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "on" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (ou.light_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }, { visibility: "off" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (ou.white_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#444444" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (ou.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (ou.dark_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (ou.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
            { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: !0 }, { weight: "7.15" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.allMaps = window.theme.allMaps || {});
    let nu = window.theme.allMaps;
    const au = "[data-map-container]",
        lu = "data-style",
        cu = "data-api-key",
        hu = "data-zoom",
        du = "data-address",
        uu = "data-latlong-correction",
        pu = "data-lat",
        mu = "data-long";
    const gu = {
        onLoad() {
            nu[this.id] = new (class {
                initMaps() {
                    Tt({ url: `https://maps.googleapis.com/maps/api/js?key=${this.key}` })
                        .then(() => {
                            return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long
                                ? new window.google.maps.LatLng(this.lat, this.long)
                                : ((t = this.address),
                                  new Promise((e, i) => {
                                      new window.google.maps.Geocoder().geocode({ address: t }, function (t, s) {
                                          if ("OK" == s) {
                                              var o = { lat: t[0].geometry.location.lat(), lng: t[0].geometry.location.lng() };
                                              e(o);
                                          } else i(s);
                                      });
                                  }));
                            var t;
                        })
                        .then((t) => {
                            var e = { zoom: parseInt(this.zoomString, 10), styles: ru(this.styleString), center: t, draggable: !0, clickableIcons: !1, scrollwheel: !1, zoomControl: !1, disableDefaultUI: !0 };
                            const i = (function (t, e) {
                                var i = new window.google.maps.Map(t, e),
                                    s = i.getCenter();
                                return (
                                    new window.google.maps.Marker({ map: i, position: s }),
                                    window.google.maps.event.addDomListener(window, "resize", function () {
                                        window.google.maps.event.trigger(i, "resize"), i.setCenter(s);
                                    }),
                                    i
                                );
                            })(this.mapWrap, e);
                            return i;
                        })
                        .then((t) => {
                            (this.map = t), (nu[this.id] = t);
                        })
                        .catch((t) => {
                            console.log("Failed to load Google Map"), console.log(t);
                        });
                }
                onUnload() {
                    void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.mapWrap = this.container.querySelector(au)),
                        (this.styleString = this.container.getAttribute(lu) || ""),
                        (this.key = this.container.getAttribute(cu)),
                        (this.zoomString = this.container.getAttribute(hu) || 14),
                        (this.address = this.container.getAttribute(du)),
                        (this.enableCorrection = this.container.getAttribute(uu)),
                        (this.lat = this.container.getAttribute(pu)),
                        (this.long = this.container.getAttribute(mu)),
                        this.key && this.initMaps();
                }
            })(this);
        },
        onUnload() {
            "function" == typeof nu[this.id].unload && nu[this.id].unload();
        },
    };
    Ze("section-map", gu), Ze("section-columns", [dl, ae]);
    const yu = "[data-related-section]",
        fu = "[data-grid-item]",
        wu = "[data-carousel]",
        bu = "data-limit",
        vu = "data-minimum",
        Su = "data-layout-desktop",
        Eu = "data-layout-tablet",
        Lu = "data-layout-mobile",
        Tu = "[data-recent-wrapper]",
        ku = "[data-recently-viewed-wrapper]",
        Au = "data-product-id";
    Ze("related", [
        {
            onLoad() {
                this.section = new (class {
                    init() {
                        const t = this.container.querySelector(yu);
                        if (!t) return;
                        const e = t.getAttribute(Au),
                            i = t.getAttribute(bu),
                            s = t.getAttribute(Su),
                            o = t.getAttribute(Eu),
                            r = t.getAttribute(Lu),
                            n = `${window.theme.routes.product_recommendations_url || "/recommendations/products/"}?section_id=related&limit=${i}&product_id=${e}`;
                        l.get(n)
                            .then((e) => {
                                const i = document.createElement("div");
                                i.innerHTML = e.data;
                                const n = i.querySelector(yu);
                                if (n.querySelector(fu)) {
                                    const e = n.innerHTML;
                                    (t.innerHTML = e),
                                        t.querySelector(wu).style.setProperty("--grid-large-items", s),
                                        t.querySelector(wu).style.setProperty("--grid-medium-items", o),
                                        t.querySelector(wu).style.setProperty("--grid-small-items", r),
                                        t.dispatchEvent(new CustomEvent("theme:related-products:added", { bubbles: !0 }));
                                } else t.dispatchEvent(new CustomEvent("theme:tabs:hide", { bubbles: !0 }));
                            })
                            .catch(function (t) {
                                console.warn(t);
                            });
                    }
                    recent() {
                        const t = this.container.querySelector(Tu),
                            e = this.container.querySelector(ku),
                            i = this.container.querySelectorAll(fu),
                            s = t.hasAttribute(vu) ? parseInt(t.getAttribute(vu)) : 4,
                            o = !e && i.length > 0,
                            r = e && i.length >= s;
                        (o || r) && t.dispatchEvent(new CustomEvent("theme:tabs:check", { bubbles: !0 }));
                    }
                    constructor(t) {
                        (this.section = t),
                            (this.container = t.container),
                            this.init(),
                            this.container.addEventListener("theme:recent-products:added", () => {
                                this.recent();
                            });
                    }
                })(this);
            },
        },
        md,
        dt,
    ]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Qt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Mo),
        customElements.get("upsell-product") || customElements.define("upsell-product", Nr);
    const qu = {
            ajaxDisable: "data-ajax-disable",
            shipping: "[data-shipping-estimate-form]",
            input: "[data-update-cart]",
            update: "[data-update-button]",
            bottom: "[data-cart-bottom]",
            upsellProduct: "[data-upsell-holder]",
            upsellButton: "[data-add-action-wrapper]",
        },
        Cu = "cart--dirty",
        Pu = "heart-beat",
        xu = {
            onLoad() {
                if ((this.container.querySelector(qu.shipping) && new rn(this), (this.disabled = "true" == this.container.getAttribute(qu.ajaxDisable)), this.disabled)) return void (this.cart = new $u(this));
                this.cart = new In(this);
                this.cart.init().then(() => {
                    this.cart.loadHTML();
                });
            },
        };
    let $u = class {
        initQuantity() {
            hn(this.container);
        }
        moveUpsell() {
            const t = this.container.querySelector(qu.bottom);
            t.insertBefore(this.upsellProduct, t.firstChild);
        }
        initInputs() {
            this.inputs.forEach((t) => {
                t.addEventListener(
                    "change",
                    function () {
                        this.updateBtn.classList.add(Cu),
                            this.updateBtn.classList.add(Pu),
                            setTimeout(
                                function () {
                                    this.updateBtn.classList.remove(Pu);
                                }.bind(this),
                                1300
                            );
                    }.bind(this)
                );
            });
        }
        constructor(t) {
            (this.section = t),
                (this.container = t.container),
                (this.inputs = this.container.querySelectorAll(qu.input)),
                (this.quantityWrappers = this.container.querySelectorAll(qu.qty)),
                (this.updateBtn = this.container.querySelector(qu.update)),
                (this.upsellProduct = this.container.querySelector(qu.upsellProduct)),
                this.initQuantity(),
                this.initInputs(),
                this.upsellProduct && this.moveUpsell();
        }
    };
    Ze("cart", [xu, Vn]), customElements.get("upsell-product") || customElements.define("upsell-product", Nr), Ze("accordion-single", Vn);
    const Hu = (t, e, i = null) => {
            (t.style.opacity = 0),
                (t.style.display = e || "block"),
                (function e() {
                    let s = parseFloat(t.style.opacity);
                    (s += 0.1) > 1 || ((t.style.opacity = s), requestAnimationFrame(e)), 1 === s && "function" == typeof i && i();
                })();
        },
        _u = (t, e = null) => {
            (t.style.opacity = 1),
                (function i() {
                    (t.style.opacity -= 0.1) < 0 ? (t.style.display = "none") : requestAnimationFrame(i), 0 === parseFloat(t.style.opacity) && "function" == typeof e && e();
                })();
        },
        Iu = "[data-tracking-consent]",
        Mu = "[data-confirm-cookies]",
        Du = "[data-close-modal]",
        Wu = "[data-popup-inner]",
        Bu = "[data-newsletter]",
        Fu = "[data-newsletter-holder]",
        Ou = "[data-newsletter-field]",
        Nu = "[data-newsletter-form]",
        zu = "[data-promo-text]",
        Ru = "data-popup-delay",
        ju = "data-cookie-name",
        Vu = "data-target-referrer",
        Uu = "has-value",
        Ju = "has-success",
        Ku = "desktop",
        Yu = "mobile";
    let Gu = {},
        Xu = class {
            write() {
                ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                    (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            read() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
                    return document.cookie
                        .split("; ")
                        .find((t) => t.startsWith(this.name))
                        .split("=")[1];
                }
                return !1;
            }
            destroy() {
                document.cookie.split("; ").find((t) => t.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            constructor(t, e) {
                (this.configuration = { expires: null, path: "/", domain: window.location.hostname }), (this.name = t), (this.value = e);
            }
        },
        Qu = class {
            always() {
                Hu(this.element);
            }
            delayed() {
                setTimeout(() => {
                    Hu(this.element);
                }, 1e4);
            }
            bottom() {
                window.addEventListener("scroll", () => {
                    window.scrollY + window.innerHeight >= document.body.clientHeight && Hu(this.element);
                });
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (t = setTimeout(() => {
                            (t = 0), Hu(this.element);
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            s();
                    };
                s();
            }
            constructor(t, e) {
                (this.element = e), (this.delay = t.getAttribute(Ru)), "always" === this.delay && this.always(), "delayed" === this.delay && this.delayed(), "bottom" === this.delay && this.bottom(), "idle" === this.delay && this.idle();
            }
        },
        Zu = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(Vu)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el);
            }
            constructor(t) {
                (this.el = t), (this.locationPath = location.href), this.el.hasAttribute(Vu) && this.init();
            }
        };
    Ze("popups", [
        {
            onLoad() {
                Gu[this.id] = [];
                this.container.querySelectorAll(Iu).forEach((t) => {
                    Gu[this.id].push(
                        new (class {
                            init() {
                                this.showPopup && Hu(this.modalInner), this.clickEvents();
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => _u(this.modalInner));
                                }),
                                    this.acceptButton.addEventListener("click", (t) => {
                                        t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => _u(this.modalInner));
                                    }),
                                    document.addEventListener("trackingConsentAccepted", function () {
                                        console.log("trackingConsentAccepted event fired");
                                    });
                            }
                            onBlockSelect(t) {
                                this.popup.contains(t.target) && this.showPopup && Hu(this.modalInner);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && _u(this.modalInner);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.modal = document.querySelector(Iu)),
                                    (this.modalInner = this.popup.querySelector(Wu)),
                                    (this.close = this.modal.querySelector(Du)),
                                    (this.acceptButton = this.modal.querySelector(Mu)),
                                    (this.enable = "true" === this.modal.getAttribute("data-enable")),
                                    (this.showPopup = !1),
                                    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                                        if (t) throw t;
                                        const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                            i = window.Shopify.customerPrivacy.getTrackingConsent();
                                        (this.showPopup = !e && "no_interaction" === i && this.enable), window.Shopify.designMode && (this.showPopup = !0), this.init();
                                    });
                            }
                        })(t)
                    );
                });
                this.container.querySelectorAll(Bu).forEach((t) => {
                    Gu[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (this.show(), this.form.classList.contains(Ju) && this.checkForSuccess());
                            }
                            show() {
                                window.Shopify.designMode ? Hu(this.popupInner) : new Qu(this.popup, this.popupInner), this.inputField(), this.closePopup();
                            }
                            checkForSuccess() {
                                Hu(this.popupInner), this.cookie.write();
                            }
                            closePopup() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), _u(this.popupInner), this.cookie.write();
                                });
                            }
                            inputField() {
                                this.newsletterField.addEventListener("input", () => {
                                    "" !== this.newsletterField.value && this.holder.classList.add(Uu, "" !== this.newsletterField.value);
                                }),
                                    this.newsletterField.addEventListener("focus", () => {
                                        "" !== this.newsletterField.value && this.holder.classList.add(Uu, "" !== this.newsletterField.value);
                                    }),
                                    this.newsletterField.addEventListener("focusout", () => {
                                        setTimeout(() => {
                                            this.holder.classList.remove(Uu);
                                        }, 2e3);
                                    });
                            }
                            onBlockSelect(t) {
                                this.popup.contains(t.target) && Hu(this.popupInner);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && _u(this.popupInner);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.popupInner = this.popup.querySelector(Wu)),
                                    (this.holder = this.popup.querySelector(Fu)),
                                    (this.close = this.popup.querySelector(Du)),
                                    (this.newsletterField = this.popup.querySelector(Ou)),
                                    (this.cookie = new Xu(this.popup.getAttribute(ju), "newsletter_is_closed")),
                                    (this.form = this.popup.querySelector(Nu)),
                                    (this.isTargeted = new Zu(this.popup)),
                                    this.init();
                            }
                        })(t)
                    );
                });
                this.container.querySelectorAll(zu).forEach((t) => {
                    Gu[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (window.Shopify.designMode ? Hu(this.popupInner) : new Qu(this.popup, this.popupInner), this.clickEvents());
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), _u(this.popupInner), this.cookie.write();
                                });
                            }
                            onBlockSelect(t) {
                                this.popup.classList.contains(Yu) && (this.hasDeviceClass = Yu),
                                    this.popup.classList.contains(Ku) && (this.hasDeviceClass = Ku),
                                    "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass),
                                    this.popup.contains(t.target) && Hu(this.popupInner);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && _u(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.popupInner = this.popup.querySelector(Wu)),
                                    (this.close = this.popup.querySelector(Du)),
                                    (this.cookie = new Xu(this.popup.getAttribute(ju), "user_has_closed")),
                                    (this.isTargeted = new Zu(this.popup)),
                                    (this.hasDeviceClass = ""),
                                    this.init();
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                Gu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Gu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        Ga,
    ]),
        Ze("tabs", md);
    const tp = "data-look-dot",
        ep = "data-products-holder",
        ip = "[data-carousel]",
        sp = "[data-button-close-holder]",
        op = "data-carousel-index",
        rp = "data-block-id",
        np = "button",
        ap = "is-active",
        lp = "is-expanded",
        cp = {};
    Ze("look", [
        {
            onLoad() {
                (cp[this.id] = []),
                    cp[this.id].push(
                        new (class {
                            init() {
                                (this.keyEvents = (t) => this.keyboardEventShowProductHolder(t)),
                                    (this.keyCloseEvent = (t) => this.hideProductsHolder(t)),
                                    (this.clickEventsDot = (t) => this.clickEventShowProductsHolder(t)),
                                    (this.clickEventToClose = (t) => this.clickEventCloseProductsHolder(t)),
                                    (this.toggleOnResize = (t) => A(this.onResize(t), 200)),
                                    this.initSlider(),
                                    this.addEvents();
                            }
                            initSlider() {
                                this.slider &&
                                    ((this.carousel = s.data(this.slider)),
                                    (this.carousel.options.wrapAround = !0),
                                    (this.carousel.options.freeScroll = !1),
                                    this.carousel.resize(),
                                    this.carousel.on("change", (t) => {
                                        (this.currentDot = this.container.querySelector(`[${tp}="${t}"]`)), this.currentDot.classList.add(ap), this.removeClassOnSiblingDots();
                                    }));
                            }
                            addEvents() {
                                this.dots.forEach((t) => {
                                    t.addEventListener("click", this.clickEventsDot), t.addEventListener("keyup", this.keyEvents);
                                }),
                                    document.addEventListener("keyup", this.keyCloseEvent),
                                    document.addEventListener("theme:resize", this.toggleOnResize),
                                    this.buttonClose && this.buttonClose.addEventListener("click", this.clickEventToClose);
                            }
                            showProductsHolder() {
                                const t = !this.productsHolder.classList.contains(lp);
                                this.currentDot.classList.toggle(ap),
                                    this.productsHolder.classList.toggle(lp, this.currentDot.classList.contains(ap)),
                                    this.currentDot.classList.contains(ap) && ((this.hasDefaultOpen = !0), this.carousel.selectCell(Number(this.currentDot.getAttribute(tp)), !0, t)),
                                    this.removeClassOnSiblingDots();
                            }
                            hideProductsHolder(t) {
                                t.which === window.theme.keyboardKeys.ESCAPE && (this.removeClasses(), ci(), this.currentDot.focus());
                            }
                            removeClasses() {
                                this.productsHolder.classList.remove(lp), this.currentDot.classList.remove(ap), (this.hasDefaultOpen = !1);
                            }
                            clickEventShowProductsHolder(t) {
                                (this.currentDot = t.currentTarget), this.showProductsHolder();
                            }
                            clickEventCloseProductsHolder() {
                                this.removeClasses();
                            }
                            keyboardEventShowProductHolder(t) {
                                (t.which !== window.theme.keyboardKeys.ENTER && t.which !== window.theme.keyboardKeys.SPACE) ||
                                    setTimeout(() => {
                                        const t = this.productsHolder.querySelector(np);
                                        li(this.productsHolder, { elementToFocus: t });
                                    }, 400);
                            }
                            onResize() {
                                this.currentDot &&
                                    (window.innerWidth < window.theme.sizes.medium
                                        ? (this.currentDot.classList.remove(ap), this.productsHolder.classList.remove(lp))
                                        : this.hasDefaultOpen && (this.currentDot.classList.add(ap), this.productsHolder.classList.add(lp)));
                            }
                            removeEvents() {
                                this.dots.forEach((t) => {
                                    t.removeEventListener("click", this.clickEventsDot), t.removeEventListener("keyup", this.keyEvents);
                                }),
                                    document.removeEventListener("keyup", this.keyCloseEvent),
                                    document.removeEventListener("theme:resize", this.toggleOnResize),
                                    this.buttonClose && this.buttonClose.removeEventListener("click", this.clickEventToClose);
                            }
                            removeClassOnSiblingDots() {
                                for (let t of this.currentDot.parentNode.children) t !== this.currentDot && t.classList.remove(ap);
                            }
                            onUnload() {
                                this.slider && this.carousel && this.carousel.destroy(), this.removeEvents();
                            }
                            onBlockSelect(t) {
                                if (this.slider && this.carousel) {
                                    const e = this.container.querySelector(`[${rp}="${t.detail.blockId}"]`);
                                    this.productsHolder.classList.add(lp), this.carousel.selectCell(Number(e.getAttribute(op)), !0, !0);
                                }
                            }
                            onBlockDeselect() {
                                window.innerWidth < window.theme.sizes.medium && (this.productsHolder.classList.remove(lp), this.currentDot.classList.remove(ap));
                            }
                            constructor(t) {
                                (this.section = t),
                                    (this.container = this.section.container),
                                    (this.dots = this.container.querySelectorAll(`[${tp}]`)),
                                    (this.productsHolder = this.container.querySelector(`[${ep}]`)),
                                    (this.slider = this.container.querySelector(ip)),
                                    (this.buttonClose = this.container.querySelector(sp)),
                                    (this.currentDot = this.container.querySelector(`[${tp}].${ap}`)),
                                    (this.hasDefaultOpen = !!this.currentDot),
                                    this.init();
                            }
                        })(this)
                    );
            },
            onUnload() {
                cp[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
            onBlockSelect(t) {
                cp[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                cp[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
    ]);
    const hp = (t, e = "", i) => ((i = i || document.createElement("div")).classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t));
    window.theme.settings.animate_scroll && i.init({ once: !0 }),
        document.addEventListener("DOMContentLoaded", function () {
            const t = document.querySelector("[data-header-height]");
            if (t) {
                const e = t.clientHeight || 0;
                document.documentElement.style.setProperty("--menu-height", `${e}px`);
            }
            ti("*"),
                window.theme.settings.animate_hover && document.body.classList.add("theme-animate-hover"),
                document.addEventListener("lazyloaded", function (t) {
                    const e = t.target.parentNode;
                    e.classList.contains("lazy-image") && (e.style.backgroundImage = "none");
                });
            document.querySelectorAll(".rte table").forEach((t) => {
                hp(t, "rte__table-wrapper");
            });
            document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t) => {
                hp(t, "rte__video-wrapper");
            }),
                document.addEventListener("mousedown", () => {
                    document.body.classList.remove("focus-enabled");
                }),
                document.addEventListener("keyup", (t) => {
                    9 === t.keyCode && document.body.classList.add("focus-enabled");
                }),
                window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
                (function (t) {
                    t = t || {};
                    var e = window.location.hash,
                        i = document.getElementById(e.slice(1));
                    if (i && t.ignore && i.matches(t.ignore)) return !1;
                    e && i && ri(i, t);
                })(),
                ni(),
                "scrollBehavior" in document.documentElement.style || Tt({ url: window.theme.assets.smoothscroll });
        });
})(
    themeVendor.FlickityFade,
    themeVendor.BodyScrollLock,
    themeVendor.AOS,
    themeVendor.Flickity,
    themeVendor.Sqrl,
    themeVendor.MicroModal,
    themeVendor.Rellax,
    themeVendor.themeCurrency,
    themeVendor.axios,
    themeVendor.themeAddresses,
    themeVendor.FlickitySync
);
//# sourceMappingURL=theme.js.map
console.log("here ... .");
var buybtn = document.querySelector(".product-grid-item__btn.buy_now");
buybtn.addEventListener("click", function (event) {
    window.location.href = event.target.getAttribute("data-href");
});
